<template>
  <div
    v-if="brandConfig && styles_loaded && brandConfig.brandCode"
    :style="new_style_variables"
    :class="brandConfig.brandCode"
  >
    <Header
      :key="updateHeader + header_menu.length"
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="basket_items_number"
      :logo_image="logo_image"
      @toggleBasket="toggleBasket"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandConfig.brandCode"
    ></Header>

    <!-- {{ lang.toUpperCase() }} -->

    <!-- <pre>{{header_menu}}</pre> -->

    <div class="page-bg" :style="set_style_variables">
      <div class="yourdetails-banner-container">
        <YourDetailsBanner
          :headline="getrans(banner_headline)"
          :headline_mobile="getrans(banner_headline_mobile)"
          :subheadline="''"
          edit-label="Edit"
          :key="lang + getrans(banner_headline_mobile)"
        >
        </YourDetailsBanner>
      </div>

      <div class="page-content">
        <div
          class="page-content__form"
          :class="showing_basket ? 'page-content__hide-section-on-mobile' : ''"
        >
          <template v-if="!new_login">
            <!-- Account Checkout Form -->
            <form @submit.prevent="proceedtocheckuser" v-if="loginistrue">
              <div
                class="page-content__form-details page-content__form--box-style"
              >
                <div class="fastest-option">
                  <h3 class="page-content__form-title">
                    {{ getrans("Account checkout") }}
                  </h3>
                  <div class="fastest-option__outer" :style="rectImage()">
                    <div class="fastest-option__inner">
                      {{ getrans("Fastest option!") }}
                    </div>
                  </div>
                </div>

                <p class="bolder-text">
                  {{
                    getrans(
                      "Make future bookings faster, view old bookings and manage new ones."
                    )
                  }}
                </p>
                <p class="standard-para">
                  {{
                    getrans(
                      "If you do not have an account we will create one for you. By selecting this option your data will be used for registration to our platform and you will have access to your booking history, personal data and booking information. Alternatively, if you do not wish to create an account please use the Guest Checkout option."
                    )
                  }}
                </p>

                <div class="block-wrap" style="width: 50%">
                  <div
                    class="block"
                    :class="`${
                      v$.emailid.$errors.length && emailid
                        ? 'form-group--error error'
                        : 'tick'
                    } ${emailid ? 'hasValue' : ''}`"
                  >
                    <input
                      type="text"
                      id="emailid"
                      v-model="emailid"
                      @input="
                        lowerCaseEmail(emailid);
                        v$.emailid.$touch();
                      "
                    />
                    <label for="emailid"
                      >{{ form_label("emailid") || getrans("Email Address") }}
                      <span class="form-mandatory">&nbsp;*</span></label
                    >
                  </div>
                </div>

                <div class="block-wrap" style="width: 50%">
                  <div class="block">
                    <div class="page-content__form-proceed">
                      <button type="submit" class="submit-checkout-now">
                        <i
                          v-if="emailid_loading"
                          class="fas fa-circle-notch fa-spin"
                        ></i>
                        {{ getrans("Checkout Now") }} >>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="block-wrap" style="width: 100%">
                  <p class="standard-para">
                    {{
                      getrans(
                        "We take your data privacy very seriously; you can delete your account at any time. Please note any existing guest bookings you have will be made available in the manage my booking area."
                      )
                    }}
                    {{
                      getrans(
                        "To learn more about how your data is collected and used, visit our"
                      )
                    }}
                    <a
                      target="_blank"
                      :href="
                        brandConfig?.links?.privacy ||
                        'https://www.hermesairports.com/privacy-notice'
                      "
                      >{{ getrans("Privacy Statement.") }}</a
                    >
                  </p>
                </div>

                <div style="clear: both"></div>
              </div>
            </form>

            <!-- Guest Checkout Form -->
            <form
              @submit.prevent="proceedtocheckuser_withoutotp"
              v-if="loginistrue"
            >
              <div class="page-content__form-details--guest">
                <h3 class="page-content__form-title">
                  {{ getrans("Guest checkout") }}
                </h3>

                <div class="block-wrap" style="width: 50%">
                  <div
                    class="block"
                    :class="`${
                      v$.emailid_wo.$error && emailid_wo
                        ? 'form-group--error error'
                        : 'tick'
                    } ${emailid_wo ? 'hasValue' : ''}`"
                  >
                    <input
                      type="text"
                      id="emailid_wo"
                      v-model="emailid_wo"
                      @change="v$.emailid_wo.$touch()"
                      @input="
                        lowerCaseEmail_wo(emailid_wo);
                        v$.emailid_wo.$touch();
                      "
                    />
                    <label for="emailid_wo"
                      >{{ form_label("emailid_wo") || getrans("Email Address") }}
                      <span class="form-mandatory">&nbsp;*</span></label
                    >
                  </div>
                </div>

                <div class="block-wrap" style="width: 100%">
                  <p class="standard-para">
                    {{
                      getrans(
                        "Please note: As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously."
                      )
                    }}&nbsp;
                    {{ getrans("To learn more, visit our") }}
                    <br />
                    <a
                      target="_blank"
                      :href="
                        brandConfig?.links?.privacy ||
                        'https://www.hermesairports.com/privacy-notice'
                      "
                      >{{ getrans("Privacy Notice") }}</a
                    >.
                  </p>
                </div>

                <div class="block-wrap" style="width: 50%">
                  <div class="block">
                    <div class="page-content__form-proceed guest-btn">
                      <button type="submit">
                        <i
                          v-if="emailid_loading"
                          class="fas fa-circle-notch fa-spin"
                        ></i>
                        {{ getrans("Guest Checkout") }}
                      </button>
                    </div>
                  </div>
                </div>
                <div style="clear: both"></div>
              </div>
            </form>

            <!-- OTP Choice Form (for brands with dual OTP) -->
            <form @submit.prevent="sendSelectedOTP" v-if="showOtpChoice">
              <div
                class="page-content__form-details page-content__form--box-style"
              >
                <h3 class="page-content__form-title">
                  {{ getrans("Choose how to receive your verification code") }}
                </h3>

                <div class="block-wrap" style="width: 100%">
                  <p>
                    {{
                      getrans(
                        "We can send your 6-digit verification code via email or SMS. Please choose your preferred method:"
                      )
                    }}
                  </p>
                </div>

                <div class="block-wrap" style="width: 50%">
                  <div class="block">
                    <div class="page-content__form-proceed">
                      <button
                        type="button"
                        @click="sendcodeoption('email')"
                        class="submit-checkout-now"
                      >
                        <i class="fas fa-envelope"></i>
                        {{ getrans("Send via Email") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="block-wrap"
                  style="width: 50%"
                  v-if="phonecode && mobilenumber"
                >
                  <div class="block">
                    <div class="page-content__form-proceed guest-btn">
                      <button type="button" @click="sendcodeoption('sms')">
                        <i class="fas fa-sms"></i>
                        {{ getrans("Send via SMS") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="block-wrap"
                  style="width: 100%"
                  v-if="!phonecode || !mobilenumber"
                >
                  <p class="standard-para">
                    {{
                      getrans(
                        "To receive SMS verification, please provide your phone number in the registration form."
                      )
                    }}
                  </p>
                </div>

                <div style="clear: both"></div>
              </div>
            </form>

            <!-- OTP Verification Form -->
            <form @submit.prevent="proceedtologinuser" v-if="passistrue">
              <div
                class="page-content__form-details page-content__form--box-style"
              >
                <h3 class="page-content__form-title">
                  {{
                    userexists
                      ? getrans("Verify Your Identity")
                      : getrans("Your details")
                  }}
                </h3>

                <h3 class="page-content__form-title">
                  <template v-if="otpMethod === 'sms'">
                    {{
                      getrans(
                        "We've sent your 6-digit verification code via SMS to"
                      )
                    }}
                    {{ phonecode }}{{ mobilenumber }}
                  </template>
                  <template v-else>
                    {{
                      getrans("We've sent your 6-digit verification code to")
                    }}
                    {{ emailid }}
                  </template>
                </h3>

                <div
                  v-if="brandConfig?.brandCode"
                  class="block-wrap"
                  style="width: 50%"
                >
                  <OTPInput v-on:opt_change="opt_change" :otpLength="6" />
                </div>

                <div
                  v-if="brandConfig?.brandCode"
                  class="block-wrap"
                  style="width: 50%"
                >
                  <div class="block">
                    <div class="page-content__form-proceed">
                      <button type="submit" class="submit-login">
                        <i
                          v-if="proceedtologinuser_loading"
                          class="fas fa-circle-notch fa-spin"
                        ></i>
                        {{ getrans("Verify Code") }}
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  v-if="brandConfig?.brandCode"
                  class="block-wrap"
                  style="width: 100%"
                >
                  <p>
                    <template v-if="otpMethod === 'sms'">
                      {{
                        getrans(
                          "Please check your mobile phone for the verification code."
                        )
                      }}
                    </template>
                    <template v-else>
                      {{
                        getrans(
                          "Please do not access your email in this tab, please leave this tab open as you check your email to retrieve the verification code."
                        )
                      }}
                    </template>
                    <br /><br />
                    {{ getrans("Didn't receive code?") }}
                    <a
                      href="javascript:;"
                      @click.stop="goto_page('/yourdetails.html')"
                      >{{ getrans("try again") }}</a
                    >
                    <template
                      v-if="
                        brandConfig.features?.otpChoice ||
                        brandConfig.features?.dualOtp
                      "
                    >
                      {{ getrans(" or ") }}
                      <a
                        href="javascript:;"
                        @click.stop="
                          showOtpChoice = true;
                          passistrue = false;
                        "
                        >{{ getrans("choose different method") }}</a
                      >
                    </template>
                  </p>
                </div>
                <div style="clear: both"></div>
              </div>
            </form>
          </template>

          <!-- Registration/Details Form -->
          <form
            @submit.prevent="submit"
            v-if="!payform && (new_login || registeristrue)"
            id="payment-process"
          >
            <div
              class="page-content__form-details page-content__form--box-style"
            >
              <div
                v-if="brandConfig.features?.bookingForOthers && userexists"
                class="block-wrap bookingfor-options"
                style="width: 100%"
              >
                <h3 class="page-content__form-title">
                  {{ getrans("Booking For") }}
                </h3>

                <!-- {{ item }} -->
                <div
                  class="input-checkbox"
                  style="z-index: 1"
                  v-for="item in bookingfor_options"
                  :key="item.value"
                >
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    :name="`bookingfor-${item.value}`"
                    :value="item.value"
                    :id="`bookingfor-${item.value}`"
                    @change="resetaddrfields($event)"
                  />
                  <div
                    :class="`custom-checkbox-style ${
                      bookingfor === item.value
                        ? 'custom-checkbox-style--checked'
                        : ''
                    }`"
                  ></div>
                  <label
                    :for="`bookingfor-${item.value}`"
                    style="pointer-events: all"
                  >
                    {{ getrans(item.text) }}
                    <!-- {{bookingfor}} {{item.value}} -->
                  </label>
                </div>
                <!-- <div
                  v-if="setbrandid"
                  class="block-wrap block-wrap-question-icon block-wrap-question-icon--in-title"
                  @click="info_your_details = !info_your_details"
                >
                  <i class="fa fa-question-circle"></i>
                </div> -->
              </div>

              <h3 class="page-content__form-title">
                {{ getrans(brandConfig?.yourDetailsHeading || "Your Details") }}
                <div
                  class="block-wrap block-wrap-question-icon block-wrap-question-icon--in-title"
                  @click="info_your_details = !info_your_details"
                >
                  <i class="fa fa-question-circle"></i>
                </div>
              </h3>

              <div
                v-if="info_your_details"
                class="block-wrap"
                style="width: 100%"
              >
                <div class="info-block">
                  <h4>
                    <i class="fa fa-question-circle"></i>
                    {{ getrans("Why do we need this information?") }}
                  </h4>
                  <p>
                    {{
                      getrans(
                        "The information requested on this form is required to process your booking. For more information, please visit our FAQ."
                      )
                    }}
                  </p>
                </div>
              </div>

              <!-- Email Display -->
              <template v-if="!new_login">
                <div
                  v-show="bookingfor === 'self'"
                  class="block-wrap"
                  style="width: 100%"
                >
                  <template v-if="is_guest === 'Y'">
                    <p>
                      {{ getrans("Email Address: ") }} <b>{{ email }}</b>
                    </p>
                    <br />
                  </template>
                  <template v-else>
                    <p>
                      {{ getrans("Account holder Email Address: ") }}
                      <b>{{ email }}</b>
                    </p>
                    <br />
                  </template>
                </div>
              </template>
              <template v-else>
                <div
                  v-show="setbrandid && bookingfor === 'self'"
                  class="block-wrap"
                  style="width: 100%"
                >
                  <div
                    class="block"
                    :class="`${
                      v$.emailid_wo.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${emailid_wo ? 'hasValue tick' : ''}`"
                  >
                    <input
                      type="text"
                      id="email"
                      v-model="emailid_wo"
                      @input="lowerCaseEmail_Confirm(emailid_wo)"
                      @change="proceedtocheckuser_withoutotp_new_flow"
                      :readonly="userexists"
                    />
                    <label for="email">
                      {{ form_label("email") || getrans("Email Address") }}
                      <span class="form-mandatory">&nbsp;*</span>
                    </label>
                  </div>
                </div>
              </template>

              <div
                v-if="setbrandid && bookingfor === 'other'"
                class="block-wrap"
                style="width: 100%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.oth_email.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${oth_email ? 'hasValue tick' : ''}`"
                >
                  <input
                    type="text"
                    id="oth_email"
                    v-model="oth_email"
                    @input="
                      lowerCaseEmail_Confirm_oth_email(oth_email);
                      v$.oth_email.$touch();
                    "
                  />
                  <label for="oth_email">
                    {{ form_label("oth_email") || getrans("Email Address for this booking") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <div
                v-if="brandConfig?.hasCompanyName"
                class="block-wrap"
                style="width: 100%"
              >
                <div
                  v-show="oth_email && !v$.oth_email.$errors.length"
                  class="input-checkbox"
                  :class="`${
                    email_consent_oth_email_selected_error
                      ? 'form-group--error error'
                      : ''
                  }`"
                >
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    name="email_consent_oth_email"
                    v-model="email_consent_oth_email"
                    value="0"
                    id="email_consent_oth_email"
                    @click="
                      email_consent_oth_email_selected = true;
                      email_consent_oth_email_selected_error = false;
                    "
                  />
                  <div
                    :class="`custom-checkbox-style ${
                      email_consent_oth_email &&
                      email_consent_oth_email_selected
                        ? 'custom-checkbox-style--checked'
                        : ''
                    }`"
                  ></div>
                  <label
                    for="email_consent_oth_email"
                    style="pointer-events: all"
                  >
                    Send booking confirmation email to{{
                      oth_email ? " " + oth_email : ""
                    }}.</label
                  >
                </div>

                <!-- other manage -->
                <div
                  v-show="oth_email && !v$.oth_email.$errors.length"
                  class="input-checkbox"
                  :class="`${
                    email_consent_oth_manage_selected_error
                      ? 'form-group--error error'
                      : ''
                  }`"
                >
                  <input
                    class="custom-checkbox"
                    type="checkbox"
                    name="email_consent_oth_manage"
                    v-model="email_consent_oth_manage"
                    value="0"
                    id="email_consent_oth_manage"
                    @click="
                      email_consent_oth_manage_selected = true;
                      email_consent_oth_manage_selected_error = false;
                    "
                  />
                  <div
                    :class="`custom-checkbox-style ${
                      email_consent_oth_manage &&
                      email_consent_oth_manage_selected
                        ? 'custom-checkbox-style--checked'
                        : ''
                    }`"
                  ></div>
                  <label
                    for="email_consent_oth_manage"
                    style="pointer-events: all"
                  >
                    Allow{{ oth_email ? " " + oth_email : "" }} to manage this
                    booking.</label
                  >
                  <br /><br />
                </div>
              </div>
              <div
                v-if="setbrandid"
                class="block-wrap"
                style="display: none; width: 50%"
              >
                <div
                  class="block"
                  :class="`${false ? 'form-group--error error' : 'tick'} ${
                    email && email !== email_confirm
                      ? 'form-group--error error'
                      : 'tick'
                  } 
                ${email_confirm ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="email_confirm"
                    v-model="email_confirm"
                    @input="lowerCaseEmail_Confirm(email_confirm)"
                    readonly
                  />
                  <label for="email_confirm">
                    {{ form_label("email_confirm") || getrans("Confirm Email Address") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>
              <div v-if="setbrandid && brandConfig?.hasCompanyName" class="block-wrap" style="width: 100%">
                <div
                  class="block"
                  :class="`${'tick'} ${companyname ? 'hasValue' : ''}`"
                >
                  <input type="text" id="companyname" v-model="companyname" />
                  <label for="companyname">
                    {{ form_label("companyname") || getrans("Company Name") }}
                  </label>
                </div>
              </div>

              <!-- Title Field (conditional based on brand) -->
              <div
                v-if="brandConfig?.hasTitle"
                class="block-wrap"
                style="width: 20%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.title.$errors.length ? 'form-group--error error' : 'tick'
                  } ${title ? 'hasValue' : ''}`"
                >
                  <select
                    class="styled_select"
                    v-model="title"
                    @change="v$.title.$touch()"
                  >
                    <option></option>
                    <option v-for="title in titles_list" :key="title">
                      {{ getrans(title) }}
                    </option>
                  </select>
                  <label for="title"
                    >{{ form_label("title") || getrans("Title")
                    }}<span v-if="v$.title.required" class="form-mandatory"
                      >&nbsp;*</span
                    ></label
                  >
                </div>
              </div>

              <!-- Name Fields -->
              <div
                v-if="brandConfig?.brandCode"
                class="block-wrap"
                :style="brandConfig?.hasTitle ? `width: 30%` : `width: 50%`"
              >
                <div
                  class="block"
                  :class="`${
                    v$.firstname.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${firstname ? 'hasValue tick' : ''}`"
                >
                  <input
                    type="text"
                    id="firstname"
                    v-model="firstname"
                    @input="v$.firstname.$touch()"
                  />
                  <label for="firstname"
                    >{{ form_label("firstname") || getrans("First Name")
                    }}<span v-if="v$.firstname.required" class="form-mandatory"
                      >&nbsp;*</span
                    ></label
                  >
                </div>
              </div>

              <div
                v-if="brandConfig?.brandCode"
                class="block-wrap"
                style="width: 50%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.surname.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${surname ? 'hasValue tick' : ''}`"
                >
                  <input
                    type="text"
                    id="lastname"
                    v-model="surname"
                    @input="v$.surname.$touch()"
                  />
                  <label for="surname"
                    >{{ form_label("surname") || getrans("Last Name")
                    }}<span v-if="v$.surname.required" class="form-mandatory"
                      >&nbsp;*</span
                    ></label
                  >
                </div>
              </div>

              <!-- Phone Fields -->
              <div class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.mobilenumber.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${mobilenumber ? 'hasValue' : ''}`"
                >
                  <div class="block-mobile-code-combined">
                    <div class="phonecode-just-number">
                      <select
                        id="phonecode"
                        v-model="phonecode"
                        class="styled_select"
                        autocomplete="off"
                        @change="v$.phonecode.$touch()"
                      >
                        <option
                          v-for="code in brandConfig?.phoneCodes || []"
                          :key="code"
                          :value="code"
                        >
                          {{ getCountryName(code) }} ({{ code }})
                        </option>
                      </select>
                      <div id="just-phonecode" :key="phonecode">
                        {{ phonecode }}
                      </div>
                    </div>
                    <input
                      type="text"
                      id="mobilenumber"
                      v-model="mobilenumber"
                      @input="v$.mobilenumber.$touch()"
                    />
                  </div>
                  <label for="mobilenumber">
                    {{ form_label("mobilenumber") || getrans("Mobile Number") }}
                    <span class="form-mandatory">&nbsp;*</span>
                  </label>
                </div>
              </div>

              <template v-if="brandConfig.features?.googleAddressFinder">
                <div v-if="setbrandid" class="block-wrap" style="width: 100%">
                  <div
                    class="block"
                    :class="`${
                      v$.postcode.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${postcode ? 'hasValue' : ''}`"
                  >
                    <GMapAutocomplete
                      :placeholder="getrans('Please start typing your Address')"
                      class="googleAddressFinder"
                      @place_changed="setPlace"
                    >
                    </GMapAutocomplete>
                    <label for="state">
                      {{ form_label("state") || getrans("Address") }}
                      <!-- {{ getrans("Vehicle Registration") }} No Spaces Please -->
                      <span v-if="v$.postcode.required" class="form-mandatory"
                        >&nbsp;*</span
                      >
                    </label>
                  </div>
                </div>
              </template>

              <div v-if="brandConfig?.hasCountry" class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.country.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${country ? 'hasValue' : ''}`"
                >
                  <select
                    id="country"
                    class="styled_select"
                    autocomplete="off"
                    v-model="country"
                  >
                    <option value></option>
                    <option
                      v-for="item in countryList"
                      :key="item.code"
                      :value="item.code"
                    >
                      {{ getrans(item.name) }}
                    </option>
                  </select>
                  <label for="country">
                    {{ form_label("country") || getrans("Country") }}
                    <span class="form-mandatory">*</span>
                  </label>
                </div>
              </div>

              <!-- Address Fields (conditional based on brand) -->
              <template
                v-if="showaddressfields && brandConfig?.hasAddressLines"
              >
                <div class="block-wrap" style="width: 50%">
                  <div
                    class="block"
                    :class="`${
                      v$.address.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${address ? 'hasValue' : ''}`"
                  >
                    <input
                      type="text"
                      id="address"
                      v-model="address"
                      @input="v$.address.$touch()"
                    />
                    <label for="address"
                      >{{ form_label("address") || getrans("Address Line 1")
                      }}<span v-if="v$.address.required" class="form-mandatory"
                        >&nbsp;*</span
                      ></label
                    >
                  </div>
                </div>

                <div
                  class="block-wrap"
                  style="width: 50%"
                  v-if="brandConfig?.hasAddressLine_2"
                >
                  <div
                    class="block"
                    :class="`${
                      v$.address_line_2.$errors.length
                        ? 'form-group--error error'
                        : 'tick'
                    } ${address_line_2 ? 'tick hasValue' : ''}`"
                  >
                    <input
                      type="text"
                      id="address_line_2"
                      v-model="address_line_2"
                      @input="v$.address_line_2.$touch()"
                    />
                    <label for="address_line_2"
                      >{{ form_label("address_line_2") || getrans("Address Line 2")
                      }}<span
                        v-if="v$.address_line_2.required"
                        class="form-mandatory"
                        >&nbsp;*</span
                      ></label
                    >
                  </div>
                </div>
              </template>

              <!-- City/Town -->
              <div
                class="block-wrap"
                style="width: 50%"
                v-if="brandConfig?.hasTownField"
              >
                <div
                  class="block"
                  :class="`${
                    v$.town.$errors.length ? 'form-group--error error' : 'tick'
                  } ${town ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="town"
                    v-model="town"
                    @input="v$.town.$touch()"
                  />
                  <label for="town">
                    <template v-if="brandConfig?.phoneCodeOrder === 'US_FIRST'">
                      {{ form_label("town") || getrans("City") }}
                    </template>
                    <template v-else> {{ form_label("town") || getrans("Town") }} </template>
                    <span v-if="v$.town.required" class="form-mandatory"
                      >&nbsp;*</span
                    ></label
                  >
                </div>
              </div>

              <!-- State Field (conditional) -->
              <div
                v-if="brandConfig?.hasStateField"
                class="block-wrap"
                style="width: 50%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.state.$errors.length ? 'form-group--error error' : 'tick'
                  } ${state ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="state"
                    v-model="state"
                    @input="v$.state.$touch()"
                  />
                  <label for="state">
                    <template v-if="brandConfig?.brandCode === 'SV1'">{{
                      form_label("state_province") || getrans("Province or State")
                    }}</template>
                    <template v-else>{{ form_label("state_province") || getrans("State") }}</template>
                    <span v-if="v$.state.required" class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <!-- Postcode/Zipcode -->
              <div class="block-wrap" style="width: 50%">
                <div
                  class="block"
                  :class="`${
                    v$.postcode.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${postcode ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="postcode"
                    v-model="postcode"
                    @blur="
                      brandConfig?.features?.postcodeFind
                        ? findyouraddress()
                        : null
                    "
                    @input="v$.postcode.$touch()"
                  />
                  <label for="postcode">
                    <template
                      v-if="
                        brandConfig?.phoneCodeOrder === 'US_FIRST' ||
                        brandConfig?.brandCode === 'SV1'
                      "
                    >
                      {{ form_label("postcode") || getrans("Postal Code or Zip Code") }}
                    </template>
                    <template v-else> {{ form_label("postcode") || getrans("Postcode") }} </template
                    ><span v-if="v$.postcode.required" class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <!-- Postcode Finder Button (UK brands) -->
              <div
                v-if="country == 'GB' && brandConfig?.features?.postcodeFind"
                class="block-wrap"
                style="width: 50%"
              >
                <div class="block find-address-btn">
                  <button
                    type="button"
                    @click="findyouraddress()"
                    class="page-content__form-btn postcode-finder-btn"
                  >
                    <i class="fas fa-search"></i>
                    {{ getrans("Find Address") }}
                  </button>
                </div>
              </div>

              <div
                v-if="
                  cartitem &&
                  cartitem.carpark_name &&
                  brandConfig?.vrnNotSeperate
                "
                class="block-wrap"
                style="width: 50%"
              >
                <div
                  class="block"
                  :class="`${
                    v$.vehicle_vrn.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${vehicle_vrn ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="vehicle_vrn"
                    v-model="vehicle_vrn"
                    @input="
                      [upperCaseVRN(vehicle_vrn), v$.vehicle_vrn.$touch()]
                    "
                    @blur="
                      brandConfig?.features?.vrnFind ? findyourvrn() : null
                    "
                  />
                  <label for="vehicle_vrn">
                    <template v-if="brandConfig?.brandCode === 'DRW'">
                      {{ form_label("vehicle_vrn") || getrans("Licence Plate") }}
                    </template>
                    <template v-else>
                      {{
                        getrans(brandConfig?.vrnLabel) ||
                        form_label("vehicle_vrn") || getrans("Vehicle Registration")
                      }}
                    </template>
                    <span v-if="v$.vehicle_vrn.required" class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <div style="clear: both"></div>
            </div>

            <!-- Vehicle Registration Section -->
            <div
              v-if="
                cartitem &&
                cartitem.carpark_name &&
                !brandConfig?.vrnNotSeperate
              "
              class="page-content__form--box-style"
            >
              <h3 class="page-content__form-title">
                {{
                  getrans(
                    brandConfig?.vehicleDetailsHeading ||
                      "For Parking Reservation: Vehicle Details"
                  )
                }}
              </h3>

              <div class="block-wrap" style="width: 66%">
                <div
                  class="block"
                  :class="`${
                    v$.vehicle_vrn.$errors.length
                      ? 'form-group--error error'
                      : 'tick'
                  } ${vehicle_vrn ? 'hasValue' : ''}`"
                >
                  <input
                    type="text"
                    id="vehicle_vrn"
                    v-model="vehicle_vrn"
                    @input="
                      [upperCaseVRN(vehicle_vrn), v$.vehicle_vrn.$touch()]
                    "
                    @blur="
                      brandConfig?.features?.vrnFind ? findyourvrn() : null
                    "
                  />
                  <label for="vehicle_vrn">
                    <template v-if="brandConfig?.brandCode === 'DRW'">
                      {{ form_label("vehicle_vrn") || getrans("Licence Plate") }}
                    </template>
                    <template v-else>
                      {{
                        getrans(brandConfig?.vrnLabel) ||
                        form_label("vehicle_vrn") || 
                        getrans("Vehicle Registration")
                      }}
                    </template>
                    <span v-if="v$.vehicle_vrn.required" class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <!-- VRN Lookup Button (UK brands) -->
              <div
                v-if="brandConfig?.features?.vrnFind"
                class="block-wrap"
                style="width: 66%"
              >
                <div class="block">
                  <button
                    type="button"
                    @click="findyourvrn()"
                    class="page-content__form-btn vrn-lookup-btn"
                  >
                    <i
                      v-if="loading_vrn"
                      class="fas fa-circle-notch fa-spin"
                    ></i>
                    <i v-else class="fas fa-car"></i>
                    {{ getrans("Lookup Vehicle") }}
                  </button>
                </div>


                <div v-if="showvrnfields">
                  <div class="block-wrap" style="width: 100%">
                    <div
                      style="margin-bottom: 8px"
                      class="block"
                      :class="`${vrn_color ? 'hasValue' : ''}`"
                    >
                      <input type="text" id="vrn_color" v-model="vrn_color" />
                      <label for="vrn_color">
                        {{ form_label("vrn_color") || getrans("Primary Colour") }}
                      </label>
                    </div>
                  </div>

                  <div class="block-wrap" style="width: 100%">
                    <div
                      style="margin-bottom: 8px"
                      class="block"
                      :class="`${vrn_make ? 'hasValue' : ''}`"
                    >
                      <input type="text" id="vrn_make" v-model="vrn_make" />
                      <label for="vrn_make">
                        {{ form_label("vrn_make") || getrans("Make") }}
                      </label>
                    </div>
                  </div>
                  <div class="block-wrap" style="width: 100%">
                    <div
                      style="margin-bottom: 8px"
                      class="block"
                      :class="`${vrn_model ? 'hasValue' : ''}`"
                    >
                      <input type="text" id="vrn_model" v-model="vrn_model" />
                      <label for="vrn_model">
                        {{ form_label("vrn_model") || getrans("Model") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- VRN Validation Message (HER brand) -->
              <div
                v-if="brandConfig?.brandCode === 'HER'"
                class="block-wrap"
                style="width: 100%"
              >
                <p class="vrn-validation-message">
                  {{
                    getrans(
                      "Please enter your vehicle registration number without spaces or special characters."
                    )
                  }}
                </p>
              </div>

              <div style="clear: both"></div>
            </div>

            <!-- Fasttrack customers section -->
            <div
              class="page-content__form--box-style"
              v-if="
                fasttrack_cartitem &&
                showForm &&
                fasttrack_passengers_ADL.length > 0
              "
            >
              <h3 class="page-content__form-title">
                {{ getrans("Fast Track Passengers") }}
                <div
                  class="block-wrap block-wrap-question-icon block-wrap-question-icon--in-title"
                  @click="
                    info_block_fastrack_passengers =
                      !info_block_fastrack_passengers
                  "
                >
                  <i class="fa fa-question-circle"></i>
                </div>
              </h3>

              <div
                v-if="info_block_fastrack_passengers"
                class="block-wrap"
                style="width: 100%"
              >
                <div class="info-block">
                  <h4>
                    <i class="fa fa-question-circle"></i>
                    {{ getrans("Why do we need this information?") }}
                  </h4>
                  <p>
                    {{
                      getrans(
                        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos id, cupiditate velit molestias, nemo doloremque cumque architecto sapiente quia deleniti dolore iste suscipit! Magni velit perspiciatis necessitatibus illo ipsam mollitia."
                      )
                    }}
                  </p>
                </div>
              </div>

              <div style="clear: both"></div>

              <!-- loop over Adults -->

              <div
                class="passenger-block"
                v-if="fasttrack_passengers_ADL.length > 0"
              >
                <p>
                  {{
                    getrans(
                      "Please enter the details below exactly as on your passport/ticket."
                    )
                  }}
                </p>

                <div
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_ADL"
                  :key="'ADL-' + i"
                >
                  <span class="inputs-heading">
                    {{ getrans("Passenger") }} {{ i + 1 }}
                  </span>
                  <div class="block-wrap" style="width: 20%">
                    <div
                      class="block"
                      :class="`
                          ${
                            fasttrack_passengers_ADL_errors[i] &&
                            fasttrack_passengers_ADL_errors[i].title
                              ? 'form-group--error error'
                              : 'tick'
                          }
                          ${fasttrack_passenger.title ? 'hasValue' : ''}
                        `"
                    >
                      <select
                        class="styled_select"
                        v-model="fasttrack_passenger.title"
                        @blur="validateFasttrackPassengerTitle(i)"
                        @change="
                          fasttrack_passengers_ADL_errors[i].title = false;
                          validateFasttrackPassengerTitle(i);
                        "
                      >
                        <option value=""></option>
                        <option v-for="title in titles_list" :key="title">
                          {{ getrans(title) }}
                        </option>
                      </select>
                      <label for="title">
                        {{ form_label("title") || getrans("Title") }}
                        <span class="form-mandatory">*</span>
                      </label>
                      <div
                        v-if="
                          fasttrack_passengers_ADL_errors[i] &&
                          fasttrack_passengers_ADL_errors[i].title
                        "
                        class="error-message"
                      >
                        {{ getrans("Title") }}&nbsp;{{ getrans("required") }}
                      </div>
                    </div>
                  </div>

                  <div class="block-wrap" style="width: 30%">
                    <div
                      class="block"
                      :class="`${
                        fasttrack_passengers_ADL_errors[i] &&
                        fasttrack_passengers_ADL_errors[i].firstname
                          ? 'form-group--error error'
                          : 'tick'
                      } ${fasttrack_passenger.firstname ? 'hasValue' : ''}`"
                    >
                      <input
                        type="text"
                        id="firstname"
                        v-model="fasttrack_passenger.firstname"
                        @input="
                          fasttrack_passengers_ADL_errors[i].firstname = false;
                          validateFasttrackPassengerFirstname(i);
                        "
                      />
                      <label for="firstname">
                        {{ form_label("firstname") || getrans("First Name") }}
                        <span class="form-mandatory">*</span>
                      </label>
                      <div
                        v-if="
                          fasttrack_passengers_ADL_errors[i] &&
                          fasttrack_passengers_ADL_errors[i].firstname
                        "
                        class="error-message"
                      >
                        {{ getrans("First Name") }}&nbsp;{{
                          getrans("required")
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`${
                        fasttrack_passengers_ADL_errors[i] &&
                        fasttrack_passengers_ADL_errors[i].surname
                          ? 'form-group--error error'
                          : 'tick'
                      } ${fasttrack_passenger.surname ? 'hasValue' : ''}`"
                    >
                      <input
                        type="text"
                        id="lastname"
                        v-model="fasttrack_passenger.surname"
                        @input="
                          fasttrack_passengers_ADL_errors[i].surname = false;
                          validateFasttrackPassengerSurname(i);
                        "
                      />
                      <label for="surname">
                        {{ form_label("surname") || getrans("Surname") }}
                        <span class="form-mandatory">*</span>
                      </label>
                      <div
                        v-if="
                          fasttrack_passengers_ADL_errors[i] &&
                          fasttrack_passengers_ADL_errors[i].surname
                        "
                        class="error-message"
                      >
                        {{ getrans("Surname") }}&nbsp;{{ getrans("required") }}
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both"></div>
              </div>

              <!-- loop over Children -->

              <template v-if="fasttrack_passengers_CHD.length > 0">
                <div
                  class="passenger-block"
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_CHD"
                  :key="'CHD-' + i"
                >
                  <div>
                    <span class="inputs-heading"> Child {{ i + 1 }} </span>

                    <div class="block-wrap" style="width: 20%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.title ? 'hasValue' : ''
                        }`"
                      >
                        <select
                          class="styled_select"
                          v-model="fasttrack_passenger.title"
                        >
                          <option></option>
                          <option v-for="title in titles_list" :key="title">
                            {{ getrans(title) }}
                          </option>
                        </select>
                        <label for="title">
                          {{ form_label("title") || getrans("Title") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 30%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.firstname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="firstname"
                          v-model="fasttrack_passenger.firstname"
                        />
                        <label for="firstname">
                          {{ form_label("firstname") || getrans("First Name") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 50%">
                      <div
                        class="block"
                        :class="` ${
                          fasttrack_passenger.surname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="lastname"
                          v-model="fasttrack_passenger.surname"
                        />
                        <label for="surname">
                          {{ form_label("surname") || getrans("Surname") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both"></div>
              </template>

              <!-- loop over Infant -->

              <template v-if="fasttrack_passengers_INF.length > 0">
                <div
                  class="passenger-block"
                  v-for="(fasttrack_passenger, i) in fasttrack_passengers_INF"
                  :key="'INF-' + i"
                >
                  <div>
                    <span class="inputs-heading"> Infant {{ i + 1 }} </span>

                    <div class="block-wrap" style="width: 20%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.title ? 'hasValue' : ''
                        }`"
                      >
                        <select
                          class="styled_select"
                          v-model="fasttrack_passenger.title"
                        >
                          <option></option>
                          <option v-for="title in titles_list" :key="title">
                            {{ getrans(title) }}
                          </option>
                        </select>
                        <label for="title">
                          {{ form_label("title") || getrans("Title") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 30%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.firstname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="firstname"
                          v-model="fasttrack_passenger.firstname"
                        />
                        <label for="firstname">
                          {{ form_label("firstname") || getrans("First Name") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>

                    <div class="block-wrap" style="width: 50%">
                      <div
                        class="block"
                        :class="`${
                          fasttrack_passenger.surname ? 'hasValue tick' : ''
                        }`"
                      >
                        <input
                          type="text"
                          id="lastname"
                          v-model="fasttrack_passenger.surname"
                        />
                        <label for="surname">
                          {{ form_label("surname") || getrans("Surname") }}
                          <span class="form-mandatory">*</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="clear: both"></div>
              </template>

              <div style="clear: both"></div>
            </div>

            <!-- {{ checkout_blocks }} -->
            <template
              v-if="
                coach_cartitem &&
                coach_cartitem.coach_selected &&
                coach_cartitem.coach_selected.length > 0
              "
            >
              <div class="page-content__form--box-style coach_driver">
                <template
                  v-for="(coach_driver, i) in coach_cartitem.coach_selected"
                  :key="'COA-' + i"
                >
                  <!-- {{coach_driver}} -->
                  <h3 class="page-content__form-title">
                    {{ getrans(`Coach`) }} {{ i + 1 }}
                    {{ getrans(`details`) }} -
                    {{ coach_driver.split("~")[1].replace(" - ", " to ") }}
                  </h3>
                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`
                      ${
                        coach_errors && !coach_drivers.name[i]
                          ? 'form-group--error error'
                          : 'tick'
                      } 
                      ${coach_drivers.name[i] ? 'hasValue' : ''}
                      `"
                    >
                      <input
                        type="text"
                        :id="'coach_drivers_name_' + i"
                        v-model="coach_drivers.name[i]"
                      />
                      <label :for="'coach_drivers_name_' + i">
                        {{ getrans("Driver Name") }}
                        <span class="form-mandatory">*</span>
                      </label>
                    </div>
                  </div>
                  <div class="block-wrap" style="width: 50%">
                    <div
                      class="block"
                      :class="`${
                        coach_errors && !coach_drivers.vrn[i]
                          ? 'form-group--error error'
                          : 'tick'
                      } ${coach_drivers.vrn[i] ? 'hasValue' : ''}`"
                    >
                      <input
                        type="text"
                        :id="'coach_drivers_vrn_' + i"
                        v-model="coach_drivers.vrn[i]"
                      />
                      <label :for="'coach_drivers_vrn_' + i">
                        {{ getrans("Coach Registration") }}
                        <span class="form-mandatory">*</span>
                      </label>
                    </div>
                  </div>
                  <div style="clear: both"></div>
                </template>
              </div>
            </template>

            <template
              v-if="
                checkout_blocks &&
                checkout_blocks.travel_details_active === 'yes'
              "
            >
              <!-- Destination Block -->
              <div class="page-content__form--box-style travel_details">
                <!-- <h3 class="page-content__form-title">
                  {{ getrans(checkout_blocks.travel_details_label) }}
                  <div
                    v-if="checkout_blocks.travel_details_info"
                    class="block-wrap block-wrap-question-icon block-wrap-question-icon--in-title"
                    @click="
                      info_block_travel_details = !info_block_travel_details
                    "
                  >
                    <i class="fa fa-question-circle"></i>
                  </div>
                </h3> -->

                <!-- {{ airlines_list }} -->

                <div
                  v-if="info_block_travel_details"
                  class="block-wrap"
                  style="width: 100%"
                >
                  <div class="info-block">
                    <h4>
                      <i class="fa fa-question-circle"></i>
                      {{ getrans("Why do we need this information?") }}
                    </h4>
                    <p>
                      {{ getrans(checkout_blocks.travel_details_info) }}
                    </p>
                  </div>
                </div>
                <div class="checkout-block">
                  <div>
                    <!-- -------------------- -->

                    <div
                      class="block-wrap"
                      style="width: 50%"
                      v-if="checkout_blocks.destinations_active === 'yes'"
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.destination.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${destination ? 'hasValue' : ''}`"
                      >
                        <select class="styled_select" v-model="destination">
                          <option></option>
                          <option
                            v-for="destination in destinations_list"
                            :key="destination"
                            :value="destination"
                          >
                            {{ getrans(destination) }}
                          </option>
                        </select>
                        <label for="title">
                          {{ getrans(checkout_blocks.destinations_label) }}
                          <span
                            v-if="
                              checkout_blocks.destinations_mandatory === 'yes'
                            "
                            class="form-mandatory"
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <!-- Purpose of Travel - Dropdown for FMM -->
                    <div
                      class="block-wrap"
                      style="width: 50%"
                      v-if="
                        checkout_blocks.reason_for_travel_active === 'yes' &&
                        setbrandid === 'FMM'
                      "
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.reason.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${reason ? 'hasValue' : ''}`"
                      >
                        <select
                          class="styled_select"
                          v-model="reason"
                          @change="v$.reason.$touch()"
                        >
                          <option value=""></option>
                          <option
                            v-for="reason_item in reasons_list"
                            :key="reason_item"
                            :value="reason_item"
                          >
                            {{ getrans(reason_item) }}
                          </option>
                        </select>
                        <label for="reason">
                          {{ form_label("reason") || getrans("Purpose of Travel") }}
                          <span
                            v-if="
                              checkout_blocks.reason_for_travel_mandatory ===
                              'yes'
                            "
                            class="form-mandatory"
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <!-- Purpose of Travel - Checkboxes for other brands -->
                    <div
                      class="block-wrap bookingfor-options"
                      style="width: 100%"
                      :class="
                        v$.reason.$errors.length ? 'form-group--error error' : ''
                      "
                      v-if="
                        checkout_blocks.reason_for_travel_active === 'yes' &&
                        setbrandid !== 'FMM'
                      "
                    >
                      <h3
                        :class="`page-content__form-title ${
                          v$.reason.$errors.length ? 'form-group--error error' : ''
                        }`"
                        :style="v$.reason.$errors.length ? 'color: #ff3b30;' : ''"
                        style="white-space: nowrap"
                      >
                        {{ getrans("Purpose of Travel") }}
                        <span
                          v-if="
                            checkout_blocks.reason_for_travel_mandatory ===
                            'yes'
                          "
                          class="form-mandatory"
                          :style="
                            v$.reason.$errors.length
                              ? 'margin-left: 0.25rem; color: #ff3b30;'
                              : 'margin-left: 0.25rem;'
                          "
                          >*</span
                        >
                      </h3>
                      <!-- {{reasons_list}} -->
                      <!-- {{ item }} -->
                      <div
                        class="input-checkbox"
                        v-for="reason_item in reasons_list"
                        :key="reason_item"
                      >
                        <input
                          class="custom-checkbox"
                          type="checkbox"
                          :key="reason_item"
                          :value="reason_item"
                          :name="`reasonfor-${reason_item}`"
                          :id="`reasonfor-${reason_item}`"
                          @change="
                            reason === reason_item
                              ? (reason = '')
                              : (reason = reason_item);
                            v$.reason.$touch();
                          "
                        />
                        <div
                          :class="`custom-checkbox-style ${
                            reason === reason_item
                              ? 'custom-checkbox-style--checked'
                              : ''
                          }`"
                        ></div>
                        <label
                          :for="`reasonfor-${reason_item}`"
                          style="pointer-events: all"
                        >
                          {{ getrans(reason_item) }}
                          <!-- {{bookingfor}} {{item.value}} -->
                        </label>
                      </div>
                    </div>

                  

                    <!-- -------------------- -->
                    <div
                      class="block-wrap"
                      style="width: 50%"
                      v-if="checkout_blocks.select_airline_active === 'yes'"
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.select_airline.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${select_airline ? 'hasValue' : ''}`"
                      >
                        <select class="styled_select" v-model="select_airline">
                          <option></option>
                          <option
                            v-for="airline in airlines_list"
                            :key="airline"
                            :value="airline"
                          >
                            {{ getrans(airline) }}
                          </option>
                        </select>
                        <label for="title">
                          {{ getrans(checkout_blocks.select_airline_label) }}
                          <span
                            class="form-mandatory"
                            v-if="
                              checkout_blocks.select_airline_mandatory === 'yes'
                            "
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <div
                      v-if="checkout_blocks.airline_number_active === 'yes'"
                      class="block-wrap"
                      style="width: 50%"
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.airline_number.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${airline_number ? 'hasValue tick' : ''}`"
                      >
                        <input
                          type="text"
                          id="airline_number"
                          v-model="airline_number"
                        />
                        <label for="airline_number">
                          {{ getrans(checkout_blocks.airline_number_label) }}
                          <span
                            class="form-mandatory"
                            v-if="
                              checkout_blocks.airline_number_mandatory === 'yes'
                            "
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <!-- -------------------- -->

                    <!-- {{{ "brandslug": "AIR", "destinations_label": "destination label 2", "destinations_info": "", "destinations_active": "yes", "reason_for_travel_label": "reason label", "reason_for_travel_info": "", "reason_for_travel_active": "yes", "select_airline_label": "airline label", "airline_number_label": "Airline Number", "select_airline_info": "", "select_airline_active": "yes", "airline_number_active": "yes", "store_card_label": "card label", "store_card_info": "", "store_card_active": "no", "outbound_flight_info": "", "outbound_flight_label": "Outbound Flight Number", "outbound_flight_active": "yes", "inbound_flight_label": "Inbound Flight Number", "inbound_flight_info": "", "inbound_flight_active": "yes", "psp_label": "", "psp_info": "", "psp_active": "no", "destinations_mandatory": "yes", "airline_number_mandatory": "yes", "reason_for_travel_mandatory": "yes", "select_airline_mandatory": "yes", "store_card_text_yes": "Store%252525252525252520Card", "store_card_text_no": "Do%252525252525252520Not%252525252525252520St", "store_card_mandatory": "no", "outbound_flight_mandatory": "yes", "inbound_flight_mandatory": "yes", "psp_mandatory": "no"
                    }}} -->

                    <div
                      v-if="checkout_blocks.outbound_flight_active === 'yes'"
                      class="block-wrap"
                      style="width: 50%"
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.outbound_flight_number.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${outbound_flight_number ? 'hasValue tick' : ''}`"
                      >
                        <input
                          type="text"
                          id="airline_number"
                          v-model="outbound_flight_number"
                        />
                        <label for="airline_number">
                          {{ getrans(checkout_blocks.outbound_flight_label) }}
                          <span
                            class="form-mandatory"
                            v-if="
                              checkout_blocks.outbound_flight_mandatory ===
                              'yes'
                            "
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <!-- -------------------- -->
                    <div
                      v-if="checkout_blocks.inbound_flight_active === 'yes'"
                      class="block-wrap"
                      style="width: 50%"
                    >
                      <div
                        class="block"
                        :class="`${
                          v$.inbound_flight_number.$errors.length
                            ? 'form-group--error error'
                            : 'tick'
                        } ${inbound_flight_number ? 'hasValue tick' : ''}`"
                      >
                        <input
                          type="text"
                          id="airline_number"
                          v-model="inbound_flight_number"
                        />
                        <label for="airline_number">
                          {{ getrans(checkout_blocks.inbound_flight_label) }}
                          <span
                            class="form-mandatory"
                            v-if="
                              checkout_blocks.inbound_flight_mandatory === 'yes'
                            "
                            >&nbsp;*</span
                          >
                        </label>
                      </div>
                    </div>

                    <!-- -------------------- -->

                    <!-- -------------------- -->

                    <!-- -------------------- -->

                    <!-- -------------------- -->
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>

              <!-- Store Card Block -->
              <div
                class="page-content__form--box-style"
                v-if="false && checkout_blocks.store_card_active === 'yes'"
              >
                <h3 class="page-content__form-title">
                  {{ getrans(checkout_blocks.store_card_label) }}
                  <div
                    class="block-wrap block-wrap-question-icon block-wrap-question-icon--in-title"
                    @click="info_block_store_card = !info_block_store_card"
                  >
                    <i class="fa fa-question-circle"></i>
                  </div>
                </h3>
                <div
                  v-if="info_block_store_card"
                  class="block-wrap"
                  style="width: 100%"
                >
                  <div class="info-block">
                    <h4>
                      <i class="fa fa-question-circle"></i>
                      {{ getrans("Why do we need this information?") }}
                    </h4>
                    <p>
                      {{ getrans(checkout_blocks.store_card_info) }}
                    </p>
                  </div>
                </div>
                <div class="checkout-block">
                  <div>
                    <div class="block-wrap" style="width: 100%">
                      <div class="input-checkbox">
                        <input
                          class="custom-checkbox"
                          type="checkbox"
                          name="store_card_yes"
                          v-model="store_card"
                          value="0"
                          id="store_card_yes"
                          :disabled="store_card"
                          @click="
                            store_card_selected = true;
                            store_card_selected_error = false;
                          "
                        />
                        <div
                          :class="`custom-checkbox-style ${
                            store_card && store_card_selected
                              ? 'custom-checkbox-style--checked'
                              : ''
                          }`"
                        ></div>
                        <label for="store_card_yes" style="pointer-events: all">
                          {{
                            getrans(
                              checkout_blocks.store_card_text_yes ||
                                "set in admin"
                            )
                          }}
                        </label>
                      </div>
                    </div>

                    <div
                      class="block-wrap"
                      style="width: 100%; margin-bottom: 1rem"
                    >
                      <div
                        class="input-checkbox"
                        :class="`${
                          store_card_selected_error
                            ? 'form-group--error error'
                            : ''
                        }`"
                      >
                        <input
                          class="custom-checkbox"
                          type="checkbox"
                          name="store_card_no"
                          v-model="store_card"
                          value="0"
                          id="store_card_no"
                          :disabled="!store_card && store_card === 0"
                          @click="
                            store_card_selected = true;
                            store_card = 0;
                            store_card_selected_error = false;
                          "
                        />
                        <div
                          :class="`custom-checkbox-style ${
                            !store_card && store_card_selected
                              ? 'custom-checkbox-style--checked'
                              : ''
                          }`"
                        ></div>
                        <label for="store_card_no" style="pointer-events: all">
                          {{
                            getrans(
                              checkout_blocks.store_card_text_no ||
                                "set in admin"
                            )
                          }}</label
                        >
                      </div>
                    </div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
            </template>

            <!-- Alternative Terms & Conditions section -->

            <div
              v-if="marketingConfig && marketingConfig.alternativeTerms"
              class="page-content__form-marketing page-content__form--box-style"
            >
              <h3
                v-if="marketingConfig.alternativeTerms.title"
                class="page-content__form-title"
              >
                {{ getrans(marketingConfig.alternativeTerms.title) }}
              </h3>
              <h3 v-else class="page-content__form-title">
                {{ getrans("Terms & Conditions and Exclusive Offers") }}
              </h3>

              <p
                v-if="marketingConfig.alternativeTerms.paragraph"
                v-html="
                  getrans(marketingConfig.alternativeTerms.paragraph)
                    .replace(
                      '{termsUrl}',
                      `<a href='${
                        marketingConfig.alternativeTerms.termsUrl
                      }' target='_blank'>${getrans(
                        marketingConfig.alternativeTerms.termsUrlText ||
                          'Terms & Conditions'
                      )}</a>`
                    )
                    .replace(
                      '{privacyUrl}',
                      `<a href='${
                        marketingConfig.alternativeTerms.privacyUrl
                      }' target='_blank'>${getrans(
                        marketingConfig.alternativeTerms.privacyUrlText ||
                          'Privacy Policy'
                      )}</a>`
                    )
                "
              ></p>

              <div
                class="block-wrap block-wrap-checkbox-spacing"
                style="width: 100%"
              >
                <div
                  v-if="marketingConfig.alternativeTerms.label"
                  class="input-checkbox"
                  :class="`${
                    v$.term_condition.$errors.length
                      ? 'form-group--error error'
                      : ''
                  }`"
                >
                  <input
                    class="checkmark-style"
                    type="checkbox"
                    name="term_condition"
                    v-model="term_condition"
                    value="0"
                    id="term_condition"
                    @input="v$.term_condition.$touch()"
                  />
                  <!-- <div
                    :class="`custom-checkbox-style ${
                      term_condition ? 'custom-checkbox-style--checked' : ''
                    }`"
                  ></div> -->
                  <label for="term_condition" style="pointer-events: all">
                    <span v-if="marketingConfig.alternativeTerms.label">
                      <span
                        v-html="
                          getrans(marketingConfig.alternativeTerms.label)
                            .replace(
                              '{termsLabelUrl}',
                              `<a href='${
                                marketingConfig.alternativeTerms.termsLabelUrl
                              }' target='_blank'>${getrans(
                                marketingConfig.alternativeTerms
                                  .termsLabelUrlText || 'Terms & Conditions'
                              )}</a>`
                            )
                            .replace(
                              '{privacyLabelUrl}',
                              `<a href='${
                                marketingConfig.alternativeTerms.privacyLabelUrl
                              }' target='_blank'>${getrans(
                                marketingConfig.alternativeTerms
                                  .privacyLabelUrlText || 'Privacy Policy'
                              )}</a>`
                            )
                        "
                      >
                      </span>
                    </span>
                    <span v-else>
                      {{
                        getrans(
                          "I have read and agree to the Terms & Conditions and Privacy Policy."
                        )
                      }}
                    </span>
                    <span
                      v-if="v$.term_condition.required"
                      class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>
              <div style="clear: both"></div>
            </div>

            <!-- Terms & Conditions with Brand-Specific Variants -->
            <div
              class="page-content__form-marketing page-content__form--box-style"
              v-if="
                (marketingConfig &&
                  marketingConfig.alternativeTerms &&
                  email_consent_exists &&
                  email_consent_exists.toString() == 'false') ||
                !(marketingConfig && marketingConfig.alternativeTerms) ||
                !email_consent_exists
              "
            >
              <h3
                v-if="marketingConfig && marketingConfig.title"
                class="page-content__form-title"
              >
                {{ getrans(marketingConfig.title) }}
              </h3>
              <h3 v-else class="page-content__form-title">
                {{ getrans("Terms & Conditions and Exclusive Offers") }}
              </h3>

              <p
                v-if="marketingConfig && marketingConfig.paragraph"
                v-html="getrans(marketingConfig.paragraph)"
              ></p>
              <br />

              <div
                v-if="!userexists"
                class="block-wrap block-wrap-checkbox-box"
                style="width: 100%; margin-bottom: 1rem"
              >
                <h3
                  class="page-content__form-title"
                  style="padding-bottom: 0rem"
                >
                  {{
                    getrans(
                      marketingConfig?.createAccount?.title ||
                        "Create an account for fast checkout & self-serve changes"
                    )
                  }}
                </h3>
                <div class="input-checkbox" :class="``">
                  <input
                    class="checkmark-style"
                    type="checkbox"
                    name="create_account"
                    v-model="create_account"
                    value="0"
                    id="create_account"
                  />
                  <label for="create_account" style="pointer-events: all">
                    <span
                      style="white-space: pre-line"
                      v-html="marketingConfig_createAccount_section"
                    ></span>
                  </label>
                </div>
              </div>

              <div
                class="block-wrap block-wrap-checkbox-spacing"
                style="width: 100%"
              >
                <div
                  v-if="marketingConfig && marketingConfig.terms"
                  class="input-checkbox"
                  :class="`${
                    v$.term_condition.$errors.length
                      ? 'form-group--error error'
                      : ''
                  }`"
                >
                  <input
                    class="checkmark-style"
                    type="checkbox"
                    name="term_condition"
                    v-model="term_condition"
                    value="0"
                    id="term_condition"
                    @input="v$.term_condition.$touch()"
                  />
                  <!-- <div
                    :class="`custom-checkbox-style ${
                      term_condition ? 'custom-checkbox-style--checked' : ''
                    }`"
                  ></div> -->
                  <label for="term_condition" style="pointer-events: all">
                    <span v-if="marketingConfig && marketingConfig.terms">
                      <span
                        v-html="
                          getrans(marketingConfig.terms.textKey)
                            .replace(
                              '{termsUrl}',
                              `<a href='${
                                marketingConfig.terms.termsUrl
                              }' target='_blank'>${getrans(
                                marketingConfig.terms.termsUrlText ||
                                  'Terms & Conditions'
                              )}</a>`
                            )
                            .replace(
                              '{privacyUrl}',
                              `<a href='${
                                marketingConfig.terms.privacyUrl
                              }' target='_blank'>${getrans(
                                marketingConfig.terms.privacyUrlText ||
                                  'Privacy Policy'
                              )}</a>`
                            )
                        "
                      >
                      </span>
                    </span>
                    <span v-else>
                      {{
                        getrans(
                          "I have read and agree to the Terms & Conditions and Privacy Policy."
                        )
                      }}
                    </span>
                    <span
                      v-if="v$.term_condition.required"
                      class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <div
                class="block-wrap block-wrap-checkbox-spacing"
                style="width: 100%"
              >
                <div
                  v-if="
                    marketingConfig &&
                    marketingConfig.privacy &&
                    marketingConfig.privacy.textKey
                  "
                  class="input-checkbox"
                  style="width: 100%; margin-bottom: 2rem"
                  :class="`${
                    v$.privacy_accept.$errors.length
                      ? 'form-group--error error'
                      : ''
                  }`"
                >
                  <input
                    class="checkmark-style"
                    type="checkbox"
                    name="privacy_accept"
                    v-model="privacy_accept"
                    value="0"
                    id="privacy_accept"
                    @input="v$.privacy_accept.$touch()"
                  />
                  <!-- <div
                  :class="`custom-checkbox-style ${
                    privacy_accept ? 'custom-checkbox-style--checked' : ''
                  }`"
                ></div> -->
                  <label for="privacy_accept" style="pointer-events: all">
                    <span v-if="marketingConfig && marketingConfig.privacy">
                      <span
                        v-html="
                          getrans(marketingConfig.privacy.textKey).replace(
                            '{privacyUrl}',
                            marketingConfig_privacy_privacyUrl
                          )
                        "
                      >
                      </span>
                    </span>
                    <span v-else>
                      {{ getrans("Yes, I have read and agree to the") }}
                      <a target="_blank" :href="privacy_policy_link">
                        {{ getrans("privacy policy") }}
                      </a>
                    </span>
                    <span
                      v-if="v$.privacy_accept.required"
                      class="form-mandatory"
                      >&nbsp;*</span
                    >
                  </label>
                </div>
              </div>

              <!-- {{marketingConfig.marketing.consentType}} -->
              <!-- Email Consent -->

              <!-- try this later 
               v-if="!email_consent_exists || (email_consent_exists && email_consent_exists.toString() == 'false')"
              -->

              <div
                class="block-wrap block-wrap-checkbox-spacing"
                style="width: 100%"
              >
                <div
                  v-if="marketingConfig && marketingConfig.marketing"
                  class="input-checkbox"
                  :class="`${
                    v$.email_consent.$errors.length
                      ? 'form-group--error error'
                      : ''
                  }`"
                  :style="
                    marketingConfig &&
                    marketingConfig.marketing &&
                    marketingConfig.marketing.consentType === 'dual'
                      ? 'flex-direction: column;'
                      : ''
                  "
                >
                  <template
                    v-if="
                      marketingConfig &&
                      marketingConfig.marketing &&
                      marketingConfig.marketing.consentType === 'dual'
                    "
                  >
                    <span
                      v-html="
                        getrans(
                          marketingConfig && marketingConfig.marketing
                            ? marketingConfig.marketing.textKey
                            : ''
                        ).replace(
                          '{marketingUrl}',
                          (marketingConfig && marketingConfig.marketing
                            ? marketingConfig.marketing.marketingUrl
                            : '') || ''
                        )
                      "
                    ></span>

                    <div 
                      class="input-checkbox"
                      :class="`${
                        email_consent_selected_error
                          ? 'form-group--error error'
                          : ''
                      }`">
                      <input
                        class="custom-checkbox"
                        type="checkbox"
                        name="email_consent"
                        v-model="email_consent"
                        value="0"
                        id="email_consent"
                        :disabled="email_consent === !0"
                        @click="
                          email_consent_selected = true;
                          email_consent_selected_error = false;
                        "
                      />
                      <div
                        :class="`custom-checkbox-style ${
                          email_consent && email_consent_selected
                            ? 'custom-checkbox-style--checked'
                            : ''
                        }`"
                      ></div>
                      <label for="email_consent" style="pointer-events: all">
                        <span
                          v-html="
                            getrans(
                              marketingConfig && marketingConfig.marketing
                                ? marketingConfig.marketing.textKeyAgree
                                : ''
                            )
                          "
                        ></span>
                      </label>
                    </div>

                    <div
                      class="input-checkbox"
                      :class="`${
                        email_consent_selected_error
                          ? 'form-group--error error'
                          : ''
                      }`"
                    >
                      <input
                        class="custom-checkbox"
                        type="checkbox"
                        name="email_consent"
                        v-model="email_consent"
                        value="0"
                        id="email_dont_consent"
                        :disabled="!email_consent && email_consent === 0"
                        @click="
                          email_consent = 0;
                          email_consent_selected = true;
                          email_consent_selected_error = false;
                        "
                      />
                      <div
                        :class="`custom-checkbox-style ${
                          !email_consent && email_consent_selected
                            ? 'custom-checkbox-style--checked'
                            : ''
                        }`"
                      ></div>
                      <label
                        for="email_dont_consent"
                        style="pointer-events: all"
                      >
                        <span
                          v-html="
                            getrans(
                              marketingConfig && marketingConfig.marketing
                                ? marketingConfig.marketing.textKeyDisagree
                                : ''
                            )
                          "
                        ></span>
                      </label>
                    </div>

                    <p
                      v-if="email_consent_selected_error"
                      class="form-group--error error"
                    >
                      <label>{{ getrans("Please select an option.") }}</label>
                    </p>
                    <p>
                      <span
                        v-html="
                          (marketingConfig && marketingConfig.marketing
                            ? marketingConfig.marketing.infoText
                            : ''
                          ).replace(
                            '{privacyUrl}',
                            marketingConfig && marketingConfig.marketing
                              ? marketingConfig.marketing.privacyUrl
                              : ''
                          )
                        "
                      ></span>
                    </p>
                  </template>

                  <template v-else>
                    <div class="input-checkbox">
                      <input
                        class="checkmark-style"
                        type="checkbox"
                        name="email_consent"
                        v-model="email_consent"
                        value="0"
                        id="email_consent"
                        @input="v$.email_consent.$touch()"
                      />
                      <!-- <div
          :class="`custom-checkbox-style ${
            email_consent ? 'custom-checkbox-style--checked' : ''
          }`"
        ></div> -->
                      <label for="email_consent" style="pointer-events: all">
                        <span
                          v-if="marketingConfig && marketingConfig.marketing"
                        >
                          <span
                            v-html="
                              getrans(
                                marketingConfig.marketing.textKey
                              ).replace(
                                '{marketingUrl}',
                                marketingConfig.marketing.marketingUrl || ''
                              )
                            "
                          >
                          </span>
                        </span>
                        <span v-else>
                          {{
                            getrans(
                              "I consent to receive communications and exclusive offers."
                            )
                          }}
                        </span>
                        <span
                          v-if="v$.email_consent.required"
                          class="form-mandatory"
                          >&nbsp;*</span
                        >
                      </label>
                    </div>
                  </template>
                </div>
              </div>

              <!-- Remember Device (supported brands) -->
              <div
                v-if="brandConfig?.features?.rememberDevice && userexists"
                class="block-wrap block-wrap-checkbox-spacing"
                style="width: 100%"
              >
                <div class="input-checkbox">
                  <input
                    class="checkmark-style"
                    type="checkbox"
                    name="remember_device"
                    v-model="remember_device"
                    value="0"
                    id="remember_device"
                    @change="
                      remember_device &&
                        handleRememberDevice(getLocalData('uuid'))
                    "
                  />
                  <!-- <div
                    :class="`custom-checkbox-style ${
                      remember_device ? 'custom-checkbox-style--checked' : ''
                    }`"
                  ></div> -->
                  <label for="remember_device" style="pointer-events: all">
                    {{
                      form_label("remember_device") || getrans("Remember this device for faster future logins")
                    }}
                  </label>
                </div>
              </div>

              <div style="clear: both"></div>
            </div>

            <!-- Continue Button -->
            <div class="page-content__form-proceed">
              <template
                v-if="
                  marketingConfig &&
                  marketingConfig.continue &&
                  marketingConfig.continue.preParagraph
                "
              >
                <p v-html="getrans(marketingConfig.continue.preParagraph)"></p>
              </template>

              <button type="submit">
                <i
                  v-if="loading_proceed"
                  class="fas fa-circle-notch fa-spin"
                ></i>
                <i v-else class="fa fa-lock"></i>
                &nbsp;
                <template
                  v-if="
                    marketingConfig &&
                    marketingConfig.continue &&
                    marketingConfig.continue.buttonText
                  "
                >
                  {{ getrans(marketingConfig.continue.buttonText) }}
                </template>
                <template v-else>
                  {{ getrans("Continue") }}
                </template>
              </button>
            </div>
          </form>
          <!-- PSP Payment Form -->
          <div
            id="psp-form"
            class="page-content__form-marketing page-content__form--box-style windcave-box-style"
            v-show="payform"
          >
            <div id="windcave-embedded"></div>
            <div id="nab-checkout"></div>
            <div id="nab-payment"></div>
            <div id="stripe-embedded-checkout"></div>
          </div>
          <div class="bank-cards" style="margin-top: 1rem">
            <img
              v-for="card in cardImages"
              :key="card"
              :src="require(`@/assets/images/cards/${card}`)"
              :alt="card.replace('.png', '').replace('.svg', '')"
            />
          </div>
          <div v-html="formdata_payform"></div>
        </div>

        <!-- Basket Section -->
        <div
          class="page-content__basket"
          v-if="cartloaded"
          :class="showing_basket ? '' : 'page-content__hide-section-on-mobile'"
        >
          <div
            class="page-content__basket-subtotal page-content__basket--box-style"
          >
            <span class="page-content__form-title"
              >{{
                brandConfig?.basketLabel
                  ? getrans(brandConfig?.basketLabel)
                  : getrans("Cart Subtotal")
              }}:</span
            >
            <span
              class="page-content__form-title page-content__form-title--price"
            >
              {{
                currency_formatter(
                  formatPrice(
                    finaltotalvalue !== undefined
                      ? finaltotalvalue
                      : cartitem.price || 0
                  )
                )
              }}
            </span>
            <button style="width: 100%" @click="toggleBasket()">
              {{ getrans("Click to proceed") }}
            </button>
          </div>

          <BasketItem
            v-if="!payform"
            v-on:finaltotalvalueChange="finaltotalvalueChange"
            v-on:basketItemsNumber="basketItemsNumber"
            :prop_parking_cartitem="cartitem"
            :item_price="cartitem ? cartitem.price : undefined"
            :item_title="cartitem ? cartitem.carpark_name : undefined"
            :item_start_date="
              cartitem ? formatDatedmy(cartitem.valid_from) : undefined
            "
            :item_start_time="cartitem ? cartitem.start_time : undefined"
            :item_end_date="
              cartitem ? formatDatedmy(cartitem.valid_till) : undefined
            "
            :item_end_time="cartitem ? cartitem.end_time : undefined"
            :prop_fasttrack_cartitem="fasttrack_cartitem"
            :remove_fasttrack_cartitem="update_fasttrack_cartitem"
            :prop_lounge_cartitem="lounge_cartitem"
            :remove_lounge_cartitem="update_lounge_cartitem"
            :update_cart_items="update_cart_items"
            :prop_coach_cartitem="
              coach_cartitem && coach_cartitem.product_name
                ? coach_cartitem
                : null
            "
            :remove_coach_cartitem="update_coach_cartitem"
            :lang="lang.toUpperCase()"
            :translations="translations"
            :brandSlug="brandConfig?.brandCode || setbrandid"
            @debug="console.log('BasketItem debug:', $event)"
          />
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <!-- <div class="faq-section">
      <div class="faq-section-title">
        <h3 class="faq-title">
          {{ getrans("Frequently asked questions...") }}
        </h3>
      </div>
      <div class="faq-section-inner">
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("What is an access code (OTP)?") }}
          </h4>
          <p>
            {{
              getrans(
                "OTP stands for One Time Passcode and is a single use, 6-digit access code which replaces a traditional password."
              )
            }}
          </p>
          <h4 class="faq-title">
            {{ getrans("How do I get my code?") }}
          </h4>
          <p>
            {{
              getrans(
                "You will receive your 6-digit access code (OTP) via email. Simply copy and paste the code into the required field to proceed with your booking and/or log in to your account."
              )
            }}
          </p>
        </div>
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("Why not passwords?") }}
          </h4>
          <p>
            {{
              getrans(
                "Your security is our biggest priority and unfortunately, passwords are not always secure enough to keep intruders at bay, which is why we take extra measures to improve account security. Our system is 100% password free. Not only does this mean you won't need to remember a password, but you also don't need to worry about the security of your personal information."
              )
            }}
          </p>
        </div>
        <div class="faq-section-inner-block">
          <h4 class="faq-title">
            {{ getrans("How long will my code work?") }}
          </h4>
          <p>
            {{
              getrans(
                "Your 6-digit access code (OTP) is valid for 15 minutes and can only be used once. Our system creates a new and random access code each time you make a booking or log into your account."
              )
            }}
          </p>
        </div>
      </div>
    </div> -->

    <!-- Dynamic Footer Component -->
    <component
      :is="brandConfig?.footerComponent || 'Footer'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandConfig?.brandCode"
    />

    <Cookies
      :brandSlug="brandConfig?.brandCode || setbrandid"
      :translations="translations"
    />
  </div>
</template>

<script>
import { getBrandConfig } from "@/utils/brandConfig.js";
import {
  getStylesConfig,
  getBrandStyleVariables,
} from "../../utils/brandConfig";
import apiProxy from "../../services/apiProxy.js";
import md5 from "js-md5";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import FooterNWI from "../../components/FooterNWI.vue";
import FooterPIT from "../../components/FooterPIT.vue";
import YourDetailsBanner from "../../components/YourDetailsBanner.vue";
import BasketItem from "../../components/BasketItem.vue";
import OTPInput from "../../components/OTPInput.vue";
import Cookies from "../../components/Cookies.vue";
import { set_style_vars } from "@/modules/set_style_vars";
import brandValidations from "@/brand/brand.validations.js";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import { normalizeBrandId } from '@/modules/brandId';
import { isDataLayerBrand } from "@/utils/datalayer";
import brandAirlines from "@/brand/brand.airlines.js";
import brandDestinations from "../../brand/brand.destinations.js";
import brandCards from "@/brand/brand.card_images.js";
import countryConfig from "@/brand/brand.country.js";
import brandTitles from "@/brand/brand.titles.js";

// Global EncryptStorage initialization
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});

import brandMarketing from "@/brand/brand.marketing.js";

import { debugMethods } from "./debug-methods.js";
// Required for LAX Windcave PSP
const crypto = require("crypto");

import { loadTranslations as loadTranslationsModule } from "../../modules/loadTranslations";

import form_labels from "@/brand/brand.details_form_labels.js";

import { required, requiredIf } from "@vuelidate/validators";

export default {
  name: "YourDetailsUnified",
  components: {
    Header,
    Footer,
    FooterNWI,
    FooterPIT,
    YourDetailsBanner,
    BasketItem,
    OTPInput,
    Cookies,
  },
  errorCaptured(err, instance, info) {
    console.error("🚨 ERROR BOUNDARY: Component error captured:", {
      error: err,
      instance: instance?.$options?.name || "Unknown",
      info,
      stack: err.stack,
    });
    if (err.message?.includes("emitsOptions")) {
      console.error("🚨 EMITS OPTIONS ERROR DETECTED:", {
        componentName: instance?.$options?.name,
        componentProps: instance?.$props,
        componentEmits: instance?.$options?.emits,
        errorMessage: err.message,
      });
    }
    return false;
  },

  data() {
    return {
      sessionRestoreInProgress: false,
      userLoginInProgress: false,
      showForm: true,
      marketingConfig: undefined,
      v$: useVuelidate(),
      formdata_payform: "",
      coach_drivers: { name: [], vrn: [] },
      coach_errors: false,

      brandConfig: null,
      styles_loaded: false,
      setbrandid: "",
      currency: "",
      email_consent_selected_error: false,
      email_consent_selected: false,
      email_consent_oth_email_selected_error: false,
      email_consent_oth_manage_selected_error: false,
      updateHeader: 0,
      finaltotalvalue: false,
      basket_items_number: 0,
      lang: "en",
      translations: "",

      // Form states
      loginistrue: true,
      passistrue: false,
      registeristrue: false,
      userexists: false,

      // Email fields
      emailid: "",
      emailid_wo: "",
      emailid_loading: false,

      // User details
      oth_email: "",
      companyname: "",
      oth_email_show: false,
      title: "",
      firstname: "",
      surname: "",
      phonecode: "",
      mobilenumber: "",
      email: "",
      email_confirm: "",

      // Address fields
      address: "",
      address_line_2: "",
      town: "",
      state: "",
      postcode: "",
      country: "GB",

      // Vehicle details
      vehicle_vrn: "",
      showvrnfields: false,
      vrn_color: "",
      vrn_make: "",
      vrn_model: "",
      loading_vrn: false,

      // Booking options
      email_consent_oth_email: true,
      email_consent_oth_email_selected: true,
      email_consent_oth_manage: true,
      email_consent_oth_manage_selected: true,
      email_consent_exists: false,
      bookingfor: "self",
      bookingfor_options: [
        { text: "Myself", value: "self" },
        { text: "Others", value: "other" },
      ],

      // Travel details
      reason: "",
      reasons_list: ["Business", "Leisure"],

      // Fasttrack passengers
      fasttrack_passengers_ADL: [],
      fasttrack_passengers_CHD: [],
      fasttrack_passengers_INF: [],
      fasttrack_passengers_ADL_errors: [],
      fasttrack_passengers_CHD_errors: [],
      fasttrack_passengers_INF_errors: [],
      fasttrack_tot_passengers: [],

      // Payment variables
      final_amount: "",
      final_orderreference: "",
      payment_session_id: "",
      transaction_token: "",
      final_uuid: "",
      cpkincart: false,
      store_card: false,
      payform: false,
      begin_checkout_sent: false,
      form_submitted_sent: false,
      add_payment_info_sent: false,

      // User VRN details
      UserVRNDetails: [],

      // Guest flag
      is_guest: "",
      guesttomember: "N",

      // OTP
      password: "",
      otpMethod: "email",
      userid: "",
      showOtpChoice: false,
      callemailsms: false,

      // Agreements
      create_account: false,
      term_condition: false,
      privacy_accept: false,
      email_consent: false,
      remember_device: false,

      // Loading states
      loading_proceed: false,
      proceedtologinuser_loading: false,

      // UI states
      showing_basket: true,
      showaddressfields: true,
      info_your_details: false,

      // Cart data
      cartloaded: false,
      cartitem: {},
      fasttrack_cartitem: {},
      lounge_cartitem: {},
      coach_cartitem: {},
      // Brand data
      brand_data: null,
      brand_product_styles: {},

      // Checkout blocks
      checkout_blocks: null,
      checkout_blocks_loaded: false,

      // UI elements
      banner_headline: "Enter Your Details",
      banner_headline_mobile: "Your Booking Summary",
      logo_image: "",
      header_menu: [],
      footer_links: [],
      footer_columns: "1 Columns",
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      show_basket: true,

      // Google Address Finder
      google_address_finder_active: false,

      airlines_list: [],
      destinations_list: [],
      select_airline: "",
      airline_number: "",
      outbound_flight_number: "",
      inbound_flight_number: "",
      destination: "",

      titles_list: [],
    };
  },
  validations() {
    // Use the config based on setbrandid
    let validations_object = brandValidations[this.setbrandid] || {};

    !validations_object.oth_email ? (validations_object.oth_email = {}) : null;
    !validations_object.title ? (validations_object.title = {}) : null;
    !validations_object.firstname ? (validations_object.firstname = {}) : null;
    !validations_object.surname ? (validations_object.surname = {}) : null;
    !validations_object.phonecode ? (validations_object.phonecode = {}) : null;
    !validations_object.mobilenumber
      ? (validations_object.mobilenumber = {})
      : null;
    !validations_object.address ? (validations_object.address = {}) : null;
    !validations_object.address_line_2
      ? (validations_object.address_line_2 = {})
      : null;
    !validations_object.town ? (validations_object.town = {}) : null;
    !validations_object.state ? (validations_object.state = {}) : null;
    !validations_object.postcode ? (validations_object.postcode = {}) : null;
    !validations_object.destination
      ? (validations_object.destination = {})
      : null;
    !validations_object.reason ? (validations_object.reason = {}) : null;
    !validations_object.select_airline
      ? (validations_object.select_airline = {})
      : null;
    !validations_object.airline_number
      ? (validations_object.airline_number = {})
      : null;
    !validations_object.outbound_flight_number
      ? (validations_object.outbound_flight_number = {})
      : null;
    !validations_object.inbound_flight_number
      ? (validations_object.inbound_flight_number = {})
      : null;
    !validations_object.term_condition
      ? (validations_object.term_condition = {})
      : null;
    !validations_object.privacy_accept
      ? (validations_object.privacy_accept = {})
      : null;
    !validations_object.email_consent
      ? (validations_object.email_consent = {})
      : null;

    validations_object.oth_email = {
      required: requiredIf(() => this.bookingfor == "other"),
    };

    validations_object.destination = {
      required: requiredIf(
        () => this.checkout_blocks?.destinations_mandatory == "yes"
      ),
    };

    validations_object.reason = {
      required: requiredIf(
        () => this.checkout_blocks?.reason_for_travel_mandatory == "yes"
      ),
    };

    validations_object.select_airline = {
      required: requiredIf(
        () => this.checkout_blocks?.select_airline_mandatory == "yes"
      ),
    };

    validations_object.airline_number = {
      required: requiredIf(
        () => this.checkout_blocks?.airline_number_mandatory == "yes"
      ),
    };

    validations_object.outbound_flight_number = {
      required: requiredIf(
        () => this.checkout_blocks?.outbound_flight_mandatory == "yes"
      ),
    };

    validations_object.inbound_flight_number = {
      required: requiredIf(
        () => this.checkout_blocks?.inbound_flight_mandatory == "yes"
      ),
    };

    if (
      encryptStorage.getItem("cart") &&
      validations_object &&
      validations_object.vehicle_vrn &&
      validations_object.vehicle_vrn.required
    ) {
      validations_object.vehicle_vrn = { required };
    } else {
      validations_object.vehicle_vrn = {};
    }

    return validations_object;
  },
  computed: {
    privacy_policy_link() {
      return this.marketingConfig?.privacy?.privacyUrl || "/privacy.html";
    },
    cardImages() {
      return brandCards[this.brandConfig?.brandCode] || brandCards.DEFAULT;
    },
    new_login: function () {
      if (
        process.env.VUE_APP_NEW_LOGIN_MODAL &&
        JSON.parse(process.env.VUE_APP_NEW_LOGIN_MODAL).includes(
          this.brandConfig?.brandCode || this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    countryList() {
      // Use the correct config array for the current brand
      if (this.setbrandid && countryConfig[this.setbrandid]) {
        return countryConfig[this.setbrandid];
      }
      // Fallback to FMM or empty array if not found
      return countryConfig.FMM || [];
    },
    new_style_variables() {
      const baseStyles = set_style_vars(
        this.brand_product_styles,
        "yourdetails"
      );
      const brandStyles = this.getBrandStyleVariables();
      return { ...baseStyles, ...brandStyles };
    },
    set_style_variables: function () {
      const brandStyles = this.getBrandStyles();
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": brandStyles.heroTextAlign,
        "--hero-text-align-mobile":
          brandStyles.heroTextAlignMobile || brandStyles.heroTextAlign,
        "--panel-background-color": this.panels_background_color,
        "--hero-background-position-y":
          brandStyles.heroBackgroundPositionY || "top",
      };
    },
    marketingConfig_privacy_privacyUrl() {
      return `<a href="${
        this.marketingConfig.privacy.privacyUrl || "/privacy.html"
      }" target="_blank">${
        this.getrans(this.marketingConfig.privacy.privacyUrlText) ||
        this.getrans("Privacy Policy")
      }</a>`;
    },
    marketingConfig_createAccount_section() {
      let text = this.getrans(
        this.marketingConfig?.createAccount?.text ||
          "Yes, create account\n\nGuest details are removed after 3 months. Visit our {privacyNoticeLink} to learn more."
      );

      text = text.replace(/\\n/g, "<br/>");

      text = text.replace(/(\r\n|\r|\n)/g, "<br/>");

      text = text.replace(
        "{privacyNoticeLink}",
        `<a target='_blank' href='${this.privacy_policy_link}'>${this.getrans(
          this.marketingConfig?.createAccount?.privacyNoticeText ||
            "Privacy Notice"
        )}</a>`
      );

      return text;
    },
  },
  watch: {
    create_account: {
      handler(newVal) {
        if (newVal) {
          this.is_guest = "N";
          this.guesttomember = "Y";
          encryptStorage.setItem("is_guest", "N");
          encryptStorage.setItem("guesttomember", "Y");
        } else if (!this.userexists) {
          // Keep guest state in sync when user unchecks create account.
          this.is_guest = "Y";
          this.guesttomember = "N";
          encryptStorage.setItem("is_guest", "Y");
          encryptStorage.setItem("guesttomember", "N");
        }
      },
      immediate: true,
    },
    header_menu: {
      handler(newVal, oldVal) {
        console.log("🔍 DEBUG: header_menu watcher triggered");
        console.log("🔍 DEBUG: Old value:", oldVal);
        console.log("🔍 DEBUG: New value:", newVal);
        console.log("🔍 DEBUG: New length:", newVal?.length);
      },
      deep: true,
      immediate: true,
    },
    brandConfig: {
      handler(newVal, oldVal) {
        console.log("🔍 DEBUG: brandConfig watcher triggered");
        console.log("🔍 DEBUG: Old value:", oldVal);
        console.log("🔍 DEBUG: New value:", newVal);
      },
      deep: true,
      immediate: true,
    },
    styles_loaded: {
      handler(newVal, oldVal) {
        console.log("🔍 DEBUG: styles_loaded watcher triggered");
        console.log("🔍 DEBUG: Old value:", oldVal);
        console.log("🔍 DEBUG: New value:", newVal);
      },
      immediate: true,
    },
  },

  beforeUnmount() {
    window.removeEventListener("userLoggedIn", this.handleUserLogin);
    window.removeEventListener(
      "userDataAvailable",
      this.handleUserDataAvailable
    );
    window.removeEventListener("userLoggedOut", this.handleUserLoggedOut);
  },

  methods: {
    pickUserByEmail(rows, expectedEmail = "") {
      const list = Array.isArray(rows) ? rows : [];
      if (!list.length) return null;
      const expected = (expectedEmail || "").toString().trim().toLowerCase();
      if (!expected) return list[0];
      return (
        list.find(
          (row) => ((row && row.email) || "").toString().trim().toLowerCase() === expected
        ) || null
      );
    },

    ...debugMethods,

    form_label(label) {
      if (label && this.setbrandid && form_labels[this.setbrandid]) {
        return this.getrans(form_labels[this.setbrandid][label]);
      }
      return false;
    },

    resetaddrfields(event) {
      let optionText = event.target.value;
      console.log("optionText", optionText);
      console.log("this.bookingfor", this.bookingfor);
      this.bookingfor = optionText;
      if (optionText == "other") {
        this.oth_email_show = true;
        this.unsetregisteredfields();
      }
      if (optionText == "self") {
        this.oth_email_show = false;
        this.check_for_session();
      }
    },

    async check_for_session() {
      const normalizedBrand = normalizeBrandId(
        this.setbrandid || this.brandConfig?.brandCode
      );

      // Always validate session with server before populating identity data.
      try {
        const isLoggedIn = await apiProxy.call("session_validate", {
          brand_id: normalizedBrand,
        });

        if (isLoggedIn && isLoggedIn.valid && isLoggedIn.authenticated) {
          // Pull fresh user details for this brand every time so the form matches
          // the current authenticated server session, not cached browser state.
          const loginEmail = isLoggedIn?.user_data?.email || null;
          const response = await apiProxy.call("Central User Details", loginEmail
            ? { slug: normalizedBrand, email: loginEmail }
            : { slug: normalizedBrand }
          );

          if (response && response.user_exists === "Y" && response.result && response.result.length > 0) {
            const selectedUser = this.pickUserByEmail(response.result, loginEmail || "");
            if (!selectedUser) {
              throw new Error("IDENTITY_MISMATCH_NO_EMAIL_MATCH");
            }
            const freshUser = { ...selectedUser, slug: normalizedBrand };
            encryptStorage.setItem("session_userdata", freshUser);
            this.populateFormFromUserData(freshUser);
            return;
          }

          // Authenticated session but no user details for this brand => force logout UI
          try {
            await apiProxy.call("logout_session", {});
          } catch (error) {
            console.log("[YourDetails] logout_session failed:", error);
          }
          encryptStorage.removeItem("session_userdata");
          document.cookie = `session_id=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
          this.loginistrue = true;
          this.registeristrue = false;
          this.userexists = false;
          window.dispatchEvent(new CustomEvent("userLoggedOut"));
          return;
        }
        // Session is not authenticated: clear stale cached identity so UI stays consistent with header.
        encryptStorage.removeItem("session_userdata");
      } catch (error) {
        console.error("[YourDetails] Session check failed:", error);
        // On validation failure, do not trust potentially stale identity cache.
        encryptStorage.removeItem("session_userdata");
      }

      // No valid session - show login form
      this.loginistrue = true;
    },

    populateFormFromUserData(userdata) {
      this.registeristrue = true;
      this.loginistrue = false;
      this.passistrue = false;
      this.userexists = true;
      this.updateHeader += 1;
      this.title = userdata.title || "";
      this.companyname = userdata.companyname || "";
      this.firstname = userdata.first_name
        ? decodeURI(userdata.first_name)
        : "";
      this.surname = userdata.last_name ? decodeURI(userdata.last_name) : "";
      this.email = userdata.email || "";
      this.email_consent_exists = userdata.email_consent;
      this.email_consent = userdata.email_consent;
      this.emailid = userdata.email || "";
      this.emailid_wo = userdata.email || "";
      this.password = "000000";
      this.email_confirm = userdata.email || "";
      this.address = userdata.address_line_1
        ? decodeURI(decodeURI(userdata.address_line_1))
        : "";
      this.address_line_2 = userdata.address_line_2
        ? decodeURI(decodeURI(userdata.address_line_2))
        : "";
      this.postcode = userdata.post_code ? decodeURI(userdata.post_code) : "";
      this.state = userdata.state ? decodeURI(userdata.state) : "";
      this.town = userdata.city ? decodeURI(userdata.city) : "";
      this.phonecode = userdata.phonecode || this.phonecode;
      this.mobilenumber = userdata.mobilenumber || "";
    },

    unsetregisteredfields() {
      //checks for session
      console.log("check_for_session", sessionStorage.getItem("session_uuid"));

      if (sessionStorage.getItem("session_uuid") === null) {
        //do nothing
      } else {
        let userdata = encryptStorage.getItem("session_userdata");
        if (userdata !== undefined) {
          this.setLocalData("uuid", sessionStorage.getItem("session_uuid"));
          this.registeristrue = true;
          this.loginistrue = false;
          this.passistrue = false;
          this.userexists = true;
          this.updateHeader += 1;
          this.title = "";
          this.firstname = "";
          this.surname = "";
          this.oth_email = "";
          this.email = "";
          this.emailid = "";
          this.emailid_wo = "";
          this.password = "000000";
          this.email_confirm = "";
          this.address = "";
          this.address_line_2 = "";
          this.postcode = "";
          this.state = "";
          this.town = "";
          this.country = "OT";
          //this.phonecode = "";
          this.mobilenumber = "";
        }
      }
    },

    validateFasttrackPassengerTitle(i) {
      // Only validate if the field is present
      if (
        this.fasttrack_passengers_ADL &&
        this.fasttrack_passengers_ADL[i] &&
        typeof this.fasttrack_passengers_ADL[i].title !== "undefined"
      ) {
        if (!this.fasttrack_passengers_ADL[i].title) {
          this.fasttrack_passengers_ADL_errors[i] =
            this.fasttrack_passengers_ADL_errors[i] || {};
          this.fasttrack_passengers_ADL_errors[i].title = true;
        } else {
          if (this.fasttrack_passengers_ADL_errors[i]) {
            this.fasttrack_passengers_ADL_errors[i].title = false;
          }
        }
      }
    },

    validateFasttrackPassengerFirstname(i) {
      if (
        this.fasttrack_passengers_ADL &&
        this.fasttrack_passengers_ADL[i] &&
        typeof this.fasttrack_passengers_ADL[i].firstname !== "undefined"
      ) {
        if (!this.fasttrack_passengers_ADL[i].firstname) {
          this.fasttrack_passengers_ADL_errors[i] =
            this.fasttrack_passengers_ADL_errors[i] || {};
          this.fasttrack_passengers_ADL_errors[i].firstname = true;
        } else {
          if (this.fasttrack_passengers_ADL_errors[i]) {
            this.fasttrack_passengers_ADL_errors[i].firstname = false;
          }
        }
      }
    },

    validateFasttrackPassengerSurname(i) {
      if (
        this.fasttrack_passengers_ADL &&
        this.fasttrack_passengers_ADL[i] &&
        typeof this.fasttrack_passengers_ADL[i].surname !== "undefined"
      ) {
        if (!this.fasttrack_passengers_ADL[i].surname) {
          this.fasttrack_passengers_ADL_errors[i] =
            this.fasttrack_passengers_ADL_errors[i] || {};
          this.fasttrack_passengers_ADL_errors[i].surname = true;
        } else {
          if (this.fasttrack_passengers_ADL_errors[i]) {
            this.fasttrack_passengers_ADL_errors[i].surname = false;
          }
        }
      }
    },

    async handleUserLogin() {
      // Prevent race conditions from multiple userLoggedIn events
      if (this.userLoginInProgress) {
        console.log("[YourDetails] User login already in progress, skipping");
        return;
      }

      this.userLoginInProgress = true;
      console.log(
        "[YourDetails] handleUserLogin triggered by userLoggedIn event"
      );

      try {
        await this.check_for_session();
      } catch (error) {
        console.error(
          "[YourDetails] Failed to refresh form after login:",
          error
        );
      } finally {
        this.userLoginInProgress = false;
      }
    },

    async handleUserDataAvailable(event) {
      console.log(
        "[YourDetails] handleUserDataAvailable triggered",
        event.detail
      );

      try {
        await this.check_for_session();
      } catch (error) {
        console.error(
          "[YourDetails] Failed to refresh form from user data:",
          error
        );
      }
    },

    handleUserLoggedOut() {
      console.log("[YourDetails] handleUserLoggedOut triggered");
      this.loginistrue = true;
      this.registeristrue = false;
      this.passistrue = false;
      this.userexists = false;
      this.email = "";
      this.emailid = "";
      this.emailid_wo = "";
      this.email_confirm = "";
      this.firstname = "";
      this.surname = "";
      this.companyname = "";
      this.mobilenumber = "";
    },
    currency_formatter(money) {
      if (!money) return;
      const brandConfig = getBrandConfig(this.setbrandid);
      if (brandConfig.features?.currencyAfterValue) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    checkpowerfields() {
      if (typeof this.cartitem !== "undefined") {
        //console.log("aaaaa");
        return true;
      } else {
        return false;
      }
    },
    getBrandStyleVariables() {
      return getBrandStyleVariables(this.setbrandid);
    },
    getBrandStyles() {
      return getStylesConfig(this.setbrandid);
    },
    async getbranded() {
      try {
        console.log("[DEBUG] getbranded() called");
        console.log(
          "🔍 DEBUG: Checking for emitsOptions errors before API call..."
        );
        const response = await apiProxy.call("brand_slug");
        console.log("[DEBUG] brand_slug API response:", response);
        console.log("🔍 DEBUG: API call completed successfully");

        if (response && response.code == "1") {
          this.setbrandid = response.slug;
          console.log("[DEBUG] Setting brandSlug in cookie:", response.slug);

          // Set brandSlug cookie for other components
          this.$cookie.setCookie("brandSlug", response.slug);
          console.log(
            "[DEBUG] Cookie set. Verifying cookie value:",
            this.$cookie.getCookie("brandSlug")
          );

          const brandConfig = getBrandConfig(response.slug);
          this.currency = brandConfig.currency;
          this.brandConfig = brandConfig;
          this.brandConfig.brandCode = response.slug;

          const { phoneCodesByOrder } = require("@/brand/brand.config.js");
          this.brandConfig.phoneCodes =
            phoneCodesByOrder[brandConfig.phoneCodeOrder] ||
            phoneCodesByOrder.UK_FIRST;

          // Set initial phone code based on brand
          if (
            this.brandConfig.phoneCodes &&
            this.brandConfig.phoneCodes.length > 0
          ) {
            this.phonecode = this.brandConfig.phoneCodes[0];
          }

          // Set country based on brand
          this.setCountryByBrand(response.slug);

          // Set Google Address Finder based on brand config
          this.google_address_finder_active =
            brandConfig.features?.googleAddressFinder || false;

          // Sequential API calls with proper await chaining
          this.loadTranslations();
          await this.getBrandData();
          await this.set_inputs();
          await this.getairlinesdestinations();

          // Check for authenticated session in new tabs
          //await this.checkSessionRestore();

          // Check for remembered device only if cookie exists
          const rememberDeviceCookie =
            this.$cookie.getCookie("remember_device");
          if (rememberDeviceCookie) {
            console.log(
              "[DEBUG] Remember device cookie found, checking device"
            );
            await this.checkRememberedDevice();
            console.log("[DEBUG] checkRememberedDevice completed");
          } else {
            console.log(
              "[DEBUG] No remember device cookie found, skipping check"
            );
          }

          console.log("[DEBUG] Brand loaded:", response.slug, this.brandConfig);
          console.log(
            "[DEBUG] Final cookie check:",
            this.$cookie.getCookie("brandSlug")
          );
        } else {
          console.error("[DEBUG] brand_slug API failed:", response);
        }
      } catch (error) {
        console.error("[DEBUG] brand_slug API error:", error);
      }
    },

    setCountryByBrand(brandCode) {
      // Use brand configuration for country mapping
      const brandConfig = getBrandConfig(brandCode);
      this.country = brandConfig.defaultCountry || "GB";
    },

    getCountryName(code) {
      const countries = {
        "+1": "USA/Canada",
        "+44": "United Kingdom",
        "+61": "Australia",
        "+33": "France",
        "+49": "Germany",
        "+357": "Cyprus",
        "+353": "Ireland",
        "+43": "Austria",
      };
      return countries[code] || code;
    },

    getBrandName() {
      // Use brand configuration for brand name
      return this.brandConfig?.brandName || this.brandConfig?.brandCode || "";
    },

    formatPrice(price) {
      const num = parseFloat(price || 0);
      if (this.brandConfig?.currencyFormat?.decimal === ",") {
        return num.toFixed(2).replace(".", ",");
      }
      return num.toFixed(2);
    },

    getrans(string) {
      if (!string) return string;

      const brandId = this.setbrandid || "";
      const language = this.lang || "en";
      const key = `${brandId}-${language.toUpperCase()}-${md5(string)}`;

      if (
        this.translations &&
        typeof this.translations === "object" &&
        this.translations[key]
      ) {
        return this.translations[key];
      }

      return string;
    },

    async loadTranslations() {
      // Use the shared module for loading translations
      const translations = await loadTranslationsModule(this.setbrandid);
      this.translations = translations;
      // Set language from sessionStorage if available
      this.lang = sessionStorage.getItem("language") || this.lang || "en";
    },

    async getBrandData() {
      console.log("🔍 DEBUG: getBrandData called for brand:", this.setbrandid);
      try {
        console.log(
          "🔍 DEBUG: Checking component state before brand_details API..."
        );
        console.log("🔍 DEBUG: Component emits:", this.$options?.emits);
        const response = await apiProxy.call("brand_details", {
          brandslug: this.setbrandid,
        });
        console.log("🔍 DEBUG: Brand details API response:", response);

        if (response && response.code == "1") {
          console.log("🔍 DEBUG: Setting menu from response...");
          this.setMenu(response);
          console.log("🔍 DEBUG: Menu set, header_menu now:", this.header_menu);

          console.log("🔍 DEBUG: Setting brand data...");
          this.setBrandData(response);
          console.log(
            "🔍 DEBUG: Brand data set, styles_loaded:",
            this.styles_loaded
          );
        } else {
          console.error("🔍 DEBUG: getBrandData: Invalid response", response);
          this.styles_loaded = true; // Ensure page shows even with API failure
        }
      } catch (error) {
        console.error("🔍 DEBUG: getBrandData error:", error);
        this.styles_loaded = true; // Ensure page shows even with API failure
      }
    },

    setBrandData(data) {
      this.brand_data = data;
      this.setStyles(data.brand_product_styles);
      this.styles_loaded = true;
    },

    setStyles(styles) {
      if (styles && Array.isArray(styles)) {
        styles.forEach((item) => {
          for (const [classname, style] of Object.entries(item)) {
            this.brand_product_styles[classname] = style;
          }
        });
        this.logo_image = this.brand_product_styles["asset_image_1"] || "";
      }
    },

    setMenu(data) {
      console.log("🔍 DEBUG: setMenu called with data:", data);

      if (!data || !data.brand_menu || !Array.isArray(data.brand_menu)) {
        console.log(
          "🔍 DEBUG: No brand_menu found or not an array:",
          data?.brand_menu
        );
        return;
      }

      console.log("🔍 DEBUG: brand_menu array:", data.brand_menu);

      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
          console.log("🔍 DEBUG: Set home_link:", menu.url);
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
          console.log("🔍 DEBUG: Set logo_link:", menu);
        }
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      console.log("🔍 DEBUG: Filtered top_menu items:", top_menu);
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      console.log("🔍 DEBUG: Filtered footer_menu items:", footer_menu);
      this.createFooterLinks(footer_menu);
    },

    async set_inputs() {
      try {
        const response = await apiProxy.call("dev_checkout", {
          brandslug: this.setbrandid,
        });

        console.log("set_inputs()", response);
        this.checkout_blocks = response;
        this.checkout_blocks_loaded = true;
      } catch (error) {
        console.error("set_inputs error:", error);
        this.checkout_blocks_loaded = true; // Set to true to prevent blocking
      }
    },

    async getairlinesdestinations() {
      try {
        const response = await apiProxy.call("initial_value", {
          brand_id: normalizeBrandId(this.setbrandid),
        });

        this.airlines_list = brandAirlines[normalizeBrandId(this.setbrandid)] || [];
        this.destinations_list = brandDestinations[normalizeBrandId(this.setbrandid)] || [];

        console.log("getairlinesdestinations", response.data);
        let items = [];
        if (response.data.airline_list) {
          for (let z = 0; z < response.data.airline_list.length; z++) {
            let it = response.data.airline_list[z];
            items.push(it.airline_name);
          }
          if (items.length > 0) {
            this.airlines_list = items || [];
          }
        }
        if (response.data.destination_list) {
          let destinations_items = [];
          for (let z = 0; z < response.data.destination_list.length; z++) {
            let it = response.data.destination_list[z];
            destinations_items.push(it.destination_name);
          }
          if (destinations_items.length > 0) {
            this.destinations_list = destinations_items || [];
          }
        }
      } catch (error) {
        console.error("getairlinesdestinations error:", error);
        // Set fallback data from brand config if API fails
        this.airlines_list = brandAirlines[this.setbrandid] || [];
        this.destinations_list = brandDestinations[this.setbrandid] || [];
      }
    },

    createHeaderLinks(data) {
      console.log("🔍 DEBUG: createHeaderLinks called with data:", data);
      try {
        const header_menu = [];

        if (data.length > 0) {
          data.forEach((menu) => {
            console.log("🔍 DEBUG: Processing menu item:", menu);
            if (menu.label.toLowerCase() === "basket") {
              this.show_basket = true;
              console.log("🔍 DEBUG: Set show_basket to true");
            } else if (
              menu.label.toLowerCase() !== "home" &&
              menu.label.toLowerCase() !== "logo"
            ) {
              header_menu.push(menu);
              console.log("🔍 DEBUG: Added to header_menu:", menu);
            }
          });
        }

        console.log("🔍 DEBUG: Final header_menu array:", header_menu);
        this.header_menu = header_menu;
        console.log("🔍 DEBUG: this.header_menu set to:", this.header_menu);
      } catch (error) {
        console.error("🚨 ERROR in createHeaderLinks:", error);
        if (error.message?.includes("emitsOptions")) {
          console.error("🚨 EMITS ERROR in createHeaderLinks");
        }
      }
    },

    createFooterLinks(data) {
      this.footer_columns = data[0]?.mcolumn || "1 Columns";
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },

    lowerCaseEmail(email) {
      this.emailid = email.toLowerCase();
    },

    lowerCaseEmail_wo(email) {
      this.emailid_wo = email.toLowerCase();
    },

    lowerCaseEmail_Confirm(email) {
      this.email = email.toLowerCase();
    },

    upperCaseVRN(vrn) {
      if (!vrn) return;
      this.vehicle_vrn = vrn
        .toString()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },

    toggleBasket() {
      this.showing_basket = !this.showing_basket;
      if (this.showing_basket) {
        this.banner_headline_mobile = "Booking Summary";
      } else {
        this.banner_headline_mobile = "Enter your details";
      }
    },

    formatDatedmy(date) {
      if (typeof date !== "undefined") {
        date = date.split("/");
        date = date[2] + "/" + date[1] + "/" + date[0];
        return date;
      }
      return "";
    },

    finaltotalvalueChange(value) {
      this.finaltotalvalue = value;
    },

    basketItemsNumber(value) {
      this.basket_items_number = value;
    },

    update_fasttrack_cartitem() {
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    },
    update_lounge_cartitem() {
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    },
    update_coach_cartitem() {
      this.coach_cartitem = encryptStorage.getItem("coach_cart");
    },
    update_cart_items() {
      this.cartitem = encryptStorage.getItem("cart");
      this.updateHeader++;
    },

    rectImage() {
      if (
       normalizeBrandId(this.brandConfig.brandCode) === "BHX"
      ) {
        return `background-image: url(${require("@/assets/images/faster_option_bhx.svg")});`;
      }
      return `background-image: url(${require("@/assets/images/faster_option.svg")});`;
    },

    async sendcodeoption(method) {
      this.otpMethod = method;
      this.showOtpChoice = false;

      if (method === "email") {
        await this.sendOTPviaEmail();
      } else if (method === "sms") {
        await this.sendOTPviaSMS();
      }

      // Show OTP input form after sending
      if (this.otpMethod) {
        this.passistrue = true;
      }
    },

    async sendSelectedOTP() {
      // This method is called when the OTP choice form is submitted
      // but we handle the actual sending via button clicks
    },

    opt_change(value) {
      this.password = value;
    },

    goto_page(url) {
      window.location.href = url;
    },

    getSSO_API_Name(baseApiName) {
      // Get regional API suffix from brand configuration
      const { regionalApiSuffixes } = require("@/utils/brandConfig.js");
      const apiEndpoint = this.brandConfig?.apiEndpoints || "standard";
      const suffix =
        regionalApiSuffixes[apiEndpoint] || regionalApiSuffixes.standard;
      return baseApiName + suffix;
    },

    async proceedtocheckuser() {
      if (this.emailid === "" || this.v$.emailid.$error) {
        Swal.fire({
          title: "Alert",
          icon: "error",
          text: "Please enter a valid email id.",
          confirmButtonText: "Close",
          showCloseButton: true,
        });
        this.emailid_loading = false;
        return;
      }

      const now = new Date().getTime() / 1000;
      try {
        const timeResponse = await apiProxy.call("server_time_check");
        const serverNow = parseInt(timeResponse.data || timeResponse);
        if (Math.abs(serverNow - now) > 20) {
          Swal.fire(
            "Error!",
            "We cannot proceed with this booking, because your system clock appears to be misconfigured. Please check your system time and try again.",
            "error"
          ).then(() => {
            this.resetpromocode();
          });
          return;
        }
      } catch (error) {
        console.error("Server time check failed:", error);
      }

      this.emailid_loading = true;

      try {
        const response = await apiProxy.call("Central Email Verification", {
          brand_id: normalizeBrandId(this.brandConfig.brandCode),
          email_id: this.emailid,
        });

        this.loginistrue = false;
        this.email = this.emailid;

        // Handle nested response structure like original staging site
        if (response && typeof response.code !== "undefined") {
          if (response.code.toString() === "37") {
            if (response.data && response.data.next_action == "deny") {
              Swal.fire({
                title: "Alert",
                icon: "error",
                text: response.data.msg,
                confirmButtonText: "Close",
                showCloseButton: true,
              });
            } else {
              this.registeristrue = true;
              this.loginistrue = false;
              this.passistrue = false;
              this.password = "000000";
            }
            this.email_confirm = this.emailid;
            this.email = this.emailid;
            this.is_guest = "N";
          } else if (response.code.toString() === "36") {
            if (response.data) {
              Swal.fire({
                title: "Alert",
                icon: "error",
                text: response.data,
                confirmButtonText: "Close",
                showCloseButton: true,
              });
            } else {
              Swal.fire({
                title: "Alert",
                icon: "error",
                text: "This account does not exist. Please contact Site Administrator",
                confirmButtonText: "Close",
                showCloseButton: true,
              });
            }
            this.email_confirm = this.emailid;
            this.email = this.emailid;
            this.is_guest = "N";
          } else if (response.code.toString() == "1" && response.data) {
            // Check user_exists from nested data object
            this.userexists = response.data.user_exists === "Y";
            let is_guest_db = response.data.is_guest;
            this.is_guest = is_guest_db;

            if (is_guest_db == "Y") {
              this.registeristrue = true;
              this.loginistrue = false;
              this.passistrue = false;
              this.password = "000000";
              this.email_confirm = this.emailid;
              this.email = this.emailid;
              this.is_guest = "N";
              this.guesttomember = "Y";
            } else {
              // Existing user - show OTP options
              if (
                this.brandConfig.features?.dualOtp ||
                this.brandConfig.features?.otpChoice
              ) {
                if (this.phonecode && this.mobilenumber) {
                  this.showOtpChoice = true;
                } else {
                  this.passistrue = true;
                  await this.sendOTPviaEmail();
                }
              } else {
                this.passistrue = true;
                await this.sendOTPviaEmail();
              }
            }
          } else {
            // No response code or other codes - treat as new user
            this.registeristrue = true;
            this.loginistrue = false;
            this.passistrue = false;
            this.password = "";
            this.email_confirm = this.emailid;
            this.email = this.emailid;
            this.emailid_loading = false;
            this.is_guest = "N";
          }
        } else {
          // No response code - treat as new user
          this.registeristrue = true;
          this.loginistrue = false;
          this.passistrue = false;
          this.password = "";
          this.email_confirm = this.emailid;
          this.email = this.emailid;
          this.emailid_loading = false;
          this.is_guest = "N";
        }
      } catch (error) {
        console.error("Email verification error:", error);
        this.loginistrue = false;
        this.registeristrue = true;
        this.emailid_loading = false;
      }
    },

    async proceedtocheckuser_withoutotp() {
      if (this.emailid_wo === "" || this.v$.emailid_wo.$error) {
        Swal.fire({
          title: "Alert",
          icon: "error",
          text: "Please enter a valid email id.",
          confirmButtonText: "Close",
          showCloseButton: true,
        });
        this.emailid_loading = false;
        return;
      }

      this.emailid_loading = true;

      try {
        // Guest checkout - still verify email exists but proceed as guest
        const apiName = this.getSSO_API_Name("email_verification");
        const response = await apiProxy.call(apiName, {
          brand_id: normalizeBrandId(this.brandConfig.brandCode),
          email_id: this.emailid_wo,
        });

        this.loginistrue = false;
        this.email = this.emailid_wo;
        this.email_confirm = this.emailid_wo;

        // Handle API response codes
        if (response && typeof response.code !== "undefined") {
          if (response.code == "37") {
            // Check next_action for domain restrictions
            if (response.data && response.data.next_action == "deny") {
              Swal.fire({
                title: "Error",
                text:
                  response.data.msg || this.getrans("Email domain not allowed"),
                icon: "error",
                confirmButtonText: "OK",
              });
              this.loginistrue = true;
              return;
            } else {
              // Proceed with guest registration even with code 37 if not denied
              this.registeristrue = true;
              this.userexists = false;
              this.is_guest = "Y";
            }
          } else if (response.code == "1") {
            // User exists - check if guest or regular user
            const is_guest_db =
              response.msg?.is_guest || response.data?.user_exists;
            if (is_guest_db === "Y" || response.data?.user_exists === "N") {
              // Proceed as guest
              this.registeristrue = true;
              this.userexists = false;
              this.is_guest = "Y";
              Swal.fire({
                title: this.getrans("Error"),
                text: this.getrans(
                  "You seem to already have an account with us. Please use account checkout to proceed"
                ),
                icon: "error",
                confirmButtonText: this.getrans("OK"),
              });
              this.loginistrue = true;
              return;
            } else {
              // User doesn't exist or is guest - proceed as guest
              console.log(
                "DEBUG: Proceeding as guest - user does not exist or is guest"
              );
              this.registeristrue = true;
              this.userexists = false;
              this.is_guest = "Y";
            }
          } else {
            // Other codes - proceed as guest
            this.registeristrue = true;
            this.userexists = false;
            this.is_guest = "Y";
          }
        } else {
          // No code in response - proceed as guest
          this.registeristrue = true;
          this.userexists = false;
          this.is_guest = "Y";
        }
      } catch (error) {
        console.error("Guest checkout error:", error);
        this.loginistrue = false;
        this.registeristrue = true;
        this.userexists = false;
        this.is_guest = "Y";
      } finally {
        this.emailid_loading = false;
      }
    },

    async proceedtocheckuser_withoutotp_new_flow() {
      if (this.userexists) return;
      if (this.emailid_loading) return;
      this.emailid_loading = true;

      try {
        const response = await apiProxy.call("Central Email Verification", {
          brand_id:normalizeBrandId(this.brandConfig.brandCode),
          email_id: this.emailid_wo,
        });

        this.loginistrue = false;
        this.email = this.emailid_wo;
        this.email_confirm = this.emailid_wo;

        if (response && typeof response.code !== "undefined") {
          if (response.code == "37") {
            if (response.data && response.data.next_action == "deny") {
              Swal.fire({
                title: "Error",
                text:
                  response.data.msg || this.getrans("Email domain not allowed"),
                icon: "error",
                confirmButtonText: "OK",
              });
              this.loginistrue = true;
              return;
            } else {
              this.registeristrue = true;
              this.userexists = false;
              this.is_guest = "Y";
            }
          } else if (response.code == "1") {
            const is_guest_db = response.data?.is_guest;
            console.log("DEBUG: Code 1 response data:", response.data);
            console.log("DEBUG: user_exists:", response.data?.user_exists);
            console.log("DEBUG: is_guest_db:", is_guest_db);
            console.log(
              "DEBUG: Condition check - user_exists === Y:",
              response.data?.user_exists === "Y"
            );
            console.log(
              "DEBUG: Condition check - is_guest_db !== Y:",
              is_guest_db !== "Y"
            );
            console.log(
              "DEBUG: Both conditions true:",
              response.data?.user_exists === "Y" && is_guest_db !== "Y"
            );

            if (response.data?.user_exists === "Y" && is_guest_db !== "Y") {
              // User exists and is not a guest - show error
              console.log("DEBUG: Showing Swal for existing user");
              Swal.fire({
                title: this.getrans("Error!"),
                icon: "error",
                text: this.getrans(
                  "You seem to already have an account with us. Please sign in to proceed to checkout."
                ),
                confirmButtonText: this.getrans("Sign In"),
                cancelButtonText: this.getrans("Cancel"),
                showCloseButton: true,
                showCancelButton: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  const new_event = new CustomEvent("loginModel", {
                    detail: { data: {} },
                  });
                  window.dispatchEvent(new_event);
                } else {
                  this.emailid_wo = "";
                }
              });
              this.loginistrue = true;
              return;
            }
          } else {
            this.registeristrue = true;
            this.userexists = false;
            this.is_guest = "Y";
          }
        } else {
          this.registeristrue = true;
          this.userexists = false;
          this.is_guest = "Y";
        }
      } catch (error) {
        console.error("Guest checkout error:", error);
        this.loginistrue = false;
        this.registeristrue = true;
        this.userexists = false;
        this.is_guest = "Y";
      } finally {
        this.emailid_loading = false;
      }
    },

    async sendOTPviaEmail() {
      try {
        const response = await apiProxy.call("Central Email OTP Send", {
          brand_id:normalizeBrandId(this.brandConfig.brandCode),
          email_id: this.emailid,
        });

        // Handle nested response structure
        if (response && response.code !== undefined) {
          if (response.code == "1") {
            console.log("Email OTP sent successfully");
            this.otpMethod = "email";
          } else {
            const errorMsg =
              response.data ||
              response.msg ||
              "Failed to send verification code. Please try again.";
            console.error("Email OTP send failed:", errorMsg);
            Swal.fire({
              title: "Error",
              text: this.getrans(errorMsg),
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            text: this.getrans(
              "Failed to send verification code. Please try again."
            ),
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error("Email OTP send error:", error);
        Swal.fire({
          title: "Error",
          text: this.getrans(
            "Failed to send verification code. Please try again."
          ),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    async sendOTPviaSMS() {
      // Check if brand supports mobile OTP using brand configuration
      if (!this.brandConfig.features?.mobileOtp) {
        console.log(
          "Mobile OTP not supported for this brand, falling back to email"
        );
        await this.sendOTPviaEmail();
        return;
      }

      // Validate phone number is provided
      if (!this.phonecode || !this.mobilenumber) {
        console.log("Phone number not provided, falling back to email");
        await this.sendOTPviaEmail();
        return;
      }

      try {
        const response = await apiProxy.call("Central Mobile OTP Send", {
          brand_id: normalizeBrandId(this.brandConfig.brandCode),
          mobile_number: this.phonecode + this.mobilenumber,
          login_id: this.emailid,
        });

        // Handle nested response structure
        if (response && response.code !== undefined) {
          if (response.code == "1") {
            console.log("SMS OTP sent successfully");
            this.otpMethod = "sms";
          } else {
            const errorMsg =
              response.msg || "Failed to send SMS. Falling back to email.";
            console.error(
              "SMS OTP send failed, falling back to email:",
              errorMsg
            );
            await this.sendOTPviaEmail();
          }
        } else {
          console.error("SMS OTP send failed, falling back to email");
          await this.sendOTPviaEmail();
        }
      } catch (error) {
        console.error("SMS OTP send error, falling back to email:", error);
        await this.sendOTPviaEmail();
      }
    },

    async proceedtologinuser() {
      this.proceedtologinuser_loading = true;

      try {
        const device_id = this.genHash(this.emailid);
        const request_id = `req_${Date.now()}_${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        const response = await apiProxy.call("Central OTP Verify", {
          brand_id: normalizeBrandId(this.brandConfig.brandCode),
          login_id: this.emailid,
          otp_code: this.password,
          otp_method: this.otpMethod || "email",
          device_id: device_id,
          request_id: request_id,
        });

        // Handle nested response structure with specific error codes
        if (response && response.code !== undefined) {
          if (response.code == "1") {
            // Login successful
            // Set session_id cookie for proxy session consistency
            if (response.session_token) {
              document.cookie = `session_id=${response.session_token}; path=/; max-age=86400; SameSite=Lax`;
              apiProxy.currentSessionToken = response.session_token;
            }

            this.passistrue = false;
            this.registeristrue = true;
            this.userexists = true;
            this.is_guest = "N";

            // Store authentication tokens if present
            if (response.msg?.accessToken) {
              this.accessToken = response.msg.accessToken;
            }
            if (response.msg?.refreshToken) {
              this.refreshToken = response.msg.refreshToken;
            }

            // Get user details after successful login
            await this.getUserDetails(null, this.emailid);

            // Dispatch event to notify Header.vue
          } else {
            // Handle specific error codes like original staging site
            let errorMsg = "Invalid verification code. Please try again.";
            if (response.code == "26") {
              errorMsg = "OTP has expired. Please request a new one.";
            } else if (response.code == "25") {
              errorMsg = "Invalid OTP. Please check and try again.";
            } else if (response.msg) {
              errorMsg = response.msg;
            }
            Swal.fire({
              title: "Error",
              text: this.getrans(errorMsg),
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        } else {
          Swal.fire({
            title: "Error",
            text: this.getrans("Login failed. Please try again."),
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error("OTP login error:", error);
        Swal.fire({
          title: "Error",
          text: this.getrans("Login failed. Please try again."),
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        this.proceedtologinuser_loading = false;
      }
    },

    async submit() {
      console.log("submit()");
      console.log("DEBUG: Cart data:", {
        cartitem: this.cartitem,
        fasttrack_cartitem: this.fasttrack_cartitem,
        lounge_cartitem: this.lounge_cartitem,
        encryptedCart: encryptStorage.getItem("cart"),
        encryptedFasttrack: encryptStorage.getItem("fasttrack_cart"),
        encryptedLounge: encryptStorage.getItem("lounge_cart"),
      });
      console.log("DEBUG: Form validation state before processOrder:", {
        hasErrors: this.v$.$error,
        errors: this.v$.$errors,
        isDirty: this.v$.$dirty,
      });

      // Validate fasttrack passenger fields before proceeding
      let fasttrackFieldErrors = [];
      if (
        this.fasttrack_passengers_ADL &&
        this.fasttrack_passengers_ADL.length > 0
      ) {
        this.fasttrack_passengers_ADL.forEach((p, i) => {
          this.validateFasttrackPassengerTitle(i);
          // Firstname
          if (!p.firstname) {
            this.fasttrack_passengers_ADL_errors[i] =
              this.fasttrack_passengers_ADL_errors[i] || {};
            this.fasttrack_passengers_ADL_errors[i].firstname = true;
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "First Name is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
          // Surname
          if (!p.surname) {
            this.fasttrack_passengers_ADL_errors[i] =
              this.fasttrack_passengers_ADL_errors[i] || {};
            this.fasttrack_passengers_ADL_errors[i].surname = true;
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "Surname is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
          // Title (already handled by validateFasttrackPassengerTitle)
          if (
            this.fasttrack_passengers_ADL_errors[i] &&
            this.fasttrack_passengers_ADL_errors[i].title
          ) {
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "Title is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
        });
      }

      if (fasttrackFieldErrors.length > 0) {
        // Show error in main error list/modal
        console.log({
          title: "Error",
          text: fasttrackFieldErrors.map((e) => e.message).join("\n"),
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      this.tryBeginCheckoutEvent();
      this.pushAddPaymentInfoEvent();
      this.pushFormSubmittedEvent();

      try {
        await this.processOrder();
      } catch (error) {
        console.error("DEBUG: processOrder failed before payment:", error);
        this.loading_proceed = false;
        Swal.fire({
          title: "Order Registration Error",
          text: "Your order could not be processed. Please try again later.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    validateForm() {
      // Check required fields

      this.brandConfig?.hasTitle ? this.v$.title.$touch() : null;
      this.brandConfig?.brandCode ? this.v$.firstname.$touch() : null;
      this.brandConfig?.brandCode ? this.v$.surname.$touch() : null;
      this.v$.phonecode.$touch();
      this.v$.mobilenumber.$touch();
      this.v$.email.$touch();
      this.brandConfig?.hasAddressLines ? this.v$.address.$touch() : null;
      this.brandConfig?.hasAddressLines
        ? this.v$.address_line_2.$touch()
        : null;
      this.brandConfig?.hasAddressLines ? this.v$.town.$touch() : null;
      this.brandConfig?.hasAddressLines ? this.v$.state.$touch() : null;
      this.brandConfig?.hasAddressLines ? this.v$.postcode.$touch() : null;
      this.v$.destination.$touch();
      this.v$.reason.$touch();
      this.v$.select_airline.$touch();
      this.v$.airline_number.$touch();
      this.v$.outbound_flight_number.$touch();
      this.v$.inbound_flight_number.$touch();
      this.v$.vehicle_vrn.$touch();
      this.v$.term_condition.$touch();
      this.v$.privacy_accept.$touch();
      this.v$.email_consent.$touch();

      if (encryptStorage.getItem("cart")) {
        this.v$.vehicle_vrn.$touch();
      }

      if (this.v$.$errors.length > 0) {
        console.log("Form validation failed:", this.v$.$errors);
        Swal.fire({
          title: "Error",
          text: this.getrans("Please fill in all required fields correctly."),
          icon: "error",
          confirmButtonText: "OK",
        });
        return false;
      }

      // if (!this.firstname) {
      //   alert(this.getrans("Please enter your first name"));
      //   return false;
      // }
      // if (!this.surname) {
      //   alert(this.getrans("Please enter your last name"));
      //   return false;
      // }
      // if (!this.phonecode || !this.mobilenumber) {
      //   alert(this.getrans("Please enter your phone number"));
      //   return false;
      // }
      // if (!this.town) {
      //   alert(this.getrans("Please enter your city"));
      //   return false;
      // }
      // if (!this.postcode) {
      //   alert(this.getrans("Please enter your postcode"));
      //   return false;
      // }
      // if (this.cartitem && this.cartitem.carpark_name && !this.vehicle_vrn) {
      //   alert(this.getrans("Please enter your vehicle registration"));
      //   return false;
      // }
      // if (!this.term_condition) {
      //   alert(this.getrans("Please accept the terms and conditions"));
      //   return false;
      // }

      // // Brand-specific validations
      // if (this.brandConfig?.hasTitle && !this.title) {
      //   alert(this.getrans("Please select your title"));
      //   return false;
      // }
      // if (this.brandConfig?.hasStateField && !this.state) {
      //   alert(this.getrans("Please enter your state/province"));
      //   return false;
      // }
      // if (this.brandConfig?.hasAddressLines && !this.address) {
      //   alert(this.getrans("Please enter your address"));
      //   return false;
      // }

      return true;
    },

    collectFormData() {
      return {
        brand: normalizeBrandId(this.brandConfig.brandCode),
        paymentProvider: this.brandConfig.paymentProvider,
        email: this.email,
        title: this.title,
        firstname: this.firstname,
        surname: this.surname,
        phone: this.phonecode + this.mobilenumber,
        phonecode: this.phonecode,
        mobilenumber: this.mobilenumber,
        address: this.address,
        address_line_2: this.address_line_2,
        city: this.town,
        state: this.state,
        postcode: this.postcode,
        country: this.country,
        vrn: this.vehicle_vrn,
        terms: this.term_condition,
        privacy: this.privacy_accept,
        marketing: this.email_consent,
        is_guest: this.is_guest,
        user_exists: this.userexists,
        booking_for: this.bookingfor,
        utm_campaign: this.$cookie.getCookie("utm_campaign"),
        utm_content: this.$cookie.getCookie("utm_content"),
        utm_medium: this.$cookie.getCookie("utm_medium"),
        utm_partner: this.$cookie.getCookie("utm_partner"),
        utm_source: this.$cookie.getCookie("utm_source"),
        utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
        utm_term: this.$cookie.getCookie("utm_term"),
      };
    },
    persistGuestFlags() {
      const isGuestFlag = this.create_account ? "N" : "Y";
      const guestToMemberFlag =
        this.guesttomember === "Y" || this.guesttomember === "N"
          ? this.guesttomember
          : "N";
      encryptStorage.setItem("is_guest", isGuestFlag);
      encryptStorage.setItem("guesttomember", guestToMemberFlag);
    },
    hashForDataLayer(value) {
      if (!value) return undefined;
      const normalized = value.toString().trim().toLowerCase();
      if (!normalized) return undefined;
      return crypto.createHash("sha256").update(normalized, "utf8").digest("hex");
    },
    buildPurchaseTrackingPayload() {
      const userData = {
        email: this.hashForDataLayer(this.email),
        phone_number: this.hashForDataLayer(this.phonecode + this.mobilenumber),
        first_name: this.hashForDataLayer(this.firstname),
        last_name: this.hashForDataLayer(this.surname),
        address: {
          first_name: this.hashForDataLayer(this.firstname),
          last_name: this.hashForDataLayer(this.surname),
          street: this.hashForDataLayer(this.address),
          city: this.hashForDataLayer(this.town),
          region: this.hashForDataLayer(this.state),
          postal_code: this.hashForDataLayer(this.postcode),
          country: this.hashForDataLayer(this.country),
        },
      };
      const attributionData = {
        utm_campaign: this.$cookie.getCookie("utm_campaign") || "",
        utm_content: this.$cookie.getCookie("utm_content") || "",
        utm_medium: this.$cookie.getCookie("utm_medium") || "",
        utm_partner: this.$cookie.getCookie("utm_partner") || "",
        utm_source: this.$cookie.getCookie("utm_source") || "",
        utm_sub_partner: this.$cookie.getCookie("utm_sub_partner") || "",
        utm_term: this.$cookie.getCookie("utm_term") || "",
      };
      return { user_data: userData, attribution_data: attributionData };
    },
    getCheckoutDataLayerPayload() {
      let datalayerparams = encryptStorage.getItem("datalayerparams") || {};
      if (typeof datalayerparams === "string") {
        try {
          datalayerparams = JSON.parse(datalayerparams);
        } catch (e) {
          datalayerparams = {};
        }
      }
      if (typeof datalayerparams !== "object" || datalayerparams === null) {
        datalayerparams = {};
      }
      const items = [];

      [datalayerparams.cpk, datalayerparams.ftt, datalayerparams.lng].forEach(
        (payload) => {
          if (payload?.ecommerce?.items?.length) {
            items.push(...payload.ecommerce.items);
          }
        }
      );

      if (!items.length) return null;

      const currency =
        datalayerparams.cpk?.ecommerce?.currency ||
        datalayerparams.ftt?.ecommerce?.currency ||
        datalayerparams.lng?.ecommerce?.currency ||
        "GBP";

      const value = items.reduce(
        (sum, item) =>
          sum + parseFloat(item.price || 0) * (item.quantity || 1),
        0
      );

      const couponRaw = encryptStorage.getItem("discount_coupon_applied");
      const coupon =
        typeof couponRaw === "string" ? couponRaw.trim() : String(couponRaw || "").trim();

      return {
        ecommerce: {
          currency,
          value: parseFloat(value.toFixed(2)),
          items,
          ...(coupon ? { coupon } : {}),
        },
      };
    },
    tryBeginCheckoutEvent(attempts = 5) {
      if (this.begin_checkout_sent) return;
      const brandId = this.brandConfig?.brandCode || this.setbrandid;
      if (!isDataLayerBrand(brandId)) return;
      const payload = this.getCheckoutDataLayerPayload();
      if (!payload) {
        if (attempts > 0) {
          setTimeout(() => this.tryBeginCheckoutEvent(attempts - 1), 500);
        }
        return;
      }
      this.begin_checkout_sent = true;
      /* eslint-disable */
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "begin_checkout",
        ...payload,
      });
      /* eslint-enable */
    },
    pushAddPaymentInfoEvent() {
      const brandId = this.brandConfig?.brandCode || this.setbrandid;
      if (!isDataLayerBrand(brandId)) return;
      if (this.add_payment_info_sent) return;
      const payload = this.getCheckoutDataLayerPayload();
      if (!payload) return;
      this.add_payment_info_sent = true;
      const addPaymentPayload = {
        ...payload,
        ecommerce: {
          ...payload.ecommerce,
          payment_type: "Stripe Payment Gateway",
        },
      };
      /* eslint-disable */
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_payment_info",
        ...addPaymentPayload,
      });
      /* eslint-enable */
    },
    pushFormSubmittedEvent() {
      if (this.form_submitted_sent) return;
      const brandId = this.brandConfig?.brandCode || this.setbrandid;
      if (!isDataLayerBrand(brandId)) return;
      this.form_submitted_sent = true;
      const hashData = (value) =>
        crypto
          .createHash("sha256")
          .update(String(value || "").toLowerCase().trim())
          .digest("hex");

      const hashedTitle = hashData(this.title);
      const hashedCompany = hashData(this.companyname);
      const hashedFirstName = hashData(this.firstname);
      const hashedSurname = hashData(this.surname);
      const hashedPhone = hashData(this.mobilenumber);
      const hashedEmail = hashData(this.email);
      const hashedPostcode = hashData(this.postcode);
      const hashedAddress = hashData(this.address);
      const hashedTown = hashData(this.town);
      const hashedState = hashData(this.state);
      const hashedAddress2 = hashData(this.address_line_2);
      const hashedCountry = hashData(this.country);

      const getAttributionValue = (key) => {
        let value = "";
        if (this.$cookie && typeof this.$cookie.getCookie === "function") {
          value = this.$cookie.getCookie(key) || "";
        }
        if (!value) {
          value = sessionStorage.getItem(key) || "";
        }
        if (!value) {
          value = localStorage.getItem(key) || "";
        }
        if (!value) {
          value = new URLSearchParams(window.location.search).get(key) || "";
        }
        return value;
      };

      const attributionData = {
        gclid: getAttributionValue("gclid"),
        ppid: getAttributionValue("ppid"),
        mobile_advertiser_id:
          getAttributionValue("mobile_advertiser_id") ||
          getAttributionValue("maid"),
      };

      const leadsUserData = {
        email: hashedEmail,
        phone_number: hashedPhone,
        address: {
          title: hashedTitle,
          company: hashedCompany,
          address_line_1: hashedAddress,
          address_line_2: hashedAddress2,
          first_name: hashedFirstName,
          last_name: hashedSurname,
          street: hashedAddress,
          city: hashedTown,
          region: hashedState,
          country: hashedCountry,
          postal_code: hashedPostcode,
        },
      };

      const purchaseUserData = {
        email: hashedEmail,
        phone_number: hashedPhone,
        address: {
          first_name: hashedFirstName,
          last_name: hashedSurname,
          street: hashedAddress,
          city: hashedTown,
          region: hashedState,
          country: hashedCountry,
          postal_code: hashedPostcode,
        },
      };

      encryptStorage.setItem("purchase_tracking_payload", {
        user_data: purchaseUserData,
        attribution_data: attributionData,
      });
      /* eslint-disable */
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "formSubmitted",
        leadsUserData,
        attribution_data: attributionData,
      });
      /* eslint-enable */
    },

    async utmdata(brandslug) {
      let sessid = "";
      let analytics = "0";
      if (!this.$cookie.isCookieAvailable("session-id")) {
        this.gensessionid();
        sessid = this.getSessionData("search_analytics_id");
      } else {
        sessid = this.$cookie.getCookie("session-id");
        analytics = "1";
      }
      if (this.$cookie.isCookieAvailable("utm_partner")) {
        let trackevents = {
          page: window.location.href,
          analytics: analytics,
          search_analytics_id: this.getSessionData("search_analytics_id"),
        };
        let tdata = {
          utm_campaign: this.$cookie.getCookie("utm_campaign"),
          utm_content: this.$cookie.getCookie("utm_content"),
          utm_medium: this.$cookie.getCookie("utm_medium"),
          utm_partner: this.$cookie.getCookie("utm_partner"),
          utm_source: this.$cookie.getCookie("utm_source"),
          utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
          utm_term: this.$cookie.getCookie("utm_term"),
          session_id: sessid,
          trackevents: trackevents,
          brandslug: brandslug,
        };

        try {
          // Use apiProxy for utm_campaign call
          const response = await apiProxy.call("utm_campaign", tdata);
          if (response.success) {
            console.log("utmdata", response.data);
          }
        } catch (error) {
          console.error("UTM data error:", error);
        }
      }
    },

    gensessionid() {
      try {
        if (!this.getSessionData("search_analytics_id")) {
          const crypto = require("crypto");
          let search_analytics_id = crypto.randomBytes(16).toString("base64");
          this.setSessionData("search_analytics_id", search_analytics_id);
          return search_analytics_id;
        } else {
          return this.getSessionData("search_analytics_id");
        }
      } catch (error) {
        console.error("Session ID generation error:", error);
        // Fallback session ID
        return Date.now().toString(36) + Math.random().toString(36).substr(2);
      }
    },

    async getUserDetails(uuid, email) {
      try {
        const apiName = "Central User Details";
        const requestPayload = {
          slug:normalizeBrandId(this.brandConfig.brandCode),
          email: email,
        };
        if (uuid) {
          requestPayload.uid = uuid;
        }
        const response = await apiProxy.call(apiName, requestPayload);

        // Handle response structure like original implementation
        if (response && response.user_exists == "Y") {
          let userdata = this.pickUserByEmail(response.result, email || this.email || this.emailid || "");
          if (!userdata) {
            console.log("User details mismatch: no record matches expected email");
            return;
          }
          let cnnnn = response.result.length;
          let usdata = response.result[cnnnn - 1];

          // Store user data in encrypted storage like original
          encryptStorage.setItem("session_userdata", userdata);
          encryptStorage.setItem("session_usdata", usdata);
          encryptStorage.setItem("email_md5", crypto.createHash('md5').update(userdata.email).digest('hex'));

          // Populate form fields
          this.companyname = userdata.companyname ? userdata.companyname : "";
          this.title = userdata.title;
          this.firstname = decodeURI(userdata.first_name);
          this.surname = decodeURI(userdata.last_name);
          this.email = userdata.email;
          this.email_consent_exists = userdata.email_consent;
          this.email_confirm = userdata.email;
          this.emailid_wo = userdata.email;
          this.address = decodeURI(decodeURI(userdata.address_line_1));
          this.address_line_2 = decodeURI(decodeURI(userdata.address_line_2));
          this.postcode = decodeURI(userdata.post_code);
          this.state = decodeURI(userdata.state);
          this.town = decodeURI(userdata.city);
          this.phonecode = userdata.phonecode || this.brandConfig.phoneCodes[0];
          this.mobilenumber = userdata.mobilenumber;
          const userLoggedInEvent = new CustomEvent("userLoggedIn");
          window.dispatchEvent(userLoggedInEvent);
        } else {
          console.log("User not found or unable to retrieve user details");
        }
      } catch (error) {
        console.error("getUserDetails error:", error);
        // Don't block the flow if user details fail
      }
    },

    async processOrder() {
      console.log("processOrder()");
      this.loading_proceed = true;
      // Set email data
      if (this.emailid == "") {
        this.emailid = this.emailid_wo;
      }
      if (this.emailid_wo == "") {
        this.emailid_wo = this.emailid;
      }
      this.email_confirm = this.email;
      this.emailid_wo = this.email;
      // if (this.emailid_wo == "") {
      //   this.emailid_wo = "NA";
      // }
      this.password = "000000";
      encryptStorage.setItem("tag_email", this.email);

      console.log("coach_drivers", this.coach_drivers);
      if (
        typeof this.coach_cartitem !== "undefined" &&
        typeof this.coach_cartitem.coach_selected !== "undefined"
      ) {
        let lt = (this.coach_cartitem.coach_selected || []).length;
        for (let z = 0; z < lt; z++) {
          let name = "";
          let vrn = "";
          if (this.coach_drivers.name[z]) {
            name = this.coach_drivers.name[z];
          }
          if (this.coach_drivers.vrn[z]) {
            vrn = this.coach_drivers.vrn[z];
          }
          if (name == "" || vrn == "") {
            this.coach_errors = true;
          }
        }
      }

      // console.log('er',er);
      // Validate form
      this.v$.destination.$touch();
      this.v$.reason.$touch();
      this.v$.select_airline.$touch();
      this.v$.airline_number.$touch();
      this.v$.outbound_flight_number.$touch();
      this.v$.inbound_flight_number.$touch();
      await this.v$.$validate();
      console.log("DEBUG: Form validation errors:", this.v$.$errors);
      console.log("DEBUG: Form validation error state:", this.v$.$error);

      // Aggregate fasttrack passenger field errors
      let fasttrackFieldErrors = [];
      if (
        this.fasttrack_passengers_ADL &&
        this.fasttrack_passengers_ADL.length > 0
      ) {
        this.fasttrack_passengers_ADL.forEach((p, i) => {
          this.validateFasttrackPassengerTitle(i);
          // Firstname
          if (!p.firstname) {
            this.fasttrack_passengers_ADL_errors[i] =
              this.fasttrack_passengers_ADL_errors[i] || {};
            this.fasttrack_passengers_ADL_errors[i].firstname = true;
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "First Name is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
          // Surname
          if (!p.surname) {
            this.fasttrack_passengers_ADL_errors[i] =
              this.fasttrack_passengers_ADL_errors[i] || {};
            this.fasttrack_passengers_ADL_errors[i].surname = true;
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "Surname is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
          // Title (already handled by validateFasttrackPassengerTitle)
          if (
            this.fasttrack_passengers_ADL_errors[i] &&
            this.fasttrack_passengers_ADL_errors[i].title
          ) {
            fasttrackFieldErrors.push({
              index: i,
              message: this.getrans(
                "Title is required for FastTrack Passenger " + (i + 1)
              ),
            });
          }
        });
      }

      // Add your email consent validation here
      if (!this.userexists) {
        if (
          brandValidations[this.setbrandid] && 
          brandValidations[this.setbrandid].email_consent_selected && 
          brandValidations[this.setbrandid].email_consent_selected.required && 
          !this.email_consent_selected
        ) {
          this.email_consent_selected_error = true;
          this.loading_proceed = false;
          return false;
        } else {
          this.email_consent_selected_error = false;
        }
      }

      if (this.v$.$error || fasttrackFieldErrors.length > 0) {
        let errorMessages = [];
        if (this.v$.$error && this.v$.$errors && this.v$.$errors.length > 0) {
          errorMessages = this.v$.$errors.map(
            (e) => e.$message || e.path || "Validation error"
          );
        }
        if (fasttrackFieldErrors.length > 0) {
          errorMessages = errorMessages.concat(
            fasttrackFieldErrors.map((e) => e.message)
          );
        }
        console.log("DEBUG: Form validation failed, stopping processOrder");
        this.loading_proceed = false;
        console.log({
          title: "Error",
          text: errorMessages.join("\n"),
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }
      console.log(
        "DEBUG: Form validation passed, continuing with processOrder"
      );

      // Handle fasttrack passengers
      if (typeof this.fasttrack_cartitem !== "undefined") {
        this.fasttrack_tot_passengers = [];
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_ADL);
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_CHD);
        this.fasttrack_tot_passengers.push(this.fasttrack_passengers_INF);
      }

      let fintotvalue = 0;
      console.log(
        "🔍 DEBUG: Starting order processing with initial total:",
        fintotvalue
      );

      // Process parking cart
      console.log(
        "DEBUG: Checking for parking cart:",
        encryptStorage.getItem("cart")
      );
      if (typeof encryptStorage.getItem("cart") !== "undefined") {
        console.log("DEBUG: Processing parking cart");
        this.cpkincart = true;
        await this.processParkingCart();

        let totalfee =
          this.getLocalDataoo("dis_cpk") === null
            ? encryptStorage.getItem("tag_totcost")
            : encryptStorage.getItem("finaltotalvalue_cpk") !== null
            ? encryptStorage.getItem("finaltotalvalue_cpk")
            : encryptStorage.getItem("tag_totcost");

        totalfee = parseFloat(totalfee);
        if (totalfee < 0) totalfee = 0;
        console.log("🔍 DEBUG: CPK total fee:", totalfee);
        fintotvalue += totalfee;
        console.log("🔍 DEBUG: Running total after CPK:", fintotvalue);
      }

      // Process fasttrack cart
      console.log(
        "DEBUG: Checking for fasttrack cart:",
        this.fasttrack_cartitem
      );
      console.log(
        "DEBUG: fasttrack_cartitem type:",
        typeof this.fasttrack_cartitem
      );
      console.log(
        "DEBUG: fasttrack_cartitem is array:",
        Array.isArray(this.fasttrack_cartitem)
      );
      console.log(
        "DEBUG: fasttrack_cartitem length:",
        this.fasttrack_cartitem?.length
      );
      console.log(
        "DEBUG: fasttrack_cartitem !== undefined:",
        typeof this.fasttrack_cartitem !== "undefined"
      );
      console.log(
        "DEBUG: fasttrack_cartitem truthy:",
        !!this.fasttrack_cartitem
      );
      if (
        typeof this.fasttrack_cartitem !== "undefined" &&
        this.fasttrack_cartitem &&
        Array.isArray(this.fasttrack_cartitem) &&
        this.fasttrack_cartitem.length > 0
      ) {
        console.log("DEBUG: Processing fasttrack cart");
        const fasttrackItemsToProcess =
          this.getFasttrackItemsForOrderProcessing();
        await this.processFasttrackCart(fasttrackItemsToProcess);
        let fttTotal = this.calculateFasttrackTotal(fasttrackItemsToProcess);
        console.log("🔍 DEBUG: FTT total fee:", fttTotal);
        fintotvalue += fttTotal;
        console.log("🔍 DEBUG: Running total after FTT:", fintotvalue);
      } else {
        console.log("DEBUG: Fasttrack cart condition failed - not processing");
      }

      // Process lounge cart
      console.log("DEBUG: Checking for lounge cart:", this.lounge_cartitem);
      if (
        typeof this.lounge_cartitem !== "undefined" &&
        this.lounge_cartitem &&
        Object.keys(this.lounge_cartitem).length > 0 &&
        this.lounge_cartitem.loungesubtotal
      ) {
        console.log("DEBUG: Processing lounge cart");
        await this.processLoungeCart();
        let lngTotal = this.calculateLoungeTotal();
        console.log("🔍 DEBUG: LNG total fee:", lngTotal);
        fintotvalue += lngTotal;
        console.log("🔍 DEBUG: Running total after LNG:", fintotvalue);
      }

      // Process coach cart
      console.log("DEBUG: Checking for coach cart:", this.coach_cartitem);
      if (
        typeof this.coach_cartitem !== "undefined" &&
        this.coach_cartitem &&
        Object.keys(this.coach_cartitem).length > 0 &&
        this.coach_cartitem.coachsubtotal
      ) {
        console.log("DEBUG: Processing coach cart");
        await this.processCoachCart();
        let coachTotal = this.calculateCoachTotal();
        console.log("🔍 DEBUG: COACH total fee:", coachTotal);
        fintotvalue += coachTotal;
        console.log("🔍 DEBUG: Running total after COACH:", fintotvalue);
      }

      console.log("🔍 DEBUG: Final calculated total:", fintotvalue);
      console.log("🔍 DEBUG: Final total type:", typeof fintotvalue);
      console.log("🔍 DEBUG: Final total === 0:", fintotvalue === 0);
      console.log("🔍 DEBUG: Final total <= 0:", fintotvalue <= 0);

      encryptStorage.setItem("final_amount_paid", fintotvalue);
      console.log(
        "🔍 DEBUG: Stored final_amount_paid:",
        encryptStorage.getItem("final_amount_paid")
      );

      // Start payment flow with preslotconfirm
      console.log("🔍 DEBUG: Calling preslotconfirm with total:", fintotvalue);
      this.preslotconfirm(
        fintotvalue,
        this.getLocalData("uuid"),
        encryptStorage.getItem("orefwithoutprefix")
      );
    },

    serializeSqsFormData(formData) {
      const serializedData = {};
      for (let [key, value] of formData.entries()) {
        serializedData[key] =
          typeof value === "string" ? encodeURIComponent(value) : value;
      }
      return serializedData;
    },

    normalizeSqsRegistrationResponse(response) {
      if (typeof response === "string") {
        try {
          return JSON.parse(response);
        } catch (error) {
          console.warn(
            "DEBUG: Unable to parse SQS_Register_Live_V2 string response:",
            error
          );
          return { success: false, message: response };
        }
      }

      if (typeof response?.body === "string") {
        try {
          return JSON.parse(response.body);
        } catch (error) {
          console.warn(
            "DEBUG: Unable to parse SQS_Register_Live_V2 body response:",
            error
          );
          return { ...response, success: false };
        }
      }

      return response;
    },

    isSuccessfulSqsRegistration(response) {
      const truthy = (value) =>
        value === true || value === "true" || value === 1 || value === "1";
      return (
        response &&
        truthy(response.success) &&
        truthy(response.s3_saved) &&
        truthy(response.sqs_forwarded) &&
        truthy(response.audit_saved)
      );
    },

    async registerSqsLiveV2(formData, label) {
      const serializedData = this.serializeSqsFormData(formData);
      console.log(`DEBUG: Serialized ${label} data:`, serializedData);

      const sqsResponse = this.normalizeSqsRegistrationResponse(
        await apiProxy.call("sqs_register_live_v2", serializedData)
      );
      console.log(`DEBUG: SQS_Register_Live_V2 ${label} response:`, sqsResponse);

      if (!this.isSuccessfulSqsRegistration(sqsResponse)) {
        const orderreference = serializedData.orderreference
          ? decodeURIComponent(serializedData.orderreference)
          : "unknown";
        const message =
          sqsResponse?.message ||
          sqsResponse?.error ||
          `SQS registration failed for ${label} (${orderreference})`;
        console.error("DEBUG: SQS_Register_Live_V2 registration failed:", {
          label,
          orderreference,
          message,
          response: sqsResponse,
        });
        throw new Error(
          "Your order could not be processed. Please try again later."
        );
      }

      return sqsResponse;
    },
    async processParkingCart() {
      this.persistGuestFlags();
      let myFormsettings = document.getElementById("payment-process");
      let formData = new FormData(myFormsettings);

      // Add form data
      formData.append("companyname", this.companyname);
      formData.append("title", this.title);
      formData.append("first_name", encodeURIComponent(this.firstname));
      formData.append("last_name", encodeURIComponent(this.surname));
      formData.append("mobilenumber", this.mobilenumber);
      formData.append("email", this.email);
      formData.append("lang", this.lang.toUpperCase());
      formData.append("phonecode", this.phonecode);
      formData.append("post_code", encodeURIComponent(this.postcode));
      formData.append("address_line_1", encodeURIComponent(this.address));
      formData.append(
        "address_line_2",
        encodeURIComponent(this.address_line_2)
      );
      formData.append(
        "upsell_shown",
        encryptStorage.getItem("upsell_shown")
      );      
      formData.append("city", encodeURIComponent(this.town));
      formData.append("state", encodeURIComponent(this.state));
      formData.append("vehicle_vrn", encodeURIComponent(this.vehicle_vrn));
      formData.append(
        "term_condition",
        encodeURIComponent(this.term_condition)
      );
      const cart = encryptStorage.getItem("cart");
      formData.append("cart", JSON.stringify(cart));
      formData.append(
        "oldcart",
        JSON.stringify(encryptStorage.getItem("oldcart"))
      );
      formData.append("orderstatus", "Pending");
      formData.append("paymentstatus", "Pending");
      formData.append("partner_id", this.$cookie.getCookie("partner_id"));
      formData.append("partner_name", this.$cookie.getCookie("partner_name"));

      formData.append("email_consent_oth_email",this.email_consent_oth_email);
      formData.append("email_consent_oth_manage",this.email_consent_oth_manage);   
      formData.append("oth_email", this.oth_email);   
      formData.append("bookingfor", this.bookingfor);   

      if (cart && cart.booking_type && cart.booking_type === "Seasonal") {
        formData.append("booking_type", "Seasonal Parking");
      }
      else if (cart && !cart.booking_type) 
      {
      formData.append("booking_type", "Single Parking");
      }

      // BH2: If partner isn't set, force to Jet2
      const normalizedBrandId = normalizeBrandId(this.setbrandid);
      let payment_brand_id = normalizedBrandId;
      if (
        this.setbrandid === "BH2" ||
        this.$cookie.getCookie("search_origin") ===
          "jet2bhxlive.rezcomm.com" ||
        this.$cookie.getCookie("search_origin") ===
          "jet2.prebook.birminghamairport.co.uk" ||
        this.$cookie.getCookie("search_origin") === "localhost:7126"
      ) {
        payment_brand_id = "BHX";
        formData.append("partner_id", 49);
        formData.append("partner_name", "Jet2 Referral");
      }

      // Handle discount
      let totalfee = 0;
      if (this.getLocalDataoo("dis_cpk") === null) {
        formData.append("ordertotal", encryptStorage.getItem("tag_totcost"));
        totalfee = encryptStorage.getItem("tag_totcost");
        formData.append("discount_amount", "0.00");
        formData.append("voucher", "");
      } else {
        let discount_amount = encryptStorage.getItem("dis_cpk");
        let discount_coupon_applied = encryptStorage.getItem(
          "discount_coupon_applied"
        );
        totalfee =
          encryptStorage.getItem("finaltotalvalue_cpk") !== null
            ? encryptStorage.getItem("finaltotalvalue_cpk")
            : encryptStorage.getItem("tag_totcost");
        totalfee = parseFloat(totalfee);
        if (totalfee < 0) totalfee = 0;
        formData.append("ordertotal", totalfee);
        formData.append("discount_amount", discount_amount);
        formData.append("voucher", discount_coupon_applied);
      }

      if (typeof encryptStorage.getItem("booking_fee_hidden") !== "undefined") {
        formData.append(
          "booking_fee_hidden",
          encryptStorage.getItem("booking_fee_hidden")
        );
      } else {
        formData.append("booking_fee_hidden", "0");
      }
      if (
        typeof encryptStorage.getItem("booking_fee_name_hidden") !== "undefined"
      ) {
        formData.append(
          "booking_fee_name_hidden",
          encryptStorage.getItem("booking_fee_name_hidden")
        );
      } else {
        formData.append("booking_fee_name_hidden", "");
      }

      const sessionToken = await this.getSessionToken();
      const paymentSessionId = await this.getPaymentSessionToken();
      formData.append("SessionId", sessionToken);
      formData.append("payment_session_id", paymentSessionId);
      formData.append("orderreference", encryptStorage.getItem("order_ref"));
      formData.append("email_consent", this.email_consent);
      formData.append(
        "orderreference_wtpre",
        encryptStorage.getItem("orefwithoutprefix")
      );
      formData.append("slug", payment_brand_id);
      formData.append("product", "CPK");
      formData.append("login_type", "SE");
      formData.append("is_guest", this.create_account ? "N" : "Y");
      formData.append("guesttomember", this.guesttomember);
      formData.append("country", this.country);

      // Add UTM data
      formData.append("utm_source", this.$cookie.getCookie("utm_source"));
      formData.append("utm_campaign", this.$cookie.getCookie("utm_campaign"));
      formData.append("utm_medium", this.$cookie.getCookie("utm_medium"));
      formData.append("utm_partner", this.$cookie.getCookie("utm_partner"));

      
      formData.append("utm_sub_partner", this.$cookie.getCookie("utm_sub_partner"));
      formData.append("utm_term", this.$cookie.getCookie("utm_term"));
      formData.append("utm_content", this.$cookie.getCookie("utm_content"));
      formData.append("tinybird_session_id",this.$cookie.getCookie("session-id"));
      formData.append("search_analytics_id",encryptStorage.getItem("search_analytics_id"));


      formData.append("reason", this.reason);
      formData.append(
        "inboundFlight",
        this.inbound_flight_number
      );
      formData.append(
        "outboundFlight",
        this.outbound_flight_number
      );
      formData.append("destination", this.destination);
      formData.append("airline_number", this.airline_number);
      formData.append("select_airline", this.select_airline);

      // Send to SQS registration
      console.log("DEBUG: Calling SQS_Register_Live_V2 API for parking cart");

      // Debug FormData contents
      console.log("DEBUG: FormData contents:");
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}:`, value);
      }

      await this.registerSqsLiveV2(formData, "parking cart");

      encryptStorage.setItem("orderplaced", "yes");
    },

    getFasttrackItemsForOrderProcessing() {
      if (!this.fasttrack_cartitem || !Array.isArray(this.fasttrack_cartitem)) {
        return [];
      }

      const seenFasttrackItems = new Set();
      return this.fasttrack_cartitem.filter((fasttrackItem) => {
        const duplicateKey = [
          fasttrackItem.product_name,
          fasttrackItem.date_selected,
          fasttrackItem.date_selected_display,
          fasttrackItem.time_selected,
          fasttrackItem.venue_id,
          fasttrackItem.venue_select_name,
          fasttrackItem.ADL,
          fasttrackItem.CHD,
          fasttrackItem.INF,
          fasttrackItem.fasttracksubtotal,
        ]
          .map((value) =>
            value === null || typeof value === "undefined"
              ? ""
              : String(value).trim().toLowerCase()
          )
          .join("|");

        if (seenFasttrackItems.has(duplicateKey)) {
          console.warn(
            "DEBUG: Skipping duplicate fasttrack cart item for order processing:",
            fasttrackItem
          );
          return false;
        }

        seenFasttrackItems.add(duplicateKey);
        return true;
      });
    },

    async processFasttrackCart(fasttrackItemsToProcess) {
      this.persistGuestFlags();
      let thing = this;
      const fasttrackCartItems =
        fasttrackItemsToProcess || this.getFasttrackItemsForOrderProcessing();
      for (const fasttrack_cartitem_arrayItem of fasttrackCartItems) {
        let myFormsettings_fast = document.getElementById("payment-process");
        let formData_fast = new FormData(myFormsettings_fast);

        formData_fast.append("companyname", thing.companyname);
        formData_fast.append("title", thing.title);
        formData_fast.append("first_name", encodeURIComponent(thing.firstname));
        formData_fast.append("last_name", encodeURIComponent(thing.surname));
        formData_fast.append("mobilenumber", thing.mobilenumber);
        formData_fast.append(
          "fasttrack_tot_passengers",
          JSON.stringify(thing.fasttrack_tot_passengers)
        );
        formData_fast.append("email", thing.email);
        formData_fast.append("lang", thing.lang.toUpperCase());
        formData_fast.append("phonecode", thing.phonecode);
        formData_fast.append("post_code", encodeURIComponent(thing.postcode));
        formData_fast.append(
          "address_line_1",
          encodeURIComponent(thing.address)
        );
        formData_fast.append(
          "address_line_2",
          encodeURIComponent(thing.address_line_2)
        );
        formData_fast.append("city", encodeURIComponent(thing.town));
        formData_fast.append("state", encodeURIComponent(thing.state));
        formData_fast.append(
          "vehicle_vrn",
          encodeURIComponent(thing.vehicle_vrn)
        );
        formData_fast.append(
          "term_condition",
          encodeURIComponent(thing.term_condition)
        );
        formData_fast.append(
          "cart",
          JSON.stringify(fasttrack_cartitem_arrayItem)
        );
        formData_fast.append("orderstatus", "Pending");
        formData_fast.append("paymentstatus", "Pending");
        formData_fast.append(
          "partner_id",
          this.$cookie.getCookie("partner_id")
        );
        formData_fast.append(
          "partner_name",
          this.$cookie.getCookie("partner_name")
        );
formData_fast.append("email_consent_oth_email",thing.email_consent_oth_email);
formData_fast.append("email_consent_oth_manage",thing.email_consent_oth_manage);
formData_fast.append("oth_email", thing.oth_email);
formData_fast.append("bookingfor", thing.bookingfor);   
        // Handle discount
        let totalfee = 0;
        if (thing.getLocalDataoo("dis_ftt") === null) {
          formData_fast.append(
            "ordertotal",
            fasttrack_cartitem_arrayItem.fasttracksubtotal
          );
          totalfee = fasttrack_cartitem_arrayItem.fasttracksubtotal;
          formData_fast.append("discount_amount", "0.00");
          formData_fast.append("voucher", "");
        } else {
          let disftt_arr = encryptStorage.getItem("disftt_arr");
          let disamt =
            disftt_arr["ftt" + fasttrack_cartitem_arrayItem.product_id]
              ?.discount_amount || 0;

          // Calculate final total after discount
          let originalAmount = parseFloat(
            fasttrack_cartitem_arrayItem.fasttracksubtotal
          );
          let discountAmount = parseFloat(disamt);
          totalfee = originalAmount - discountAmount;
          if (totalfee < 0) totalfee = 0;

          formData_fast.append("ordertotal", totalfee.toFixed(2));
          formData_fast.append("discount_amount", disamt);
          formData_fast.append(
            "voucher",
            encryptStorage.getItem("discount_coupon_applied")
          );
        }

        const sessionToken = await thing.getSessionToken();
        const paymentSessionId = await thing.getPaymentSessionToken();
        formData_fast.append("SessionId", sessionToken);
        formData_fast.append("payment_session_id", paymentSessionId);
        formData_fast.append(
          "orderreference",
          fasttrack_cartitem_arrayItem.ftt_order_ref +
            "-" +
            Math.floor(Math.random() * 10)
        );
        formData_fast.append(
          "orderreference_wtpre",
          encryptStorage.getItem("orefwithoutprefix")
        );
        formData_fast.append("email_consent", thing.email_consent);
        formData_fast.append("slug", thing.setbrandid);
        formData_fast.append("product", "FTT");
        formData_fast.append("login_type", "SE");
        formData_fast.append(
          "is_guest",
          thing.create_account ? "N" : "Y"
        );
        formData_fast.append("guesttomember", thing.guesttomember);
        formData_fast.append("country", thing.country);

        // Add UTM data
        formData_fast.append(
          "utm_source",
          thing.$cookie.getCookie("utm_source")
        );
        formData_fast.append(
          "utm_campaign",
          thing.$cookie.getCookie("utm_campaign")
        );
        formData_fast.append(
          "utm_medium",
          thing.$cookie.getCookie("utm_medium")
        );
        formData_fast.append(
          "utm_partner",
          thing.$cookie.getCookie("utm_partner")
        );

      formData_fast.append("utm_sub_partner", thing.$cookie.getCookie("utm_sub_partner"));
      formData_fast.append("utm_term", thing.$cookie.getCookie("utm_term"));
      formData_fast.append("utm_content", thing.$cookie.getCookie("utm_content"));
      formData_fast.append("tinybird_session_id",thing.$cookie.getCookie("session-id"));
      formData_fast.append("search_analytics_id",encryptStorage.getItem("search_analytics_id"));        

        formData_fast.append("reason", thing.reason);
        formData_fast.append(
          "inboundFlight",
          thing.inbound_flight_number
        );
        formData_fast.append(
          "outboundFlight",
          thing.outbound_flight_number
        );
        formData_fast.append("destination", thing.destination);
        formData_fast.append("airline_number", thing.airline_number);
        formData_fast.append("select_airline", thing.select_airline);

        // Send to SQS registration
        console.log("DEBUG: Calling SQS_Register_Live_V2 API for fasttrack cart");

        await thing.registerSqsLiveV2(formData_fast, "fasttrack cart");
      }
    },

    async processLoungeCart() {
      this.persistGuestFlags();
      let thingu = this;
      let myFormsettings_lng = document.getElementById("payment-process");
      let formData_lng = new FormData(myFormsettings_lng);

      formData_lng.append("companyname", thingu.companyname);
      formData_lng.append("title", thingu.title);
      formData_lng.append("first_name", encodeURIComponent(thingu.firstname));
      formData_lng.append("last_name", encodeURIComponent(thingu.surname));
      formData_lng.append("mobilenumber", thingu.mobilenumber);
      formData_lng.append("email", thingu.email);
      formData_lng.append("lang", thingu.lang.toUpperCase());
      formData_lng.append("phonecode", thingu.phonecode);
      formData_lng.append("post_code", encodeURIComponent(thingu.postcode));
      formData_lng.append("address_line_1", encodeURIComponent(thingu.address));
      formData_lng.append(
        "address_line_2",
        encodeURIComponent(thingu.address_line_2)
      );
      formData_lng.append("city", encodeURIComponent(thingu.town));
      formData_lng.append("state", encodeURIComponent(thingu.state));
      formData_lng.append(
        "vehicle_vrn",
        encodeURIComponent(thingu.vehicle_vrn)
      );
      formData_lng.append(
        "term_condition",
        encodeURIComponent(thingu.term_condition)
      );
      formData_lng.append(
        "cart",
        JSON.stringify(encryptStorage.getItem("lounge_cart"))
      );
      formData_lng.append("orderstatus", "Pending");
      formData_lng.append("paymentstatus", "Pending");
      formData_lng.append("partner_id", this.$cookie.getCookie("partner_id"));
      formData_lng.append(
        "partner_name",
        this.$cookie.getCookie("partner_name")
      );

formData_lng.append("email_consent_oth_email",thingu.email_consent_oth_email);
formData_lng.append("email_consent_oth_manage",thingu.email_consent_oth_manage);      
formData_lng.append("oth_email", thingu.oth_email);
formData_lng.append("bookingfor", thingu.bookingfor);   

      // Handle discount
      let totalfee = 0;
      const loungeDiscountRaw = encryptStorage.getItem("dis_lng");
      const hasLoungeDiscount =
        loungeDiscountRaw !== null &&
        typeof loungeDiscountRaw !== "undefined" &&
        !Number.isNaN(parseFloat(loungeDiscountRaw)) &&
        parseFloat(loungeDiscountRaw) > 0;

      if (!hasLoungeDiscount) {
        formData_lng.append(
          "ordertotal",
          thingu.lounge_cartitem.loungesubtotal
        );
        totalfee = thingu.lounge_cartitem.loungesubtotal;
        formData_lng.append("discount_amount", "0.00");
        formData_lng.append("voucher", "");
      } else {
        let discount_amount = parseFloat(loungeDiscountRaw);

        // Calculate final total after discount (same logic as FTT)
        let originalAmount = parseFloat(thingu.lounge_cartitem.loungesubtotal);
        let discountAmount = parseFloat(discount_amount || 0);
        totalfee = originalAmount - discountAmount;
        if (totalfee < 0) totalfee = 0;

        formData_lng.append("ordertotal", totalfee.toFixed(2));
        formData_lng.append("discount_amount", discount_amount.toFixed(2));
        formData_lng.append(
          "voucher",
          encryptStorage.getItem("discount_coupon_applied")
        );
      }

      const sessionToken = await thingu.getSessionToken();
      const paymentSessionId = await thingu.getPaymentSessionToken();
      formData_lng.append("SessionId", sessionToken);
      formData_lng.append("payment_session_id", paymentSessionId);
      formData_lng.append(
        "orderreference",
        encryptStorage.getItem("lng_order_ref")
      );
      formData_lng.append(
        "orderreference_wtpre",
        encryptStorage.getItem("orefwithoutprefix")
      );
      formData_lng.append("email_consent", thingu.email_consent);
      formData_lng.append("slug", thingu.setbrandid);
      formData_lng.append("product", "LNG");
      formData_lng.append("login_type", "SE");
      formData_lng.append(
        "is_guest",
        thingu.create_account ? "N" : "Y"
      );
      formData_lng.append("guesttomember", thingu.guesttomember);
      formData_lng.append("country", thingu.country);

      // Add UTM data
      formData_lng.append("utm_source", thingu.$cookie.getCookie("utm_source"));
      formData_lng.append(
        "utm_campaign",
        thingu.$cookie.getCookie("utm_campaign")
      );
      formData_lng.append("utm_medium", thingu.$cookie.getCookie("utm_medium"));
      formData_lng.append(
        "utm_partner",
        thingu.$cookie.getCookie("utm_partner")
      );

      formData_lng.append("utm_sub_partner", thingu.$cookie.getCookie("utm_sub_partner"));
      formData_lng.append("utm_term", thingu.$cookie.getCookie("utm_term"));
      formData_lng.append("utm_content", thingu.$cookie.getCookie("utm_content"));
      formData_lng.append("tinybird_session_id",thingu.$cookie.getCookie("session-id"));
      formData_lng.append("search_analytics_id",encryptStorage.getItem("search_analytics_id"));      

      formData_lng.append("reason", thingu.reason);
      formData_lng.append(
        "inboundFlight",
        thingu.inbound_flight_number
      );
      formData_lng.append(
        "outboundFlight",
        thingu.outbound_flight_number
      );
      formData_lng.append("destination", thingu.destination);
      formData_lng.append("airline_number", thingu.airline_number);
      formData_lng.append("select_airline", thingu.select_airline);

      // Send to SQS registration
      console.log("DEBUG: Calling SQS_Register_Live_V2 API for lounge cart");

      await this.registerSqsLiveV2(formData_lng, "lounge cart");
    },

    async processCoachCart() {
      this.persistGuestFlags();
      let thingcoach = this;
      let myFormsettings_coach = document.getElementById("payment-process");
      let formData_coach = new FormData(myFormsettings_coach);

      formData_coach.append("companyname", thingcoach.companyname);
      formData_coach.append("title", thingcoach.title);
      formData_coach.append(
        "first_name",
        encodeURIComponent(thingcoach.firstname)
      );
      formData_coach.append(
        "last_name",
        encodeURIComponent(thingcoach.surname)
      );
      formData_coach.append("mobilenumber", thingcoach.mobilenumber);
      formData_coach.append("email", thingcoach.email);
      formData_coach.append("lang", thingcoach.lang.toUpperCase());
      formData_coach.append("phonecode", thingcoach.phonecode);
      formData_coach.append(
        "post_code",
        encodeURIComponent(thingcoach.postcode)
      );
      formData_coach.append(
        "address_line_1",
        encodeURIComponent(thingcoach.address)
      );
      formData_coach.append(
        "address_line_2",
        encodeURIComponent(thingcoach.address_line_2)
      );
      formData_coach.append("city", encodeURIComponent(thingcoach.town));
      formData_coach.append("state", encodeURIComponent(thingcoach.state));
      formData_coach.append(
        "vehicle_vrn",
        encodeURIComponent(thingcoach.vehicle_vrn)
      );
      formData_coach.append(
        "term_condition",
        encodeURIComponent(thingcoach.term_condition)
      );
      formData_coach.append(
        "email_consent_oth_email",
        thingcoach.email_consent_oth_email
      );
      formData_coach.append(
        "email_consent_oth_manage",
        thingcoach.email_consent_oth_manage
      );
      formData_coach.append("oth_email", thingcoach.oth_email);
      formData_coach.append("bookingfor", thingcoach.bookingfor);
      formData_coach.append(
        "cart",
        JSON.stringify(encryptStorage.getItem("coach_cart"))
      );
      formData_coach.append("orderstatus", "Pending");
      formData_coach.append("paymentstatus", "Pending");
      formData_coach.append(
        "partner_id",
        thingcoach.$cookie.getCookie("partner_id")
      );
      formData_coach.append(
        "partner_name",
        thingcoach.$cookie.getCookie("partner_name")
      );

      // Handle discount
      let totalfee = 0;
      if (thingcoach.getLocalDataoo("dis_chp") === null) {
        formData_coach.append(
          "ordertotal",
          thingcoach.coach_cartitem.coachsubtotal
        );
        totalfee = thingcoach.coach_cartitem.coachsubtotal;
        formData_coach.append("discount_amount", "0.00");
        formData_coach.append("voucher", "");
      } else {
        let discount_amount = encryptStorage.getItem("dis_chp");
        let discount_coupon_applied = encryptStorage.getItem(
          "discount_coupon_applied"
        );

        totalfee =
          encryptStorage.getItem("finaltotalvalue_chp") === null
            ? thingcoach.coach_cartitem.coachsubtotal
            : encryptStorage.getItem("finaltotalvalue_chp");
        totalfee = parseFloat(totalfee);
        if (totalfee < 0) {
          totalfee = 0;
        }

        formData_coach.append("ordertotal", totalfee);
        formData_coach.append("discount_amount", discount_amount);
        formData_coach.append("voucher", discount_coupon_applied);
      }

      const sessionToken = await thingcoach.getSessionToken();
      const paymentSessionId = await thingcoach.getPaymentSessionToken();
      formData_coach.append("SessionId", sessionToken);
      formData_coach.append("payment_session_id", paymentSessionId);
      formData_coach.append(
        "orderreference",
        encryptStorage.getItem("coa_order_ref")
      );
      formData_coach.append(
        "orderreference_wtpre",
        encryptStorage.getItem("orefwithoutprefix")
      );
      formData_coach.append("email_consent", thingcoach.email_consent);
      formData_coach.append("slug", thingcoach.setbrandid);
      formData_coach.append("product", "COA");
      formData_coach.append("login_type", "SE");
      formData_coach.append(
        "is_guest",
        thingcoach.create_account ? "N" : "Y"
      );
      formData_coach.append("guesttomember", thingcoach.guesttomember);
      formData_coach.append("country", thingcoach.country);

      formData_coach.append(
        "coach_drivers",
        JSON.stringify(thingcoach.coach_drivers)
      );
      formData_coach.append("reason", thingcoach.reason);
      formData_coach.append(
        "inboundFlight",
        thingcoach.inbound_flight_number
      );
      formData_coach.append(
        "outboundFlight",
        thingcoach.outbound_flight_number
      );
      formData_coach.append("destination", thingcoach.destination);
      formData_coach.append("airline_number", thingcoach.airline_number);
      formData_coach.append("select_airline", thingcoach.select_airline);

      // Add UTM data
      formData_coach.append(
        "utm_source",
        thingcoach.$cookie.getCookie("utm_source")
      );
      formData_coach.append(
        "utm_campaign",
        thingcoach.$cookie.getCookie("utm_campaign")
      );
      formData_coach.append(
        "utm_medium",
        thingcoach.$cookie.getCookie("utm_medium")
      );
      formData_coach.append(
        "utm_partner",
        thingcoach.$cookie.getCookie("utm_partner")
      );

      formData_coach.append("utm_sub_partner", thingcoach.$cookie.getCookie("utm_sub_partner"));
      formData_coach.append("utm_term", thingcoach.$cookie.getCookie("utm_term"));
      formData_coach.append("utm_content", thingcoach.$cookie.getCookie("utm_content"));
      formData_coach.append("tinybird_session_id",thingcoach.$cookie.getCookie("session-id"));
      formData_coach.append("search_analytics_id",encryptStorage.getItem("search_analytics_id"));        

      // Send to SQS registration
      console.log("DEBUG: Calling SQS_Register_Live_V2 API for coach cart");

      await this.registerSqsLiveV2(formData_coach, "coach cart");
    },

    calculateFasttrackTotal(fasttrackItemsToProcess) {
      let totalfee = 0;
      const fasttrackCartItems =
        fasttrackItemsToProcess || this.getFasttrackItemsForOrderProcessing();
      console.log(
        "🔍 DEBUG: calculateFasttrackTotal - checking discount:",
        this.getLocalDataoo("dis_ftt")
      );
      console.log(
        "🔍 DEBUG: calculateFasttrackTotal - fasttrack_cartitem:",
        fasttrackCartItems
      );
      console.log(
        "🔍 DEBUG: calculateFasttrackTotal - fasttrack_cartitem type:",
        typeof fasttrackCartItems
      );
      console.log(
        "🔍 DEBUG: calculateFasttrackTotal - fasttrack_cartitem is array:",
        Array.isArray(fasttrackCartItems)
      );
      console.log(
        "🔍 DEBUG: calculateFasttrackTotal - fasttrack_cartitem length:",
        fasttrackCartItems?.length
      );

      // Check if fasttrack_cartitem exists and is an array
      if (!fasttrackCartItems || !Array.isArray(fasttrackCartItems)) {
        console.log(
          "🔍 DEBUG: calculateFasttrackTotal - no valid fasttrack items"
        );
        return 0;
      }

      if (this.getLocalDataoo("dis_ftt") === null) {
        console.log("🔍 DEBUG: calculateFasttrackTotal - no discount applied");
        fasttrackCartItems.forEach(function (
          fasttrack_cartitem_arrayItem
        ) {
          let itemTotal = parseFloat(
            fasttrack_cartitem_arrayItem.fasttracksubtotal || 0
          );
          console.log(
            "🔍 DEBUG: calculateFasttrackTotal - item subtotal:",
            itemTotal
          );
          totalfee += itemTotal;
        });
      } else {
        console.log("🔍 DEBUG: calculateFasttrackTotal - discount applied");
        let finaltotalvalue_ftt = encryptStorage.getItem("finaltotalvalue_ftt");
        console.log(
          "🔍 DEBUG: calculateFasttrackTotal - finaltotalvalue_ftt:",
          finaltotalvalue_ftt
        );

        fasttrackCartItems.forEach(function (
          fasttrack_cartitem_arrayItem
        ) {
          let fttfinalamount = fasttrack_cartitem_arrayItem.fasttracksubtotal; // Default to original amount

          // Check if discount data exists and has the correct structure
          if (finaltotalvalue_ftt && typeof finaltotalvalue_ftt === "object") {
            let productKey = "ftt" + fasttrack_cartitem_arrayItem.product_id;
            if (
              finaltotalvalue_ftt[productKey] &&
              typeof finaltotalvalue_ftt[productKey].finalamount !== "undefined"
            ) {
              fttfinalamount = finaltotalvalue_ftt[productKey].finalamount;
              console.log(
                "🔍 DEBUG: calculateFasttrackTotal - found discount for product",
                productKey,
                ":",
                fttfinalamount
              );
            } else {
              console.log(
                "🔍 DEBUG: calculateFasttrackTotal - no discount found for product",
                productKey,
                ", using original amount"
              );
            }
          }

          let itemTotal = parseFloat(fttfinalamount);
          console.log(
            "🔍 DEBUG: calculateFasttrackTotal - discounted item total:",
            itemTotal
          );
          totalfee += itemTotal;
        });
      }

      console.log("🔍 DEBUG: calculateFasttrackTotal - final total:", totalfee);
      return totalfee;
    },

    calculateLoungeTotal() {
      let totalfee = 0;
      console.log(
        "🔍 DEBUG: calculateLoungeTotal - lounge_cartitem:",
        this.lounge_cartitem
      );
      console.log(
        "🔍 DEBUG: calculateLoungeTotal - loungesubtotal:",
        this.lounge_cartitem?.loungesubtotal
      );

      // Check if lounge_cartitem has actual data
      if (!this.lounge_cartitem || !this.lounge_cartitem.loungesubtotal) {
        console.log("🔍 DEBUG: calculateLoungeTotal - no valid lounge data");
        return 0;
      }

      const loungeDiscountRaw = encryptStorage.getItem("dis_lng");
      const hasLoungeDiscount =
        loungeDiscountRaw !== null &&
        typeof loungeDiscountRaw !== "undefined" &&
        !Number.isNaN(parseFloat(loungeDiscountRaw)) &&
        parseFloat(loungeDiscountRaw) > 0;

      if (!hasLoungeDiscount) {
        totalfee = this.lounge_cartitem.loungesubtotal;
      } else {
        const finalLoungeTotal = encryptStorage.getItem("finaltotalvalue_lng");
        totalfee =
          finalLoungeTotal !== null &&
          typeof finalLoungeTotal !== "undefined" &&
          !Number.isNaN(parseFloat(finalLoungeTotal))
            ? parseFloat(finalLoungeTotal)
            : parseFloat(this.lounge_cartitem.loungesubtotal) -
              parseFloat(loungeDiscountRaw);
      }
      console.log("🔍 DEBUG: calculateLoungeTotal - final total:", totalfee);
      return parseFloat(totalfee);
    },

    calculateCoachTotal() {
      let totalfee = 0;
      console.log(
        "🔍 DEBUG: calculateCoachTotal - coach_cartitem:",
        this.coach_cartitem
      );
      console.log(
        "🔍 DEBUG: calculateCoachTotal - coachsubtotal:",
        this.coach_cartitem?.coachsubtotal
      );

      if (!this.coach_cartitem || !this.coach_cartitem.coachsubtotal) {
        console.log("🔍 DEBUG: calculateCoachTotal - no valid coach data");
        return 0;
      }

      if (this.getLocalDataoo("dis_chp") === null) {
        totalfee = this.coach_cartitem.coachsubtotal;
      } else {
        totalfee =
          encryptStorage.getItem("finaltotalvalue_chp") ||
          this.coach_cartitem.coachsubtotal;
      }
      console.log("🔍 DEBUG: calculateCoachTotal - final total:", totalfee);
      return parseFloat(totalfee);
    },

    generateSessionToken() {
      const timestamp = Date.now().toString(36);
      const randomBytes = crypto.randomBytes(16).toString("hex");
      const combined = timestamp + randomBytes;
      return crypto
        .createHash("sha256")
        .update(combined, "utf-8")
        .digest("hex");
    },

    async getSessionToken() {
      try {
        // Make API call to get session token from HttpOnly cookie
        const response = await apiProxy.call("get_session_token");
        if (response && response.session_token) {
          // Mirror HttpOnly session into a readable cookie for this browser session
          document.cookie = `session_id=${response.session_token}; path=/; max-age=86400; SameSite=Lax`;
          apiProxy.currentSessionToken = response.session_token;
          return response.session_token;
        }
      } catch (error) {
        console.log(
          "No session token available, generating new one for order tracking"
        );
      }

      // Fallback: generate new session token for order tracking
      return this.generateSessionToken();
    },

    async getPaymentSessionToken() {
      if (!this.payment_session_id) {
        this.payment_session_id = this.generateSessionToken();
      }
      return this.payment_session_id;
    },

    getLocalDataoo(name) {
      return sessionStorage.getItem(name);
    },

    // LAX Windcave PSP Methods
    preslotconfirm(total, uuid, orderreference) {
      console.log("🔍 DEBUG: preslotconfirm called with:", {
        total,
        uuid,
        orderreference,
      });
      console.log("🔍 DEBUG: cpkincart:", this.cpkincart);
      console.log("🔍 DEBUG: Total type:", typeof total, "Value:", total);
      console.log("🔍 DEBUG: Total <= 0 check:", total <= 0);

      if (this.cpkincart) {
        Swal.fire(
          "Info!",
          this.getrans(
            "Please wait, we are validating availability one final time."
          ),
          "info"
        );

        setTimeout(() => {
          Swal.close();
        }, 2000);
        let cc = encryptStorage.getItem("cart");
        let datafor_preconfirm = {
          venue_id: cc.venue_id,
          brand_id: normalizeBrandId(this.setbrandid),
          booking_ref_id: cc.booking_ref_id,
          uuid: uuid,
        };

        apiProxy.call("parking_slot_pre_confirm", datafor_preconfirm).then(
          (response) => {
            if (response.user_exists == "Y") {
              // For PB1, use preorderconfirm with retry logic
              if (this.setbrandid == "PB1") {
                setTimeout(() => {
                  this.preorderconfirm(
                    total,
                    this.getLocalData("uuid"),
                    encryptStorage.getItem("orefwithoutprefix"),
                    0
                  );
                }, 5000);
              } else {
                // Check for zero value order before routing to payment
                console.log(
                  "🔍 DEBUG: CPK cart - checking total for zero value:",
                  total
                );
                if (total <= 0) {
                  console.log("🔍 DEBUG: CPK cart - routing to zerovalueorder");
                  this.zerovalueorder(orderreference);
                } else {
                  console.log("🔍 DEBUG: CPK cart - routing to payment");
                  this.routeToPayment(total, uuid, orderreference);
                }
              }
            } else {
              //show alert order cannot be processed, delete cart
              Swal.fire(
                "Error!",
                "Sorry, there are no more slots available for the duration you are searching on this car park, please try your search again",
                "error"
              ).then(() => {
                this.resetpromocode();
              });
            }
          },
          (error) => {
            this.loading_proceed = false;
            console.log(error);
          }
        );
      } else {
        //process order, hide popup
        console.log("🔍 DEBUG: No CPK cart - processing FTT/LNG only order");
        setTimeout(() => {
          // Check for zero value order before routing to payment
          console.log(
            "🔍 DEBUG: FTT/LNG only - checking total for zero value:",
            total
          );
          if (total <= 0) {
            console.log("🔍 DEBUG: FTT/LNG only - routing to zerovalueorder");
            this.zerovalueorder(orderreference);
          } else {
            console.log("🔍 DEBUG: FTT/LNG only - routing to payment");
            this.routeToPayment(total, uuid, orderreference);
          }
        }, 2000);
      }
    },

    preorderconfirm(total, uuid, orderreference, cn) {
      Swal.fire(
        "Info!",
        "Please wait, we are validating your request.",
        "info"
      );
      let datafor_preorder = {
        slug: normalizeBrandId(this.setbrandid),
        orderreference_wtpre: orderreference,
      };

      apiProxy.call("order_check_live", datafor_preorder).then((response) => {
        let totalrecs = response.total[0].cn;
        console.log("totalrecs", totalrecs);
        console.log("cn", cn);
        if (totalrecs == 0 && cn < 6) {
          cn++;
          setTimeout(() => {
            this.preorderconfirm(total, uuid, orderreference, cn);
          }, 2000);
        } else if (totalrecs == 0 && cn >= 6) {
          Swal.close();
          Swal.fire(
            "Info!",
            "There seems to be a problem confirming your reservation, please submit your request one more time.",
            "info"
          );
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else if (totalrecs > 0) {
          let totaloval = response.ot[0].ordertotal;
          if (totaloval != total) {
            total = totaloval;
          }
          console.log("Total amount:", total);

          if (total <= 0) {
            // Zero value order process
            this.zerovalueorder(orderreference);
          } else {
            this.routeToPayment(
              total,
              this.getLocalData("uuid"),
              encryptStorage.getItem("orefwithoutprefix")
            );
          }
        }
      });
    },

    routeToPayment(total, uuid, orderreference) {
      console.log(
        "Routing to payment provider:",
        this.brandConfig?.paymentProvider
      );
      console.log("Brand code:", this.setbrandid);
      console.log("Payment details:", { total, uuid, orderreference });
      console.log(
        "🔍 DEBUG: routeToPayment called with total:",
        total,
        "type:",
        typeof total
      );
      console.log("🔍 DEBUG: routeToPayment - total <= 0 check:", total <= 0);
      console.log(
        "🔍 DEBUG: routeToPayment - parseFloat(total) <= 0 check:",
        parseFloat(total) <= 0
      );

      const paymentProvider = this.brandConfig?.paymentProvider;

      // Route based on brand code for specific implementations
      if (["LAX", "RSW"].includes(this.setbrandid)) {
        console.log("Processing LAX/RSW Windcave payment");
        this.showpaymentwindcave(orderreference);
      } else if (this.setbrandid === "PB1") {
        console.log("Processing PB1 First Pay payment");
        this.showpayment_first(total, uuid, orderreference);
      } else if (this.setbrandid === "IP1") {
        console.log("Processing IP1 EVO payment");
        this.showpayment_evo(total, uuid, orderreference);
      } else if (paymentProvider === "JCC" || this.setbrandid === "HER") {
        console.log("Processing JCC payment");
        this.processJCCPayment({ total, uuid, orderreference });
      } else if (paymentProvider === "NAB" || this.setbrandid === "DRW") {
        console.log("Processing NAB payment");
        this.processNABPayment();
      } else if (
        paymentProvider === "stripe" ||
        ["PIT", "HVN", "SZG", "NOC", "SV1", "ML1", "GSO", "ST1"].includes(
          this.setbrandid
        )
      ) {
        console.log("Processing Stripe payment");
        this.processStripePayment({ total, uuid, orderreference });
      } else if (paymentProvider === "advam" || this.setbrandid === "BFS") {
        console.log("Processing Advam payment");
        this.showpayment_advam(total, uuid, orderreference);
      } else if (paymentProvider === "authipay" || this.setbrandid === "LDY") {
        console.log("Processing Authipay payment");
        this.showpayment_authipay(total, uuid, orderreference);
      } else if (
        paymentProvider === "payone" ||
        ["FMM", "FM1"].includes(this.setbrandid)
      ) {
        console.log("Processing Payone payment");
        this.showpayment_payone(total, uuid, orderreference);
      } else if (paymentProvider === "NMI" || this.setbrandid === "NQY"  || normalizeBrandId(this.setbrandid) === "SB2") {
        console.log("Processing NMI payment");
        this.showpayment_nmi(total, uuid, orderreference);
      } else if (this.setbrandid === "JER") {
        console.log("Processing JER NMI payment with CollectJS");
        this.nmipayment_gpay_apay(total, uuid, orderreference);
      } else {
        console.log("Using default JCC payment for brand:", this.setbrandid);
        this.processJCCPayment({ total, uuid, orderreference });
      }
    },

    showpayment_nmi(total, uuid, orderreference) {
      Swal.fire(
        "Info!",
        "Please wait, redirecting to payment gateway to complete your payment",
        "info"
      );

      let chdata =
        process.env.VUE_APP_CHL_USD +
        this.setbrandid.toLowerCase() +
        orderreference +
        uuid +
        total;
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      this.final_amount = total;
      this.transaction_token = transaction_token;
      this.final_orderreference = orderreference;
      this.final_uuid = uuid;
      encryptStorage.setItem("final_uuid", this.final_uuid);
      encryptStorage.setItem("final_orderreference", this.final_orderreference);
      this.loading_proceed = false;
      this.registeristrue = false;
      this.loginistrue = false;
      let nmigateway  = '';
      if(this.setbrandid=='JER'){nmigateway = 'https://securepayservice.prebooking-newquaycornwallairport.com/stagingprocess.php';}
      if(this.setbrandid=='SB2' || this.setbrandid=='SB3' || this.setbrandid=='SB4' || this.setbrandid=='SB5'){
        nmigateway = 'https://devhub.rezcomm.com/hubapmydbauth/sb2livenmi/';
      }
      
let success_url= this.brandConfig?.successUrl || `${window.location.origin}/confirmation.html`;
let failure_url= this.brandConfig?.failureUrl || `${window.location.origin}/failure.html`;

      let nmi3dsform_el =
        '<form id="nmi3dsform" method="post" action="'+nmigateway+'">';
      nmi3dsform_el +=
        '<input type="hidden" name="firstname" value="' + this.firstname + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="lastname" value="' + this.surname + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="email" value="' + this.email + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="final_amount" value="' + total + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="final_uuid" value="' +
        this.final_uuid +
        '">';
      nmi3dsform_el +=
        '<input type="hidden" name="final_orderreference" value="' +
        this.final_orderreference +
        '">';
      nmi3dsform_el +=
        '<input type="hidden" name="transaction_token" value="' +
        this.transaction_token +
        '">';
      nmi3dsform_el +=
        '<input type="hidden" name="brand_id" value="' + this.setbrandid + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="phone" value="' + this.mobilenumber + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="city" value="' + this.town + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="state" value="' + this.state + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="address1" value="' + this.address + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="postalCode" value="' + this.postcode + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="success_url" value="' + success_url + '">';
      nmi3dsform_el +=
        '<input type="hidden" name="failure_url" value="' + failure_url + '">';
      nmi3dsform_el += "</form>";
      this.formdata_payform = nmi3dsform_el;
      setTimeout(function () {
        document.getElementById("nmi3dsform").submit();
      }, 1000);
    },

    async showpayment_first(total, uuid, orderreference) {
      this.loading_proceed = true;

      // Generate transaction token like original PB1
      let chdata =
        process.env.VUE_APP_CHL_YHM +
        this.setbrandid.toLowerCase() +
        orderreference +
        (total * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", total);

      let pspdata = {
        amount: (total * 100).toFixed(),
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        currency: "EUR",
        signature: transaction_token,
        ref: orderreference,
        user_guid: uuid,
        first_name: this.firstname,
        last_name: this.surname,
        country: "DE",
        cart: JSON.stringify(encryptStorage.getItem("cart")),
        success_url:
          this.brandConfig?.successUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/confirmation.html`,
        failure_url:
          this.brandConfig?.failureUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/failure.html`,
      };

      try {
        const response = await apiProxy.call("first_payment_session", pspdata);
        let codesent = response;
        let target_url = codesent.target_url;

        setTimeout(function () {
          window.location.href = target_url;
        }, 3000);
      } catch (error) {
        this.loading_proceed = false;
        console.error("First Pay payment error:", error);
      }
    },

    async showpayment_evo(total, uuid, orderreference) {
      this.loading_proceed = true;

      let chdata =
        process.env.VUE_APP_CHL_USD +
        this.setbrandid.toLowerCase() +
        orderreference +
        total * 100;
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", total);

      let pspdata = {
        amount: total * 100,
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        signature: transaction_token,
        currency: "GBP",
        ref: orderreference,
        user_guid: uuid,
        success_url:
          this.brandConfig?.successUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/confirmation.html`,
        failure_url:
          this.brandConfig?.failureUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/failure.html`,
      };

      try {
        const response = await apiProxy.call("evo_payment_session", pspdata);
        let codesent = response;
        let target_url = codesent.target_url;

        setTimeout(function () {
          window.location.href = target_url;
        }, 3000);
      } catch (error) {
        this.loading_proceed = false;
        console.error("EVO payment error:", error);
      }
    },

    zerovalueorder(orderreference) {
      console.log(
        "🔍 DEBUG: zerovalueorder called with orderreference:",
        orderreference
      );
      encryptStorage.setItem("final_amount_paid", 0);

      let formData = {
        slug: normalizeBrandId(this.setbrandid),
        orderreference: orderreference,
        uuid: this.getLocalData("uuid"),
        amount: "0.00",
      };

      console.log(
        "🔍 DEBUG: zerovalueorder - calling live_order_process with:",
        formData
      );

      apiProxy
        .call("live_order_process", formData)
        .then((response) => {
          console.log(
            "🔍 DEBUG: zerovalueorder - live_order_process response:",
            response
          );
          encryptStorage.setItem("orderplaced", "yes");
          console.log("🔍 DEBUG: zerovalueorder - redirecting to confirmation");
          window.location.href = "/confirmation.html";
        })
        .catch((error) => {
          console.error(
            "🔍 DEBUG: zerovalueorder - live_order_process error:",
            error
          );
          this.loading_proceed = false;
        });
    },

    async processStripePayment({ total, uuid, orderreference }) {
      console.log("Processing Stripe payment", { total, uuid, orderreference });
      console.log("DEBUG: Received total from parameter:", total);
      console.log(
        "DEBUG: Current basket total from component:",
        this.finaltotalvalue
      );
      console.log(
        "DEBUG: Stored final_amount_paid:",
        encryptStorage.getItem("final_amount_paid")
      );
      console.log(
        "DEBUG: Applied discount amount:",
        encryptStorage.getItem("discount_amount")
      );
      console.log(
        "DEBUG: Applied promo code:",
        encryptStorage.getItem("discount_coupon_applied")
      );

      // Use the basket total instead of parameter if different
      const actualTotal = this.finaltotalvalue || total;
      console.log("DEBUG: Using actual total for payment:", actualTotal);

      // Check for zero value order
      if (parseFloat(actualTotal) === 0) {
        console.log("DEBUG: Zero value order detected, calling zerovalueorder");
        this.zerovalueorder(orderreference);
        return;
      }

      const payment_brand_id = normalizeBrandId(this.setbrandid);
      this.loading_proceed = true;
      let chdata =
        process.env.VUE_APP_CHL_YHM +
        payment_brand_id.toLowerCase() +
        orderreference +
        (actualTotal * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", actualTotal);

      // Get currency code based on brand configuration
      const getCurrencyCode = (currencySymbol) => {
        const currencyMap = {
          $: "USD",
          "£": "GBP",
          "€": "EUR",
        };
        return currencyMap[currencySymbol] || "USD";
      };

      const paymentSessionId = await this.getPaymentSessionToken();

      const stripeData = {
        amount: (actualTotal * 100).toFixed(),
        brand_id: payment_brand_id.toLowerCase(),
        product_id: "CPK",
        currency: getCurrencyCode(this.brandConfig?.currency),
        signature: transaction_token,
        ref: orderreference,
        payment_session_id: paymentSessionId,
        user_guid: uuid,
        first_name: this.firstname,
        last_name: this.surname,
        success_url:
          this.brandConfig?.stripe?.successUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/confirmation.html`,
        failure_url:
          this.brandConfig?.stripe?.failureUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/failure.html`,
        embedded: this.brandConfig?.features?.stripeEmbedded ? "Y" : "N",
      };

      try {
        console.log("Calling Stripe Session API with data:", stripeData);
        const stripeResponse = await apiProxy.call(
          "stripe_session",
          stripeData
        );
        console.log("Stripe Session API response:", stripeResponse);

        if (stripeResponse && stripeResponse.client_secret) {
          if (this.brandConfig?.features?.stripeEmbedded) {
            // Setup embedded Stripe checkout
            this.setupStripeEmbeddedCheckout(
              stripeResponse.client_secret,
              actualTotal,
              uuid,
              orderreference
            );
          } else {
            // Redirect to Stripe hosted checkout
            setTimeout(() => {
              window.location.href = stripeResponse.target_url;
            }, 3000);
          }
        } else {
          console.error("Stripe session creation failed:", stripeResponse);
          Swal.fire({
            title: "Payment Error",
            text: "Unable to initialize payment. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
          this.loading_proceed = false;
        }
      } catch (error) {
        console.error("Stripe session error:", error);
        Swal.fire({
          title: "Payment Error",
          text: "Unable to initialize payment. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
        this.loading_proceed = false;
      }
    },

    setupStripeEmbeddedCheckout(clientSecret, total, uuid, orderreference) {
      console.log(
        "Setting up Stripe embedded checkout with clientSecret:",
        clientSecret
      );

      if (!window.stripe) {
        console.error("Stripe.js not loaded");
        this.loading_proceed = false;
        return;
      }

      const payment_brand_id = normalizeBrandId(this.setbrandid);
      window.stripe
        .initEmbeddedCheckout({
          clientSecret: clientSecret,
        })
        .then((checkout) => {
          checkout.mount("#stripe-embedded-checkout");

          // Store payment details
          let chdata =
            process.env.VUE_APP_CHL_USD +
            payment_brand_id.toLowerCase() +
            orderreference +
            uuid +
            total;
          let hash = crypto.createHash("sha512");
          let transaction_token = hash.update(chdata, "utf-8").digest("hex");

          this.final_amount = total;
          this.transaction_token = transaction_token;
          this.stripe_sessionid = clientSecret;
          this.final_orderreference = orderreference;
          this.final_uuid = uuid;
          encryptStorage.setItem("final_uuid", this.final_uuid);
          encryptStorage.setItem(
            "final_orderreference",
            this.final_orderreference
          );

          this.loading_proceed = false;
          this.registeristrue = false;
          this.loginistrue = false;
          this.payform = true;
          window.scrollTo(0, 0);
          this.banner_headline =
            "Please complete the secure payment form below to complete your reservation";
        })
        .catch((error) => {
          console.error("Stripe embedded checkout error:", error);
          this.loading_proceed = false;
        });
    },

    async showpaymentwindcave(orderreference) {
      let total = encryptStorage.getItem("final_amount_paid");
      let uuid = this.getLocalData("uuid");
      //let toto = parseFloat(total).toFixed(2);
      //console.log("Windcave payment - total:", toto);
      console.log("Windcave payment - orderreference:", orderreference);
      console.log("Windcave payment - uuid:", uuid);

      // Check for zero value order
      if (parseFloat(total) === 0) {
        this.zerovalueorder(orderreference);
        return;
      }

      let chdata =
        process.env.VUE_APP_CHL_USD +
        this.setbrandid.toLowerCase() +
        orderreference +
        uuid +
        total;
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");
      console.log("Windcave payment - transaction_token:", transaction_token);

      this.final_amount = total;
      this.transaction_token = transaction_token;
      this.final_orderreference = orderreference;
      this.final_uuid = uuid;
      encryptStorage.setItem("final_uuid", this.final_uuid);
      encryptStorage.setItem("final_orderreference", this.final_orderreference);

      try {
        // Call Windcave Session API to initialize payment
        const windcaveData = {
          amount: (parseFloat(total) * 100).toFixed(0), // Convert to cents
          brand_id: this.setbrandid.toLowerCase(),
          product_id: "CPK",
          currency: "USD",
          signature: transaction_token,
          ref: orderreference,
          user_guid: uuid,
          store_card: this.store_card ? "yes" : "no",
          first_name: this.firstname,
          last_name: this.surname,
          success_url:
            this.brandConfig?.windcave?.successUrl ||
            "https://laxstaging.rezcomm.com/confirmation.html",
          failure_url:
            this.brandConfig?.windcave?.failureUrl ||
            "https://laxstaging.rezcomm.com/failure.html",
        };

        console.log("Calling Windcave Session API with data:", windcaveData);
        const windcaveResponse = await apiProxy.call(
          "windcave_session",
          windcaveData
        );
        console.log("Windcave Session API response:", windcaveResponse);

        if (windcaveResponse && windcaveResponse.target_url) {
          // Setup inline Windcave payment with iframe
          this.setupWindcaveInlinePayment(
            windcaveResponse.target_url,
            total,
            uuid,
            orderreference
          );
        } else {
          console.error("Windcave session creation failed:", windcaveResponse);
          Swal.fire({
            title: "Payment Error",
            text: "Unable to initialize payment. Please try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
          this.loading_proceed = false;
          return;
        }
      } catch (error) {
        console.error("Windcave session error:", error);
        Swal.fire({
          title: "Payment Error",
          text: "Unable to initialize payment. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
        this.loading_proceed = false;
        return;
      }
    },

    setupWindcaveInlinePayment(target_url, total, uuid, orderreference) {
      console.log(
        "Setting up Windcave inline payment with target_url:",
        target_url
      );
      console.log("Setting up Windcave inline payment with total:", total);
      console.log("Setting up Windcave inline payment with uuid:", uuid);
      console.log(
        "Setting up Windcave inline payment with orderreference:",
        orderreference
      );

      this.loading_proceed = false;
      this.registeristrue = false;
      this.loginistrue = false;
      this.payform = true;
      window.scrollTo(0, 0);
      this.banner_headline =
        "Please complete the secure payment form below to complete your reservation";

      // Setup message listener for Windcave events
      window.addEventListener("message", (msg) => {
        console.warn("WINDCAVE EVENT", msg);
        let eventData;
        if (typeof msg.data === "string") {
          eventData = JSON.parse(msg.data);
        } else {
          eventData = msg.data;
        }
        if (eventData.type) {
          switch (eventData.type) {
            case "REDIRECT":
              window.location.href = eventData.content;
              break;
          }
        }
      });

      // Create and embed Windcave iframe
      document.getElementById(
        "windcave-embedded"
      ).innerHTML = `<iframe id="windcave-inline" width="500" height="750" allow="payment 'src' https://*.windcave.com" style="width: 100%; height: 950px; border:none" src="${target_url}"></iframe>`;

      // Setup iframe load event
      document
        .getElementById("windcave-inline")
        .addEventListener("load", () => {
          if (window.top.windcaveIframe) {
            setInterval(window.top.windcaveIframe, 200);
          }
        });
    },

    showpayment_windcave(sessionId, amount, orderreference) {
      console.log("Initializing Windcave form with sessionId:", sessionId);

      this.loading_proceed = false;
      this.registeristrue = false;
      this.loginistrue = false;
      this.payform = true;
      window.scrollTo(0, 0);
      this.banner_headline =
        "Please complete the secure payment form below to complete your reservation";

      // Clear any existing content
      const windcaveContainer = document.getElementById("windcave-embedded");
      if (windcaveContainer) {
        windcaveContainer.innerHTML = "";

        // Create Windcave payment form container
        const paymentForm = document.createElement("div");
        paymentForm.innerHTML = `
          <h3 style="margin-bottom: 1rem; color: #0a3b74;">Secure Payment</h3>
          <div style="margin-bottom: 1rem; padding: 1rem; background: #f8f9fa; border-radius: 4px;">
            <p style="margin: 0; font-weight: bold;">Amount: $${parseFloat(
              amount
            ).toFixed(2)}</p>
            <p style="margin: 0.5rem 0 0 0; font-size: 0.9rem; color: #666;">Order Reference: ${orderreference}</p>
          </div>
          <div id="windcave-payment-form" style="min-height: 400px;">
            <div style="text-align: center; padding: 2rem;">
              <div style="display: inline-block; width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #0a3b74; border-radius: 50%; animation: spin 1s linear infinite;"></div>
              <p style="margin-top: 1rem;">Loading secure payment form...</p>
            </div>
          </div>
        `;
        windcaveContainer.appendChild(paymentForm);

        // Initialize Windcave iframe
        this.loadWindcaveIframe(sessionId);
      }
    },

    loadWindcaveIframe(sessionId) {
      console.log("Loading Windcave iframe for sessionId:", sessionId);

      const paymentFormContainer = document.getElementById(
        "windcave-payment-form"
      );
      if (paymentFormContainer) {
        // Create iframe for Windcave payment form
        const iframe = document.createElement("iframe");
        iframe.src = `https://sec.windcave.com/pxaccess/shtml/card.shtml?SessionId=${sessionId}`;
        iframe.width = "100%";
        iframe.height = "500";
        iframe.frameBorder = "0";
        iframe.style.border = "none";
        iframe.style.borderRadius = "4px";
        iframe.id = "windcave-iframe";

        // Clear loading content and add iframe
        paymentFormContainer.innerHTML = "";
        paymentFormContainer.appendChild(iframe);

        // Set up event listener for payment completion
        window.addEventListener("message", this.handleWindcaveMessage, false);

        // Set up iframe load event
        iframe.onload = () => {
          console.log("Windcave iframe loaded successfully");
        };

        iframe.onerror = () => {
          console.error("Failed to load Windcave iframe");
          paymentFormContainer.innerHTML = `
            <div style="text-align: center; padding: 2rem; color: #dc3545;">
              <p>Failed to load payment form. Please try again.</p>
              <button onclick="window.location.reload()" style="padding: 0.5rem 1rem; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">
                Retry
              </button>
            </div>
          `;
        };
      }
    },

    handleWindcaveMessage(event) {
      // Handle messages from Windcave iframe
      if (event.origin !== "https://sec.windcave.com") {
        return;
      }

      console.log("Windcave message received:", event.data);

      if (event.data && event.data.type === "payment_complete") {
        // Payment completed, redirect to success page
        window.location.href = "/payment-success.html";
      } else if (event.data && event.data.type === "payment_failed") {
        // Payment failed, show error
        Swal.fire({
          title: "Payment Failed",
          text: "Your payment could not be processed. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    async processJCCPayment({ total, uuid, orderreference }) {
      console.info(total);
      console.info(uuid);
      this.loading_proceed = true;
      let ven_sel = "";
      if (typeof encryptStorage.getItem("cart") !== "undefined") {
        ven_sel = this.getLocalData("venue_selected");
      }
      if (typeof encryptStorage.getItem("fasttrack_cartitem") !== "undefined") {
        ven_sel = this.getLocalData("venue_selected_ftt");
      }
      if (typeof encryptStorage.getItem("lounge_cartitem") !== "undefined") {
        ven_sel = this.getLocalData("venue_selected_lng");
      }
      let chdata =
        process.env.VUE_APP_JCC_KEY +
        parseFloat(encryptStorage.getItem("final_amount_paid")).toFixed(2) +
        orderreference +
        this.email +
        this.getLocalData("uuid") +
        this.setbrandid +
        this.lang +
        ven_sel;
      console.log("chdata", chdata);
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      let cpk_cart = "N";
      if (this.cpkincart) {
        cpk_cart = "Y";
      } else {
        cpk_cart = "N";
      }
      let pspdata = {
        amount: parseFloat(encryptStorage.getItem("final_amount_paid")).toFixed(
          2
        ),
        orderreference: orderreference,
        email: this.email,
        uuid: this.getLocalData("uuid"),
        brand_id: this.setbrandid,
        lang: this.lang,
        venue_id: ven_sel,
        cpk_cart: cpk_cart,
        transaction_token: transaction_token,
      };

      apiProxy.call("payment_jcc_initiate", pspdata).then(
        (response) => {
          this.emailid_loading = false;
          let formUrl = response.formUrl;
          setTimeout(function () {
            if (formUrl != "") {
              encryptStorage.setItem("session_pay", "1");
              window.location.href = formUrl;
            }
          }, 500);
        },
        (error) => {
          this.loading_proceed = false;
          console.log(error);
        }
      );
    },

    async processNABPayment() {
      console.log("Processing NAB payment for:", this.setbrandid);
      this.loading_proceed = true;

      let total = encryptStorage.getItem("final_amount_paid");
      let uuid = this.getLocalData("uuid");
      let orderreference = encryptStorage.getItem("orefwithoutprefix");

      let chdata =
        process.env.VUE_APP_CHL_YHM +
        this.setbrandid.toLowerCase() +
        orderreference +
        (total * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      let pspdata = {
        amount: (total * 100).toFixed(),
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        currency: "AUD",
        signature: transaction_token,
        ref: orderreference,
        user_guid: uuid,
        user_email: this.emailid,
        first_name: this.firstname,
        last_name: this.surname,
        user_address1: this.address,
        user_town: this.town,
        user_country: "AU",
        success_url:
          this.brandConfig?.nab?.successUrl ||
          "https://drwstaging.rezcomm.com/confirmation.html",
        failure_url:
          this.brandConfig?.nab?.failureUrl ||
          "https://drwstaging.rezcomm.com/failure.html",
      };

      try {
        const response = await apiProxy.call("nab_payment_session", pspdata);
        let codesent = response;

        if (!codesent.context) {
          this.loading_proceed = false;
          return;
        }

        const addScript = async (src) =>
          new Promise((resolve, reject) => {
            const el = document.createElement("script");
            el.src = src;
            el.addEventListener("load", resolve);
            el.addEventListener("error", reject);
            document.body.appendChild(el);
          });

        await addScript(codesent.target_url);

        //let toto = encryptStorage.getItem("final_amount_paid");
        //toto = parseFloat(toto).toFixed(2);

        let chdata2 =
          process.env.VUE_APP_CHL_USD +
          this.setbrandid.toLowerCase() +
          orderreference +
          uuid +
          total;
        let hash2 = crypto.createHash("sha512");
        let transaction_token2 = hash2.update(chdata2, "utf-8").digest("hex");

        this.final_amount = total;
        this.transaction_token = transaction_token2;
        this.final_orderreference = orderreference;
        this.final_uuid = uuid;
        encryptStorage.setItem("final_uuid", this.final_uuid);
        encryptStorage.setItem(
          "final_orderreference",
          this.final_orderreference
        );

        this.loading_proceed = false;
        this.registeristrue = false;
        this.loginistrue = false;
        this.payform = true;
        window.scrollTo(0, 0);
        this.banner_headline =
          "Please complete the secure payment form below to complete your reservation";

        setTimeout(async () => {
          try {
            const accept = await window.Accept(codesent.context);
            const up = await accept.unifiedPayments(false);
            const tt = await up.show({
              containers: {
                paymentSelection: "#nab-checkout",
                paymentScreen: "#nab-payment",
              },
            });
            console.warn("NAB Payment Token:", tt);

            const processResponse = await apiProxy.call("nab_payment_process", {
              token: tt,
              brand_id: this.setbrandid.toLowerCase(),
              product_id: "CPK",
              user_email: this.emailid,
              first_name: this.firstname,
              last_name: this.surname,
              user_address1: this.address,
              user_town: this.town,
              user_country: "AU",
              uuid: codesent.next_uuid,
            });

            console.warn("NAB Payment Complete:", processResponse);
            if (processResponse.redirect_to) {
              window.location.href = processResponse.redirect_to;
            }
          } catch (e) {
            console.error("NAB Payment Error:", e);
            this.loading_proceed = false;
          }
        }, 100);
      } catch (error) {
        console.error("NAB Payment Session Error:", error);
        this.loading_proceed = false;
      }
    },

    async showpayment_authipay(total, uuid, orderreference) {
      this.loading_proceed = true;

      let chdata =
        process.env.VUE_APP_CHL_YHM +
        this.setbrandid.toLowerCase() +
        orderreference +
        (total * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", total);

      let pspdata = {
        amount: (total * 100).toFixed(),
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        currency: "GBP",
        signature: transaction_token,
        ref: orderreference,
        user_guid: uuid,
        first_name: this.firstname,
        last_name: this.surname,
        success_url:
          this.brandConfig?.authipay?.successUrl ||
          "https://ldystaging.rezcomm.com/confirmation.html",
        failure_url:
          this.brandConfig?.authipay?.failureUrl ||
          "https://ldystaging.rezcomm.com/failure.html",
      };

      try {
        const response = await apiProxy.call("authipay_session", pspdata);
        let codesent = response;
        let target_url = codesent.target_url;

        setTimeout(function () {
          window.location.href = target_url;
        }, 3000);
      } catch (error) {
        this.loading_proceed = false;
        console.error("Authipay payment error:", error);
      }
    },

    async showpayment_advam(total, uuid, orderreference) {
      this.loading_proceed = true;

      let chdata =
        process.env.VUE_APP_CHL_YHM +
        this.setbrandid.toLowerCase() +
        orderreference +
        (total * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", total);

      let pspdata = {
        amount: (total * 100).toFixed(),
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        currency: "GBP",
        signature: transaction_token,
        ref: orderreference,
        user_guid: uuid,
        first_name: this.firstname,
        last_name: this.surname,
        success_url:
          this.brandConfig?.advam?.successUrl ||
          "https://bfsstaging.rezcomm.com/confirmation.html",
        failure_url:
          this.brandConfig?.advam?.failureUrl ||
          "https://bfsstaging.rezcomm.com/failure.html",
      };

      try {
        const response = await apiProxy.call("advam_session", pspdata);
        let codesent = response;
        let target_url = codesent.target_url;

        setTimeout(function () {
          window.location.href = target_url;
        }, 3000);
      } catch (error) {
        this.loading_proceed = false;
        console.error("Advam payment error:", error);
      }
    },

    async showpayment_payone(total, uuid, orderreference) {
      this.loading_proceed = true;

      let chdata =
        process.env.VUE_APP_CHL_YHM +
        this.setbrandid.toLowerCase() +
        orderreference +
        (total * 100).toFixed();
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      encryptStorage.setItem("final_amount_paid", total);

      let pspdata = {
        amount: (total * 100).toFixed(),
        brand_id: this.setbrandid.toLowerCase(),
        product_id: "CPK",
        currency: "EUR",
        country: "DE",
        signature: transaction_token,
        ref: orderreference,
        user_guid: uuid,
        firstname: this.firstname,
        lastname: this.surname,
        success_url:
          this.brandConfig?.payone?.successUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/confirmation.html`,
        failure_url:
          this.brandConfig?.payone?.failureUrl ||
          `https://${this.setbrandid.toLowerCase()}staging.rezcomm.com/failure.html`,
      };

      try {
        const response = await apiProxy.call("payone_session", pspdata);
        let target_url =
          response.target_url + "&lang=" + this.lang.toLowerCase();
        setTimeout(() => {
          window.location.href = target_url;
        }, 3000);
      } catch (error) {
        this.loading_proceed = false;
        console.error("Payone payment error:", error);
      }
    },

    nmipayment_gpay_apay(total, uuid, orderreference) {
      console.log("nmipayment_gpay_apay", total);
      console.log("nmipayment_gpay_apay", orderreference);

      // Configure CollectJS for JER brand
      window.CollectJS.configure({
        paymentSelector: "#demoPayButton",
        fields: {
          ccnumber: {
            selector: "#demoCcnumber",
            title: "Card Number",
            placeholder: "0000 0000 0000 0000",
          },
          ccexp: {
            selector: "#demoCcexp",
            title: "Card Expiration",
            placeholder: "00 / 00",
          },
          cvv: {
            display: "show",
            selector: "#demoCvv",
            title: "CVV Code",
            placeholder: "***",
          },
          googlePay: {
            selector: ".googlePayButton",
          },
          applePay: {
            selector: ".applePayButton",
          },
        },
        price: total.toString(),
        currency: "USD",
        country: "US",
        variant: "inline",
        callback: function (response) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "payment_token";
          input.value = response.token;
          var form = document.getElementsByTagName("form")[0];
          form.appendChild(input);
          form.submit();
        },
      });

      this.showpayment_jer(total, uuid, orderreference);
    },

    showpayment_jer(total, uuid, orderreference) {
      Swal.fire(
        "Info!",
        "Please wait, redirecting to payment gateway to complete your payment",
        "info"
      );

      let chdata =
        process.env.VUE_APP_CHL_USD +
        this.setbrandid.toLowerCase() +
        orderreference +
        uuid +
        total;
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      this.final_amount = total;
      this.transaction_token = transaction_token;
      this.final_orderreference = orderreference;
      this.final_uuid = uuid;
      encryptStorage.setItem("final_uuid", this.final_uuid);
      encryptStorage.setItem("final_orderreference", this.final_orderreference);
      this.loading_proceed = false;
      this.registeristrue = false;
      this.loginistrue = false;
      this.payform = true;
      window.scrollTo(0, 0);
      this.banner_headline =
        "Please complete the secure payment form below to complete your reservation";

      // Create JER NMI form with CollectJS integration
      let jerNmiForm = `
        <form id="jerNmiForm" method="post" action="https://devhub.rezcomm.com/hubapmydbauth/jerdevnmi/stagingprocess.php">
          <table class="w-100">
            <tr>
              <td>CC Number</td>
              <td id="demoCcnumber"></td>
            </tr>
            <tr>
              <td>CC Exp</td>
              <td id="demoCcexp"></td>
            </tr>
            <tr>
              <td>CVV</td>
              <td id="demoCvv"></td>
            </tr>
          </table>
          <input type="hidden" name="amount" value="${total}" />
          <input type="hidden" name="first_name" value="${this.firstname}" />
          <input type="hidden" name="last_name" value="${this.surname}" />
          <input type="hidden" name="address" value="${this.address}" />
          <input type="hidden" name="city" value="${this.town}" />
          <input type="hidden" name="state" value="${this.state}" />
          <input type="hidden" name="zip" value="${this.postcode}" />
          <input type="hidden" name="orderreference" value="${this.final_orderreference}" />
          <input type="hidden" name="transaction_token" value="${this.transaction_token}" />
          <input type="hidden" name="uuid" value="${this.final_uuid}" />
          <input type="hidden" name="brand_id" value="${this.setbrandid}" />
          <div class="googlePayButton"></div>
          <div class="applePayButton"></div>
          <button id="demoPayButton" type="button" class="page-content__form-btn mt-3">
            <i class="fas fa-circle-notch fa-spin"></i>
            Complete Payment
          </button>
        </form>
      `;

      // Insert form into PSP container
      document.getElementById("psp-form").innerHTML = jerNmiForm;

      // Initialize CollectJS after form is inserted
      setTimeout(() => {
        if (window.CollectJS) {
          window.CollectJS.configure();
        }
      }, 1000);
    },

    // UK-specific features
    async findyouraddress() {
      if (!this.postcode || this.postcode.length < 5) {
        Swal.fire({
          title: "Error",
          text: this.getrans("Please enter a valid postcode"),
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      try {
        const response = await apiProxy.call("postcode_lookup_uk", {
          postcode: this.postcode.toUpperCase().replace(/\s/g, ""),
        });

        if (response && response.addresses && response.addresses.length > 0) {
          // Show address selection modal or populate first address
          const firstAddress = response.addresses[0];
          this.address = firstAddress.line_1 || "";
          this.address_line_2 = firstAddress.line_2 || "";
          this.town = firstAddress.town || "";
          console.log("Address populated from postcode lookup");
        } else {
          Swal.fire({
            title: "Error",
            text: this.getrans("No addresses found for this postcode"),
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error("Postcode lookup error:", error);
        Swal.fire({
          title: "Error",
          text: this.getrans(
            "Postcode lookup failed. Please enter address manually."
          ),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    },

    async findyourvrn() {
      if (!this.vehicle_vrn || this.vehicle_vrn.length < 3) {
        Swal.fire({
          title: "Error",
          text: this.getrans("Please enter a valid vehicle registration"),
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      try {

        this.loading_vrn = true;
        const response = await apiProxy.call("vrn_lookup_uk", {
          vrn: this.vehicle_vrn.toUpperCase().replace(/\s/g, ""),
        });

        if (response && response.data && response.data[0]) {
          const vehicle = response.data[0];
          console.log("Vehicle details found:", {
            make: vehicle.make,
            model: vehicle.model,
            color: vehicle.primaryColour,
          });
          console.log(vehicle);
          // Could populate additional vehicle fields if they exist in the form

          this.vrn_make = vehicle.make || "";
          this.vrn_model = vehicle.model || "";
          this.vrn_color = vehicle.primaryColour || "";
          this.showvrnfields = true;
          this.loading_vrn = false;
        } else {
          console.log("No vehicle details found for VRN:", this.vehicle_vrn);
          this.loading_vrn = false;
        }
      } catch (error) {
        console.error("VRN lookup error:", error);
        this.loading_vrn = false;
        // Don't show error to user as VRN lookup is optional
      }
    },

    // Credit balance functionality for Australian brands
    async checkCreditBalance() {
      if (!this.brandConfig?.features?.creditBalance) {
        return;
      }

      try {
        const response = await apiProxy.call("credit_balance_api", {
          brand_id: normalizeBrandId(this.brandConfig.brandCode),
          email_id: this.email,
        });

        if (response && response.credit_balance > 0) {
          console.log("Credit balance available:", response.credit_balance);
          // Could show credit balance application option
        }
      } catch (error) {
        console.error("Credit balance check error:", error);
      }
    },

    // Google Address Finder (LAX brand)
    setPlace(event) {
      console.log("setPlace", event);
      let address1 = "";
      let postcode = "";
      let town = "";
      let state = "";
      let country = "";
      let country_name = "";

      for (const component of event.address_components) {
        console.log("component", component);
        const componentType = component.types[0];

        switch (componentType) {
          case "street_number": {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case "route": {
            address1 += component.short_name;
            break;
          }
          case "postal_code": {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case "postal_code_suffix": {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case "locality":
            town = component.long_name;
            break;
          case "postal_town": {
            if (!town) {
              town = component.long_name;
            }
            break;
          }
          case "administrative_area_level_1": {
            state = component.long_name;
            break;
          }
          case "administrative_area_level_2": {
            if (!town) {
              town = component.long_name;
            }
            break;
          }
          case "country": {
            country_name = component.long_name;
            country = component.short_name;
            break;
          }
        }
      }

      this.address = address1;
      this.address_line_2 = "";
      this.town = town;
      this.state = state;
      this.country = country;
      this.country_name = country_name;
      this.postcode = postcode;
      this.showaddressfields = true;
    },

    // Remember device functionality
    async handleRememberDevice(uuid) {
      try {
        const RememberDevice = (await import("@/modules/RememberDevice"))
          .default;
        await RememberDevice.rememberDevice(
          uuid,
          this.loginemail || this.email
        );
      } catch (error) {
        console.error("Remember device error:", error);
      }
    },

    loadFunction() {
      this.cartitem = encryptStorage.getItem("cart") || {};
      this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart") || {};
      this.lounge_cartitem = encryptStorage.getItem("lounge_cart") || {};
      this.coach_cartitem = encryptStorage.getItem("coach_cart") || {};

      console.log("Cart items loaded:", {
        cartitem: this.cartitem,
        fasttrack_cartitem: this.fasttrack_cartitem,
        lounge_cartitem: this.lounge_cartitem,
        coach_cartitem: this.coach_cartitem,
      });
    },
    initializeFasttrackPassengers() {
      console.log("DEBUG: initializeFasttrackPassengers called");
      console.log("DEBUG: fasttrack_cartitem:", this.fasttrack_cartitem);

      // Clear existing passengers first
      this.fasttrack_passengers_ADL = [];
      this.fasttrack_passengers_CHD = [];
      this.fasttrack_passengers_INF = [];

      if (
        this.fasttrack_cartitem &&
        Array.isArray(this.fasttrack_cartitem) &&
        this.fasttrack_cartitem.length > 0
      ) {
        let object = this.fasttrack_cartitem[0];
        console.log("DEBUG: Processing fasttrack object:", object);

        // Initialize ADL passengers
        if (object.ADL) {
          for (let i = 1; i <= object.ADL; i++) {
            this.fasttrack_passengers_ADL.push({
              title: this.getrans(""),
              firstname: "",
              surname: "",
            });
          }
        }

        // Initialize CHD passengers
        if (object.CHD) {
          for (let i = 1; i <= object.CHD; i++) {
            this.fasttrack_passengers_CHD.push({
              title: this.getrans(""),
              firstname: "Child " + i,
              surname: "Child " + i,
            });
          }
        }

        // Initialize INF passengers
        if (object.INF) {
          for (let i = 1; i <= object.INF; i++) {
            this.fasttrack_passengers_INF.push({
              title: this.getrans(""),
              firstname: "Infant " + i,
              surname: "Infant " + i,
            });
          }
        }

        console.log("DEBUG: Initialized passengers:", {
          ADL: this.fasttrack_passengers_ADL.length,
          CHD: this.fasttrack_passengers_CHD.length,
          INF: this.fasttrack_passengers_INF.length,
        });
      } else {
        console.log("DEBUG: No fasttrack_cartitem found or not an array");
      }
    },

    debugBasketData() {
      console.log("=== BASKET DEBUG DATA ===");
      console.log("Translations passed to BasketItem:", {
        type: typeof this.translations,
        isObject: typeof this.translations === "object",
        isNull: this.translations === null,
        isUndefined: this.translations === undefined,
        keys: this.translations
          ? Object.keys(this.translations).slice(0, 10)
          : "No keys",
        sampleValue: this.translations
          ? this.translations[Object.keys(this.translations)[0]]
          : "No sample",
        fullObject: this.translations,
      });
      console.log("Brand data:", {
        brandSlug: this.brandConfig?.brandCode || this.setbrandid,
        lang: this.lang.toUpperCase(),
      });
      console.log("========================");
    },

    setSessionData(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {
        console.error("Session storage error:", error);
      }
    },

    getSessionData(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        console.error("Session storage error:", error);
        return null;
      }
    },

    genHash(str) {
      var hash = 0,
        i,
        chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
      }
      return hash;
    },

    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },

    resetpromocode() {
      let order_ref = encryptStorage.getItem("order_ref");
      if (typeof order_ref === "undefined") {
        order_ref = encryptStorage.getItem("order_ref_remove");
      }
      let discount_coupon_applied = encryptStorage.getItem(
        "discount_coupon_applied"
      );
      if (typeof discount_coupon_applied !== "undefined") {
        let cartdata = {
          brand_id: this.setbrandid,
          booking_ref_id: order_ref,
          uuid: this.genuuid(),
          promo_code: discount_coupon_applied,
        };
        apiProxy.call("promo_code_cancel", cartdata).then((response) => {
          console.log(response);
          this.clearCartData();
          setTimeout(() => {
            window.location.href = "/index.html";
          }, 6000);
        });
      } else {
        this.clearCartData();
        setTimeout(() => {
          window.location.href = "/index.html";
        }, 6000);
      }
    },

    clearCartData() {
      sessionStorage.removeItem("cart");
      sessionStorage.removeItem("fasttrack_cart");
      sessionStorage.removeItem("lounge_cart");
      sessionStorage.removeItem("orefwithoutprefix");
      encryptStorage.removeItem("cart");
      encryptStorage.removeItem("fasttrack_cart");
      encryptStorage.removeItem("lounge_cart");
      encryptStorage.removeItem("orefwithoutprefix");
      encryptStorage.removeItem("order_ref");
      encryptStorage.removeItem("dis_cpk");
      encryptStorage.removeItem("dis_ftt");
      encryptStorage.removeItem("discount_amount");
      encryptStorage.removeItem("discount_amount_applied");
      encryptStorage.removeItem("discount_coupon_applied");
      encryptStorage.removeItem("final_amount_paid");
    },

    checkHomeRedirect() {
      if (
        !encryptStorage.getItem("fasttrack_cart") &&
        !encryptStorage.getItem("lounge_cart") &&
        !encryptStorage.getItem("coach_cart") &&
        !encryptStorage.getItem("cart")
      ) {
        window.location.href = "/index.html";
      }
    },

    checkHomeRedirectCartTimeout() {
      var noww = new Date().getTime();
      var snddc = encryptStorage.getItem("snddc");
      if (!snddc) {
        encryptStorage.setItem("snddc", noww);
        window.location.href = "/index.html";
      } else {
        if (noww - snddc > 60 * 60 * 1000) {
          window.location.href = "/index.html";
        }
      }
    },

    genuuid() {
      if (sessionStorage.getItem("uuid") === null) {
        const { v4: uuidv4 } = require("uuid");
        let uuidgen = uuidv4();
        this.setLocalData("uuid", uuidgen);
        return uuidgen;
      } else {
        return sessionStorage.getItem("uuid");
      }
    },

    getLocalData(name) {
      if (name == "uuid") {
        return sessionStorage.getItem("uuid").replaceAll('"', "");
      } else {
        return JSON.parse(sessionStorage.getItem(name));
      }
    },

    // Form prefilling only - authentication handled by Header.vue
    prefillFormFromUserData() {
      console.log("[YourDetails] Direct prefill from session_userdata disabled");
    },

    isSb4PrefillBlocked() {
      const rawCandidates = [
        this.$cookie?.getCookie?.("brandSlug"),
        this.setbrandid,
        this.brandConfig?.brandCode
      ]
        .map((value) => (value || "").toString().toUpperCase())
        .filter(Boolean);

      // SB4 may normalize to SB2 for API calls, so we check raw/original slug sources.
      return rawCandidates.includes("SB4");
    },
  },

  async mounted() {
    // Initialize branding and event listeners first
    this.getbranded();



    // BH2: If partner isn't set, force to Jet2
    if (
      this.setbrandid === "BH2" ||
      this.$cookie.getCookie("search_origin") ===
        "jet2bhxlive.rezcomm.com" ||
      this.$cookie.getCookie("search_origin") ===
        "jet2.prebook.birminghamairport.co.uk" ||
      this.$cookie.getCookie("search_origin") === "localhost:7126"
    ) {
      this.$cookie.setCookie("partner_id", 49);
      this.$cookie.setCookie("partner_name", "Jet2 Referral");
    }

    window.addEventListener("userLoggedIn", this.handleUserLogin);
    window.addEventListener("userDataAvailable", this.handleUserDataAvailable);
    window.addEventListener("userLoggedOut", this.handleUserLoggedOut);

    console.log("[DEBUG] YourDetails mounted - checking session state");
    console.log(
      "[DEBUG] Current session_userdata exists:",
      !!encryptStorage.getItem("session_userdata")
    );

    // Check for session restore on page load
    // await this.checkSessionRestore();

    console.log("🔍 DEBUG: YourDetails mounted - starting initialization");
    console.log("🔍 DEBUG: Initial state - brandConfig:", this.brandConfig);
    console.log("🔍 DEBUG: Initial state - styles_loaded:", this.styles_loaded);
    console.log("🔍 DEBUG: Initial state - header_menu:", this.header_menu);

    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }

    console.log("🔍 DEBUG: YourDetails calling getbranded()");
    await this.getbranded();
    console.log("[YourDetails DEBUG] brand set:", this.setbrandid);
    console.log("[YourDetails DEBUG] session_userdata on mount:", encryptStorage.getItem("session_userdata"));
    await this.check_for_session();
    await this.getPaymentSessionToken();
    this.loadFunction();
    this.initializeFasttrackPassengers();

    // Initialize error arrays for fasttrack passengers
    this.fasttrack_passengers_ADL_errors = this.fasttrack_passengers_ADL.map(
      () => ({
        title: false,
        firstname: false,
        surname: false,
      })
    );
    this.fasttrack_passengers_CHD_errors = this.fasttrack_passengers_CHD.map(
      () => ({
        title: false,
        firstname: false,
        surname: false,
      })
    );
    this.fasttrack_passengers_INF_errors = this.fasttrack_passengers_INF.map(
      () => ({
        title: false,
        firstname: false,
        surname: false,
      })
    );
    this.cartloaded = true;
    this.tryBeginCheckoutEvent();

    // Handle UTM parameters
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = [
      "utm_campaign",
      "utm_content",
      "utm_medium",
      "utm_partner",
      "utm_source",
      "utm_sub_partner",
      "utm_term",
    ];

    utmParams.forEach((param) => {
      if (urlParams.has(param)) {
        const value = urlParams.get(param);
        if (!this.$cookie.isCookieAvailable(param)) {
          this.$cookie.setCookie(param, value);
        } else {
          if (this.$cookie.getCookie(param) === null) {
            this.$cookie.setCookie(param, value);
          }
        }
      }
    });

    // Call UTM data tracking after brandConfig is loaded
    if (this.brandConfig?.brandCode) {
      this.utmdata(normalizeBrandId(this.brandConfig.brandCode)
      );
      this.marketingConfig = brandMarketing[this.brandConfig?.brandCode] || {};

      if (this.marketingConfig?.marketing?.preSelectDisagree) {
        this.email_consent = 0;
        this.email_consent_selected = true;
        this.email_consent_selected_error = false;
      }
    }

    // Debug basket data after everything is loaded
    this.debugBasketData();

    console.log("🔍 DEBUG: Final state check:");
    console.log("🔍 DEBUG: - brandConfig:", this.brandConfig);
    console.log("🔍 DEBUG: - styles_loaded:", this.styles_loaded);
    console.log("🔍 DEBUG: - header_menu:", this.header_menu);
    console.log("🔍 DEBUG: - header_menu.length:", this.header_menu.length);
    console.log("🔍 DEBUG: - show_basket:", this.show_basket);
    console.log(
      "YourDetails unified component loaded for brand:",
      this.brandConfig?.brandCode
    );

    if (brandTitles[this.brandConfig?.brandCode]) {
      this.titles_list = brandTitles[this.brandConfig?.brandCode];
    } else {
      this.titles_list = brandTitles["DEFAULT"];
    }

    // Prefill now comes only from server-validated session checks.
  },

  updated() {
    this.checkHomeRedirect();
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";
@import "@/assets/sass/demoPay.scss";

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
<style scoped lang="scss">
@import "@/assets/sass/variables.scss";
@import "@/assets/sass/FormStyles_new.scss";
</style>
